// PLIK GENEROWANY - nie edytuj ręcznie (patrz scripts/strzelnice/README.md).
// Źródło: OpenStreetMap (© współtwórcy OpenStreetMap, licencja ODbL)
// uzupełnione danymi ze stron internetowych samych strzelnic.
// Wygenerowano dla stanu bazy z lipca 2026. Obiektów: 492.
//
// REGIONY/MIASTA/POWIATY/RANKING_PL trzymają wyłącznie indeksy do OBIEKTY,
// żeby ten sam obiekt nie był w pliku kilka razy.

export const STRZELNICE_STATS = {"total": 492, "listed": 256, "phones": 196, "sites": 176, "regions": 16};

export const KRYTERIA = {
 "tel": "podany numer telefonu",
 "www": "własna strona internetowa",
 "godz": "opublikowane godziny otwarcia",
 "adres": "pełny adres z ulicą",
 "mail": "kontakt e-mail",
 "kryta": "strzelnica kryta - czynna cały rok",
 "klub": "klub strzelecki (droga po patent i licencję)",
 "opis": "opis oferty od samego obiektu"
};

export const OBIEKTY = [
 {
  "id": "way/448772268",
  "n": "Strzelnica Myśliwska Biernacice",
  "a": "Biernacice",
  "c": "Biernacice",
  "p": "powiat ząbkowicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Biernacice.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1226241556",
  "n": "Strzelnica Sowiogórskiego Stowarzyszenia Strzeleckiego",
  "a": "Boguszów-Gorce",
  "c": "Boguszów-Gorce",
  "p": "powiat wałbrzyski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/profile.php?id=100088461829029",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica Sowiogórskiego Stowarzyszenia Strzeleckiego, z osiami na podłożu naturalnym.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/445115474",
  "n": "Strzelnica 200 m",
  "a": "Bolesławiec",
  "c": "Bolesławiec",
  "p": "powiat bolesławiecki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Bolesławiec.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/445115475",
  "n": "Strzelnica Pistoletowa",
  "a": "Bolesławiec",
  "c": "Bolesławiec",
  "p": "powiat bolesławiecki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Bolesławiec.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1191378112",
  "n": "Strzelnica Sportowa",
  "a": "Brzeg Głogowski",
  "c": "Brzeg Głogowski",
  "p": "powiat głogowski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Brzeg Głogowski.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1459838920",
  "n": "strzelnica",
  "a": "Brzeg Głogowski",
  "c": "Brzeg Głogowski",
  "p": "powiat głogowski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Brzeg Głogowski.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/387676677",
  "n": "Strzelnica Sportowa",
  "a": "Dobrzejów",
  "c": "Dobrzejów",
  "p": "powiat legnicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa - Dobrzejów.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11887030808",
  "n": "Strzelnica Domaniów",
  "a": "Domaniów",
  "c": "Domaniów",
  "p": "powiat oławski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 606 515 647",
  "t2": "",
  "w": "https://strzelnicadomaniow.pl/",
  "f": "",
  "e": "asc.domaniow@gmail.com",
  "h": "pon.-pt. 10-18; sob. 11-18; niedz. 12-16",
  "d": "Strzelnica pod Wrocławiem (ok. 30 min autostradą A4): strzelania rekreacyjne, szkolenia taktyczne i imprezy firmowe.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/901937829",
  "n": "Duszniki Arena - Trybuna",
  "a": "Olimpijska, 57-340 Duszniki-Zdrój",
  "c": "Duszniki-Zdrój",
  "p": "powiat kłodzki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Trybuna strzelnicy biathlonowej Duszniki Arena - obiekt sportowy, na co dzień wykorzystywany przez zawodników.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/632621806",
  "n": "Strzelnica",
  "a": "Dzikowiec",
  "c": "Dzikowiec",
  "p": "powiat kłodzki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dzikowiec.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/635294795",
  "n": "Strzelnica sportowa KS Bastion",
  "a": "68b, 59-930 Dłużyna Dolna",
  "c": "Dłużyna Dolna",
  "p": "powiat zgorzelecki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 660 460 525",
  "t2": "",
  "w": "http://www.strzelnica-zgorzelec.pl/",
  "f": "",
  "e": "info@ksbastion.pl",
  "h": "",
  "d": "Klubowa strzelnica KS Bastion pod Zgorzelcem; szkolenia firmowe, wyjazdy integracyjne i strzelania w grupach.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "adres",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/6866806031",
  "n": "Jaworski Klub Strzelecki UR",
  "a": "Jawor",
  "c": "Jawor",
  "p": "powiat jaworski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 695 926 527",
  "t2": "",
  "w": "https://www.jksur.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Klub strzelecki w Jaworze prowadzący treningi i przyjmujący nowych członków.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "klub"
  ]
 },
 {
  "id": "way/1348996117",
  "n": "Strzelnica JKS UR w Jaworze",
  "a": "Jawor",
  "c": "Jawor",
  "p": "powiat jaworski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "https://strzelnica.jksur.pl/",
  "f": "",
  "e": "strzelnica@jksur.pl",
  "h": "",
  "d": "Strzelnica Jaworskiego Klubu Strzeleckiego UR - treningi klubowe i strzelania po uzgodnieniu terminu.",
  "s": 4,
  "k": [
   "www",
   "mail"
  ]
 },
 {
  "id": "way/635278612",
  "n": "Strzelinca LOK Jeżów Sudecki",
  "a": "Jelenia Góra",
  "c": "Jelenia Góra",
  "p": "",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 696 862 340",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/Liga-Obrony-Kraju-Jelenia-G%C3%B3ra-938811016147678",
  "e": "",
  "h": "",
  "d": "Strzelnica Ligi Obrony Kraju w Jeżowie Sudeckim pod Jelenią Górą.",
  "s": 4,
  "k": [
   "tel",
   "klub"
  ]
 },
 {
  "id": "node/10061032688",
  "n": "Strzelnica Kwietno KS Amator (braterstwo.eu)",
  "a": "Kwietno",
  "c": "Kwietno",
  "p": "powiat średzki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "https://braterstwo.eu/",
  "f": "",
  "e": "pawel@braterstwo.eu",
  "h": "",
  "d": "Strzelnica sieci Braterstwo (KS Amator) - klub pomagający przejść drogę po pozwolenie na broń i patent.",
  "s": 5,
  "k": [
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/12657593783",
  "n": "Strzelnica SSK Trzy Twierdze Twierdza Kłodzko",
  "a": "Kłodzko",
  "c": "Kłodzko",
  "p": "powiat kłodzki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa, prowadzona przez: Stowarzyszenie Strzelecko-Kolekcjonerskie Trzy Twierdze.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/1390731238",
  "n": "Strzelnica Krzelków",
  "a": "Lipa",
  "c": "Lipa",
  "p": "powiat ząbkowicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Lipa.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/9879343474",
  "n": "Strzelnica",
  "a": "Lubin",
  "c": "Lubin",
  "p": "powiat lubiński",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Lubin.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1421118133",
  "n": "Dębowy Wąwóz",
  "a": "Lwówek Śląski",
  "c": "Lwówek Śląski",
  "p": "powiat lwówecki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 604 239 132",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarty obiekt strzelecki Dębowy Wąwóz w okolicy Lwówka Śląskiego.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "node/11161575190",
  "n": "Strzelnica Milicz",
  "a": "Milicz",
  "c": "Milicz",
  "p": "powiat milicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 695 398 545",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "pon.-wt. nieczynne; śr. 09-16; czw.-niedz. nieczynne",
  "d": "Strzelnica w Miliczu udostępniana w wyznaczone dni tygodnia - przed wizytą potwierdź termin.",
  "s": 5,
  "k": [
   "tel",
   "godz"
  ]
 },
 {
  "id": "node/10599358542",
  "n": "Strzelnica Karpacz",
  "a": "Miłków",
  "c": "Miłków",
  "p": "powiat karkonoski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 508 984 346",
  "t2": "",
  "w": "https://strzelnica-karpacz.pl/",
  "f": "",
  "e": "biuro@strzelnica-karpacz.pl",
  "h": "pon. nieczynne; wt.-niedz. 12-18",
  "d": "Strzelnica turystyczna w Karpaczu i okolicy - strzelania rekreacyjne dla dorosłych, młodzieży i dzieci.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/328970952",
  "n": "Strzelnica miejska",
  "a": "Wesółka 4d, 56-416 Twardogóra",
  "c": "Moszyce",
  "p": "powiat oleśnicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica miejska w Moszycach - obiekt otwarty, wykorzystywany przez kluby i grupy zorganizowane.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/1191453342",
  "n": "Strzelica w Oławie",
  "a": "Rybacka 36, 55-200 Oława",
  "c": "Oława",
  "p": "powiat oławski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "czw. 14:30-16:30",
  "d": "Strzelnica w Oławie dostępna dla klientów obiektu w wyznaczonych godzinach treningowych.",
  "s": 4,
  "k": [
   "godz",
   "adres"
  ]
 },
 {
  "id": "node/1842464622",
  "n": "Strzelnica LOK",
  "a": "Oława",
  "c": "Oława",
  "p": "powiat oławski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "pon., śr. 15-17; czw., pt. 18-20",
  "d": "Strzelnica klubowa w miejscowości Oława.",
  "s": 3,
  "k": [
   "godz",
   "klub"
  ]
 },
 {
  "id": "node/11470940058",
  "n": "Strzelnica Berdysz",
  "a": "Ożary",
  "c": "Ożary",
  "p": "powiat ząbkowicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Ożary.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/279163970",
  "n": "Strzelnica myśliwska",
  "a": "Pietrzyków",
  "c": "Pietrzyków",
  "p": "powiat świdnicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska - Pietrzyków.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1501333770",
  "n": "Strzelnica Izerska",
  "a": "Rębiszów",
  "c": "Rębiszów",
  "p": "powiat lwówecki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Rębiszów.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11148789063",
  "n": "Strzelnica Antrans",
  "a": "Serby",
  "c": "Serby",
  "p": "powiat głogowski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 535 009 729",
  "t2": "",
  "w": "",
  "f": "",
  "e": "strzelnica.antrans@gmail.com",
  "h": "pon.-czw. nieczynne; pt.-SU 10-18",
  "d": "Strzelnica Antrans w Serbach pod Głogowem, czynna od piątku do niedzieli.",
  "s": 6,
  "k": [
   "tel",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1533564229",
  "n": "Strzelnica Siechnice",
  "a": "Tadeusza Kościuszki 25, 55-011 Siechnice",
  "c": "Siechnice",
  "p": "powiat wrocławski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 797 222 244",
  "t2": "",
  "w": "https://strzelnicasiechnice.eu/",
  "f": "",
  "e": "biuro@strzelnicasiechnice.eu",
  "h": "",
  "d": "Strzelnica klubu sportowo-kolekcjonerskiego w Siechnicach: strzelania bez pozwolenia i pomoc w zdobyciu własnego.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/9701601737",
  "n": "Strzelnica Historyczna",
  "a": "Srebrna Góra",
  "c": "Srebrna Góra",
  "p": "powiat ząbkowicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "https://strzelnicahistoryczna.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica przy Twierdzy Srebrna Góra - strzelania z ostrej amunicji z instruktorem, także dla początkujących.",
  "s": 4,
  "k": [
   "www",
   "klub"
  ]
 },
 {
  "id": "node/7906047451",
  "n": "Sudeckie Stowarzyszenie Strzeleckie",
  "a": "Stare Bogaczowice",
  "c": "Stare Bogaczowice",
  "p": "powiat wałbrzyski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 602 773 639",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Sudeckie Stowarzyszenie Strzeleckie - klub prowadzący treningi i zawody w Starych Bogaczowicach.",
  "s": 4,
  "k": [
   "tel",
   "klub"
  ]
 },
 {
  "id": "node/11110504225",
  "n": "Strzelnica Glauberyt",
  "a": "Trzebnice",
  "c": "Trzebnice",
  "p": "powiat polkowicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 533 017 989",
  "t2": "",
  "w": "https://ksglauberyt.pl/",
  "f": "",
  "e": "kontakt@ksglauberyt.pl",
  "h": "",
  "d": "Klub Glauberyt: strzelectwo sportowe i bojowe, zajęcia dla początkujących oraz zrzeszanie kolekcjonerów broni.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/217623176",
  "n": "Strzelnica sportowa w Wołowie",
  "a": "Wołów",
  "c": "Wołów",
  "p": "powiat wołowski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa - Wołów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1204746222",
  "n": "Bractwo Kurkowe \"Husarz\"",
  "a": "Wrocław",
  "c": "Wrocław",
  "p": "",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Wrocław.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/9623598667",
  "n": "Strzelnica COLT",
  "a": "Kwidzyńska 4, 51-416 Wrocław",
  "c": "Wrocław",
  "p": "",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 667 727 024",
  "t2": "",
  "w": "https://strzelnicacolt.pl/",
  "f": "",
  "e": "coltwroc@gmail.com",
  "h": "pon. nieczynne; wt.-pt. 15-22; sob.-niedz. 10-15",
  "d": "Kryta strzelnica komercyjna we Wrocławiu; vouchery, szkolenia na patent strzelecki i licencję PZSS.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/7856464615",
  "n": "War Zone",
  "a": "Sztabowa 32, 53-321 Wrocław",
  "c": "Wrocław",
  "p": "",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 731 027 577",
  "t2": "",
  "w": "https://www.war-zone.com.pl/",
  "f": "",
  "e": "biuro@war-zone.com.pl",
  "h": "pon. nieczynne; wt.-pt. 16-20; sob.-niedz. 12-18",
  "d": "Strzelnica War Zone przy ul. Sztabowej we Wrocławiu - osie do wynajęcia i pakiety dla początkujących.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/10131234416",
  "n": "Strzelnica Łowęcice",
  "a": "Łowęcice",
  "c": "Łowęcice",
  "p": "powiat średzki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 514 482 170",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/strzelnicaStrefaCelu",
  "e": "strefacelu@interia.pl",
  "h": "pon. 08-20; wt.-pt. 08-18; sob.-niedz. 09-18",
  "d": "Strzelnica Łowęcice czynna przez cały tydzień, także w weekendy.",
  "s": 6,
  "k": [
   "tel",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/10052101815",
  "n": "Strzelnica",
  "a": "Łączna 4, 58-100 Świdnica",
  "c": "Świdnica",
  "p": "powiat świdnicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 509 378 444",
  "t2": "",
  "w": "https://strzelam.pl/",
  "f": "",
  "e": "strzelnicaswidnica@gmail.com",
  "h": "",
  "d": "Strzelnica Klubu Sportów Obronnych w Świdnicy, działająca razem ze sklepem z bronią.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "adres",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/6184117248",
  "n": "Strzelnica KSOS",
  "a": "Świdnica",
  "c": "Świdnica",
  "p": "powiat świdnicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Świdnica.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/9989481205",
  "n": "Strzelnica Piechcin",
  "a": "Aleksandrowo",
  "c": "Aleksandrowo",
  "p": "powiat żniński",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Aleksandrowo.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1315391977",
  "n": "ACS II",
  "a": "Bydgoszcz",
  "c": "Bydgoszcz",
  "p": "",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, prowadzona przez: Politechnika Bydgoska.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/123524257",
  "n": "Strzelnica myśliwska",
  "a": "Cierpice",
  "c": "Cierpice",
  "p": "powiat toruński",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Cierpice.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1273952495",
  "n": "Strzelnica LOK",
  "a": "Lipnowska 11, 87-400 Golub-Dobrzyń",
  "c": "Golub-Dobrzyń",
  "p": "powiat golubsko-dobrzyński",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "https://strzelnicagolub.pl/",
  "f": "",
  "e": "lokstrazak@wp.pl",
  "h": "",
  "d": "Strzelnica Ligi Obrony Kraju w Golubiu-Dobrzyniu - treningi klubowe i strzelania grupowe.",
  "s": 7,
  "k": [
   "www",
   "adres",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/1292018542",
  "n": "Strzelnica Kowalewko - Mundurowy Klub Strzelecki - Jednostka Ratownictwa Specialnego w Kowalewku",
  "a": "Kowalewko",
  "c": "Kowalewko",
  "p": "powiat nakielski",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Kowalewko.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/1275176554",
  "n": "Strzelnica Nakielskiego Bractwa Kurkowego",
  "a": "Paterek",
  "c": "Paterek",
  "p": "powiat nakielski",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Paterek.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1111002134",
  "n": "Strzelnica, Kurkowego Bractwa Strzeleckiego w Solcu Kujawskim",
  "a": "Przyłubie",
  "c": "Przyłubie",
  "p": "powiat bydgoski",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Przyłubie.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/4293428738",
  "n": "Ośrodek Szkoleń Strzeleckich RYBIENIEC",
  "a": "Rybieniec",
  "c": "Rybieniec",
  "p": "powiat chełmiński",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "+48 607 304 469",
  "t2": "",
  "w": "http://www.strzelnicarybieniec.pl/",
  "f": "",
  "e": "",
  "h": "pon.-wt. nieczynne; śr. 15-19; czw.-pt. nieczynne; sob.-niedz. 09-15",
  "d": "Komercyjna strzelnica w Rybieńcu z szerokim wyborem broni palnej; czynna w środy i w weekendy.",
  "s": 8,
  "k": [
   "tel",
   "www",
   "godz"
  ]
 },
 {
  "id": "node/11976604960",
  "n": "Dynamic Arena",
  "a": "Smolniki",
  "c": "Smolniki",
  "p": "powiat nakielski",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "+48 691 666 060",
  "t2": "",
  "w": "https://dynamicarena.pl/",
  "f": "",
  "e": "dnmcabiuro@gmail.com",
  "h": "pon.-sob. 10-20; niedz. nieczynne",
  "d": "Strzelnica dla strzelców z okolic Bydgoszczy, Torunia i Inowrocławia; rezerwacja stanowiska online.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/11174572555",
  "n": "Shotgun team akwanuta",
  "a": "Toruń",
  "c": "Toruń",
  "p": "",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Toruń.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/9376382836",
  "n": "Strzelnica Gunstorm",
  "a": "Marii Skłodowskiej-Curie 85B, 87-100 Toruń",
  "c": "Toruń",
  "p": "",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "+48 513 601 615",
  "t2": "",
  "w": "https://gunstorm.pl/",
  "f": "",
  "e": "strzelnica@gunstorm.pl",
  "h": "",
  "d": "Strzelnica Gunstorm w Toruniu - strzelania komercyjne i treningi.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/415082056",
  "n": "Centrum Szkolenia Strzeleckiego Lasów Państwowych im. Jana Wendy w Plaskoszu k/Tucholi",
  "a": "Tuchola",
  "c": "Tuchola",
  "p": "powiat tucholski",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Tuchola.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/4476364411",
  "n": "Olender Shooting Center",
  "a": "Toruńska 34/40, 87-165 Wielka Nieszawka",
  "c": "Wielka Nieszawka",
  "p": "powiat toruński",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "+48 566 220 606",
  "t2": "",
  "w": "https://www.strzelnica-torun.pl/",
  "f": "",
  "e": "osc.strzelnica@o2.pl",
  "h": "",
  "d": "Strzelnica sportowo-bojowa przy centrum Olender pod Toruniem; rezerwacja telefoniczna lub mailowa.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/807764133",
  "n": "Strzelnica myśliwska PZŁ Włocławek - Ostrowy",
  "a": "Włocławek",
  "c": "Włocławek",
  "p": "",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Włocławek.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1263075962",
  "n": "Lipnowski Klub Strzelecki \"Vis\"",
  "a": "Lipno",
  "c": "Złotopole",
  "p": "powiat lipnowski",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Złotopole.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/10756152594",
  "n": "Strzelnica Godawy",
  "a": "Łysinin",
  "c": "Łysinin",
  "p": "powiat żniński",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Łysinin.",
  "s": 0,
  "k": []
 },
 {
  "id": "relation/17671068",
  "n": "Strzelnica Fort IV Borowa",
  "a": "Borowa",
  "c": "Borowa",
  "p": "powiat puławski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Borowa.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1348467136",
  "n": "w dyszkę",
  "a": "Brzeziny",
  "c": "Brzeziny",
  "p": "powiat rycki",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Brzeziny.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1425598289",
  "n": "Strzelnica Myśliwska PZŁ w Hrudzie",
  "a": "Cicibór Mały",
  "c": "Cicibór Mały",
  "p": "powiat bialski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "https://bialapodlaska.pzlow.pl/dla-mysliwych/strzelnica/",
  "f": "",
  "e": "zo.bialapodlaska@pzlow.pl",
  "h": "",
  "d": "Strzelnica myśliwska Polskiego Związku Łowieckiego w Hrudzie - przystrzeliwanie broni i treningi myśliwych.",
  "s": 4,
  "k": [
   "www",
   "mail"
  ]
 },
 {
  "id": "way/361210864",
  "n": "Strzelnica sportowa Reduta",
  "a": "Dęblin",
  "c": "Dęblin",
  "p": "powiat rycki",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "https://nshm.deblin.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Nadwiślańskiego Stowarzyszenia Historii Militarnej w Dęblinie; zawody PZSS i wydarzenia historyczne.",
  "s": 4,
  "k": [
   "www",
   "klub"
  ]
 },
 {
  "id": "way/583047013",
  "n": "Strzelnica Hubale Mokre",
  "a": "Hubale",
  "c": "Hubale",
  "p": "powiat zamojski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 606 929 174",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/strzelnicahubale.mokre/",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica Hubale Mokre z osiami na podłożu naturalnym.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "way/1293063732",
  "n": "Strzelnica Janowiec",
  "a": "Janowiec",
  "c": "Janowiec",
  "p": "powiat puławski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 508 225 135",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "pon.-pt. nieczynne; sob.-niedz. 10-22",
  "d": "Strzelnica w Janowcu czynna w weekendy - strzelania rekreacyjne i grupowe.",
  "s": 5,
  "k": [
   "tel",
   "godz"
  ]
 },
 {
  "id": "way/625828344",
  "n": "KS \"Snajper\" Lublin",
  "a": "Gospodarcza 27, 20-211 Lublin",
  "c": "Lublin",
  "p": "",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "https://www.snajper.lublin.pl/",
  "f": "",
  "e": "snajper@snajper.lublin.pl",
  "h": "pon.-pt. 14-20",
  "d": "Klub strzelecki Snajper w Lublinie - treningi w dni powszednie po południu.",
  "s": 9,
  "k": [
   "www",
   "godz",
   "adres",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/11348719929",
  "n": "Strzelnica SCHRON Lublin",
  "a": "Mariana Smoluchowskiego 1, 20-474 Lublin",
  "c": "Lublin",
  "p": "",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Klubu Strzeleckiego SCHRON w Lublinie: pakiety zależne od broni i liczby strzałów.",
  "s": 3,
  "k": [
   "adres",
   "klub"
  ]
 },
 {
  "id": "way/1415713229",
  "n": "KS KALIBER",
  "a": "Małaszewicze Małe",
  "c": "Małaszewicze Małe",
  "p": "powiat bialski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Małaszewicze Małe.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/290256211",
  "n": "Strzelnica Sportowo- Myśliwska w Zarajcu",
  "a": "Michałówka",
  "c": "Michałówka",
  "p": "powiat janowski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Michałówka.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1348470171",
  "n": "Lewart",
  "a": "Olempin",
  "c": "Olempin",
  "p": "powiat puławski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Olempin.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1246265062",
  "n": "Strzelnica Pneumatyczna w Ostrowie Lubelskim",
  "a": "Unicka 5, 21-110 Ostrów Lubelski",
  "c": "Ostrów Lubelski",
  "p": "powiat lubartowski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "wt. 15-18",
  "d": "5 stanowisk, sala szkoleniowa, toaleta, broń długa i krótka.",
  "s": 5,
  "k": [
   "godz",
   "adres",
   "opis"
  ]
 },
 {
  "id": "way/307288958",
  "n": "Strzelnica szkolna",
  "a": "Ostrów Lubelski",
  "c": "Ostrów Lubelski",
  "p": "powiat lubartowski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Ostrów Lubelski.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/857256380",
  "n": "Strzelnica Osówka",
  "a": "Osówka",
  "c": "Osówka",
  "p": "powiat lubelski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "https://gtsjastrzab.pl/",
  "f": "",
  "e": "gtsjastrzab@gmail.com",
  "h": "pon.-pt. 10-18",
  "d": "Strzelnica Gminnego Towarzystwa Strzeleckiego JASTRZĄB w Osówce, czynna w dni powszednie.",
  "s": 7,
  "k": [
   "www",
   "godz",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/943498206",
  "n": "Strzelnica Zimny Dół",
  "a": "Parchatka",
  "c": "Parchatka",
  "p": "powiat puławski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/zimnydolstrzelnica/",
  "e": "",
  "h": "",
  "d": "Strzelnica Zimny Dół w Parchatce - otwarte osie strzeleckie w dolinie.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1348679029",
  "n": "strzelnica Borek",
  "a": "Piaski",
  "c": "Piaski",
  "p": "powiat świdnicki",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Piaski.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/87580509",
  "n": "Strzelnica PZŁ",
  "a": "Puławy",
  "c": "Puławy",
  "p": "powiat puławski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Puławy.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/175468482",
  "n": "Strzelnica",
  "a": "Rudka",
  "c": "Rudka",
  "p": "powiat chełmski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Rudka.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/459616515",
  "n": "SJS",
  "a": "Siedliska",
  "c": "Siedliska",
  "p": "powiat tomaszowski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Siedliska.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/362746575",
  "n": "Strzelnica",
  "a": "Sobieszyn",
  "c": "Sobieszyn",
  "p": "powiat rycki",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Sobieszyn.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1376173699",
  "n": "strzelnica Jonnik",
  "a": "Stara Wróblina",
  "c": "Stara Wróblina",
  "p": "powiat łukowski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Stara Wróblina.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13722498960",
  "n": "Wren",
  "a": "Uniszowice 31A, Uniszowice",
  "c": "Uniszowice",
  "p": "powiat lubelski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 601 297 528",
  "t2": "",
  "w": "https://wren.pl",
  "f": "",
  "e": "info@wren.pl",
  "h": "pon.-pt. 10-17; sob. 09-14",
  "d": "Sklep z bronią i rusznikarnia WReN ze strzelnicą - amunicja, akcesoria myśliwskie i strzeleckie.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/1435501272",
  "n": "Strzelnica Arizona",
  "a": "Wilkołaz Drugi",
  "c": "Wilkołaz Drugi",
  "p": "powiat kraśnicki",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 797 767 088",
  "t2": "",
  "w": "https://strzelnicawilkolaz.pl/",
  "f": "",
  "e": "strzelnicaarizona@proton.me",
  "h": "",
  "d": "Strzelnica Arizona w Wilkołazie - strzelania komercyjne i szkolenia strzeleckie.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/1278271068",
  "n": "Strzelnica Guardian",
  "a": "Woskrzenice Duże",
  "c": "Woskrzenice Duże",
  "p": "powiat bialski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 696 900 320",
  "t2": "+48 793 204 706",
  "w": "https://guardian.mil.pl/kontakt/",
  "f": "",
  "e": "guardian@guardian.mil.pl",
  "h": "",
  "d": "Strzelnica Guardian pod Białą Podlaską: strzelania komercyjne i szkolenia, cennik na stronie obiektu.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/790875911",
  "n": "Strzelnica STEN",
  "a": "Wąwolnica",
  "c": "Wąwolnica",
  "p": "powiat puławski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 786 444 221",
  "t2": "+48 609 676 558",
  "w": "https://www.wsssten.pl",
  "f": "",
  "e": "sten.wawolnica@wp.pl",
  "h": "pon.-niedz. 09-17",
  "d": "Strzelnica Wąwolnickiego Stowarzyszenia Strzeleckiego STEN",
  "s": 10,
  "k": [
   "tel",
   "www",
   "godz",
   "mail",
   "opis"
  ]
 },
 {
  "id": "way/145628136",
  "n": "Strzelnica",
  "a": "Zamość",
  "c": "Zamość",
  "p": "",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Zamość.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/5252292777",
  "n": "Strzelnica Pneumatyczna",
  "a": "Zamość",
  "c": "Zamość",
  "p": "",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "pon.-niedz. 12-20",
  "d": "Strzelnica w miejscowości Zamość.",
  "s": 2,
  "k": [
   "godz"
  ]
 },
 {
  "id": "way/1504148352",
  "n": "Strzelnica Grodzisko Zawalów",
  "a": "Zawalów",
  "c": "Zawalów",
  "p": "powiat zamojski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Zawalów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/642621794",
  "n": "Strzelnica Łaziska",
  "a": "Łaziska",
  "c": "Łaziska",
  "p": "powiat opolski",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Łaziska.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/372653860",
  "n": "Molon Labe",
  "a": "Aleja Lotników Polskich 9, 21-040 Świdnik",
  "c": "Świdnik",
  "p": "powiat świdnicki",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 501 508 567",
  "t2": "",
  "w": "https://molonlabe.pl/",
  "f": "",
  "e": "info@molonlabe.pl",
  "h": "wt.-niedz. 12-20",
  "d": "Molon Labe w Świdniku - strzelnica ze sklepem z bronią, kursami, zawodami i imprezami integracyjnymi.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/1097727411",
  "n": "STRZELNICA",
  "a": "Dobiegniew",
  "c": "Dobiegniew",
  "p": "powiat strzelecko-drezdenecki",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dobiegniew.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/9975718681",
  "n": "Strzelnica kryta KSK Pretor",
  "a": "Lubiszyn",
  "c": "Lubiszyn",
  "p": "powiat gorzowski",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "+48 791 390 444",
  "t2": "",
  "w": "",
  "f": "https://pl-pl.facebook.com/kskpretor",
  "e": "info@kskpretor.pl",
  "h": "pon.-niedz. 12-20",
  "d": "Kryta strzelnica klubu KSK Pretor w Lubiszynie, czynna codziennie w godzinach popołudniowych.",
  "s": 7,
  "k": [
   "tel",
   "godz",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/566479905",
  "n": "Strzelnica Sportowa Snajper Lubrza",
  "a": "Lubrza",
  "c": "Lubrza",
  "p": "powiat świebodziński",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "+48 664 418 467",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/people/Strzelnica-Sportowa-Snajper/100057644521936/",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa klubu Snajper w Lubrzy - treningi i zawody klubowe.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "way/633064413",
  "n": "Centrum Strzeleckie Nietoperek",
  "a": "Nietoperek",
  "c": "Nietoperek",
  "p": "powiat międzyrzecki",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "+48 604 454 477",
  "t2": "",
  "w": "https://www.strzelnicanietoperek.pl/",
  "f": "",
  "e": "biuro@strzelnicanietoperek.pl",
  "h": "",
  "d": "Centrum Strzeleckie Nietoperek - obiekt strzelecki w rejonie Międzyrzeckiego Rejonu Umocnionego.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/653619185",
  "n": "Strzelnica GTS BRASS Racław",
  "a": "Racław",
  "c": "Racław",
  "p": "powiat gorzowski",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "",
  "t2": "",
  "w": "http://brassgts.webd.pl/NEW/",
  "f": "",
  "e": "info@brass.org.pl",
  "h": "",
  "d": "Strzelnica Gorzowskiego Towarzystwa Strzeleckiego B.R.A.S.S. w Racławiu - treningi i zawody sportowe.",
  "s": 5,
  "k": [
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/1151073449",
  "n": "LOK",
  "a": "Szprotawa",
  "c": "Szprotawa",
  "p": "powiat żagański",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Szprotawa.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/4431022496",
  "n": "Strzelnica GunSpot",
  "a": "Sportowa, 69-100 Słubice",
  "c": "Słubice",
  "p": "powiat słubicki",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "+48 607 880 968",
  "t2": "",
  "w": "https://www.gunspot.pl/",
  "f": "",
  "e": "kontakt@gunspot.pl",
  "h": "pon.-pt. 09-19",
  "d": "Strzelnica GunSpot w Słubicach: strzelania z broni krótkiej i długiej, szkolenia i eventy firmowe.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/12403414895",
  "n": "Strzelnica Wiechlice",
  "a": "Wiechlice",
  "c": "Wiechlice",
  "p": "powiat żagański",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "+48 501 414 141",
  "t2": "",
  "w": "https://airbase-range.com/",
  "f": "",
  "e": "",
  "h": "pon.-sob. 09-18; niedz. 09-16",
  "d": "Oś strzału 1200m",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "opis"
  ]
 },
 {
  "id": "way/425533814",
  "n": "Strzelnica PZŁ w Zielonej Górze",
  "a": "Zielona Góra",
  "c": "Zielona Góra",
  "p": "",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Zielona Góra.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/743101494",
  "n": "Strzelnica Zielona Góra",
  "a": "Zielona Góra",
  "c": "Zielona Góra",
  "p": "",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, wstęp płatny.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/12644094835",
  "n": "Strzelnica Miejska LOK Żary",
  "a": "Żary",
  "c": "Żary",
  "p": "powiat żarski",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Żary.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/13961745082",
  "n": "50m",
  "a": "Baraki Chotumskie",
  "c": "Baraki Chotumskie",
  "p": "powiat ciechanowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Baraki Chotumskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1531867444",
  "n": "MOP",
  "a": "Baraki Chotumskie",
  "c": "Baraki Chotumskie",
  "p": "powiat ciechanowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Baraki Chotumskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13961778341",
  "n": "dzik",
  "a": "Baraki Chotumskie",
  "c": "Baraki Chotumskie",
  "p": "powiat ciechanowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Baraki Chotumskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13961778340",
  "n": "rogacz",
  "a": "Baraki Chotumskie",
  "c": "Baraki Chotumskie",
  "p": "powiat ciechanowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Baraki Chotumskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1434448627",
  "n": "skeet",
  "a": "Baraki Chotumskie",
  "c": "Baraki Chotumskie",
  "p": "powiat ciechanowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Baraki Chotumskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/313264904",
  "n": "strzelnica myśliwska",
  "a": "Baraki Chotumskie",
  "c": "Baraki Chotumskie",
  "p": "powiat ciechanowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Baraki Chotumskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1434448277",
  "n": "trap",
  "a": "Baraki Chotumskie",
  "c": "Baraki Chotumskie",
  "p": "powiat ciechanowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Baraki Chotumskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13961745081",
  "n": "zając",
  "a": "Baraki Chotumskie",
  "c": "Baraki Chotumskie",
  "p": "powiat ciechanowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Baraki Chotumskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11227632828",
  "n": "Strzelnica TenClub",
  "a": "Błonie",
  "c": "Błonie",
  "p": "powiat warszawski zachodni",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 574 210 388",
  "t2": "",
  "w": "https://tenclub.pl/",
  "f": "",
  "e": "strzelnica@tenclub.pl",
  "h": "pon. nieczynne; wt.-pt. 13-20 ; sob.-niedz. 10-20",
  "d": "Strzelnica klubu TenClub pod Warszawą - strzelectwo sportowe i rekreacyjne dla początkujących.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1453549547",
  "n": "PPM Strzelectwo - oś długa",
  "a": "Polna, 08-200 Chłopków",
  "c": "Chłopków",
  "p": "powiat łosicki",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 668 883 030",
  "t2": "",
  "w": "https://ppmstrzelectwo.pl",
  "f": "",
  "e": "kontakt@ppmstrzelectwo.pl",
  "h": "sob.-niedz. 09-17",
  "d": "Oś długa strzelnicy PPM Strzelectwo w Chłopkowie, dostępna dla klientów obiektu w weekendy.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/1453546275",
  "n": "PPM Strzelectwo - oś krótka",
  "a": "Polna, 08-200 Chłopków",
  "c": "Chłopków",
  "p": "powiat łosicki",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 668 883 030",
  "t2": "",
  "w": "https://ppmstrzelectwo.pl",
  "f": "",
  "e": "kontakt@ppmstrzelectwo.pl",
  "h": "sob.-niedz. 09-17",
  "d": "Oś krótka strzelnicy PPM Strzelectwo w Chłopkowie - strzelania z broni krótkiej w weekendy.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/556580701",
  "n": "Kaliber",
  "a": "Stefana Starzyńskiego 43, 05-090 Dawidy Bankowe",
  "c": "Dawidy Bankowe",
  "p": "powiat pruszkowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 224 604 719",
  "t2": "",
  "w": "https://kaliber.pl/",
  "f": "",
  "e": "sklep@kaliber.pl",
  "h": "pon.-pt. 08-16",
  "d": "Sklep strzelecki Kaliber wraz ze strzelnicą w Dawidach Bankowych pod Warszawą (gm. Raszyn) - akcesoria, części do broni oraz strzelania, także z wynajmem całego obiektu.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/13243264919",
  "n": "22",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13243264918",
  "n": "23",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13243239892",
  "n": "24",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13243262134",
  "n": "25",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13175371460",
  "n": "26",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13175371459",
  "n": "27",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831959308",
  "n": "28",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831959309",
  "n": "29",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831959310",
  "n": "30",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831959311",
  "n": "31",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831959312",
  "n": "32",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831959313",
  "n": "33",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dębinki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/209573855",
  "n": "Strzelnica Bellona Marynino",
  "a": "Dębinki",
  "c": "Dębinki",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 530 900 777",
  "t2": "",
  "w": "https://strzelnica-marynino.pl/",
  "f": "",
  "e": "strzelnica.marynino@gmail.com",
  "h": "08-18",
  "d": "Strzelnica Bellona w Maryninie pod Płońskiem, czynna codziennie od rana do wieczora.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/13664559953",
  "n": "Stowarzyszenie strzeleckie Shooter",
  "a": "Dębsk",
  "c": "Dębsk",
  "p": "powiat mławski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Dębsk.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/11479277046",
  "n": "Strzelnica Wilcze Doły",
  "a": "Góry",
  "c": "Góry",
  "p": "powiat miński",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 697 439 375",
  "t2": "",
  "w": "https://wilczedoly.com.pl",
  "f": "",
  "e": "wilcze.doly@op.pl",
  "h": "pon.-pt. 09-20; sob.-niedz. 10-20",
  "d": "Ośrodek strzelecki Wilcze Doły pod Mińskiem Mazowieckim - nauka strzelania z instruktorem, czynne codziennie.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1447583052",
  "n": "P2W Shooting",
  "a": "Gąsawy Rządowe",
  "c": "Gąsawy Rządowe",
  "p": "powiat szydłowiecki",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "https://p2w-shooting.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica P2W Shooting w Gąsawach Rządowych - strzelania i szkolenia strzeleckie.",
  "s": 3,
  "k": [
   "www"
  ]
 },
 {
  "id": "way/1351889752",
  "n": "Strzelnica UFO Team",
  "a": "Jasionna",
  "c": "Jasionna",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Jasionna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10004627528",
  "n": "Strzelnica 9-tka",
  "a": "Józefów",
  "c": "Józefów",
  "p": "powiat otwocki",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 227 693 961",
  "t2": "",
  "w": "https://www.strzelnica9-tka.pl/",
  "f": "",
  "e": "strzelnica9ka@gmail.com",
  "h": "pon. nieczynne; wt.-pt. 12-19 ; sob. 10-20 ; niedz. 10-19",
  "d": "Strzelnica 9'tka pod Warszawą: szkolenia strzeleckie i imprezy, czynna od wtorku do niedzieli.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/286954736",
  "n": "Strzelnica",
  "a": "Kieszek",
  "c": "Kieszek",
  "p": "powiat radomski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Kieszek.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1144455741",
  "n": "Strzelnica FMJ",
  "a": "Dworkowa 30A, 05-230 Kobyłka",
  "c": "Kobyłka",
  "p": "powiat wołomiński",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 739 015 110",
  "t2": "",
  "w": "https://strzelnicafmj.pl/",
  "f": "",
  "e": "kontakt@strzelnicafmj.pl",
  "h": "pon. nieczynne; wt.-pt. 13-21; sob. 11-21; niedz. nieczynne",
  "d": "Nowoczesna strzelnica w Kobyłce pod Warszawą - z własną bronią lub z arsenału obiektu, pakiety dla początkujących.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/1417622988",
  "n": "Strzelnica S.H. Security Kochów",
  "a": "Kochów",
  "c": "Kochów",
  "p": "powiat garwoliński",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 512 805 910",
  "t2": "",
  "w": "",
  "f": "",
  "e": "strzelnica@shsecurity.pl",
  "h": "",
  "d": "Strzelnica S.H. Security w Kochowie - szkolenia i strzelania dla grup zorganizowanych.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "way/1536954780",
  "n": "strzelnica ProPatria",
  "a": "Kurowo",
  "c": "Kurowo",
  "p": "powiat przasnyski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "https://kursy-ochrona.pl",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica ProPatria przy placówce szkoleniowej Patriot P3 Academy - szkolenia ochrony i strzeleckie.",
  "s": 3,
  "k": [
   "www"
  ]
 },
 {
  "id": "way/1352359637",
  "n": "Fundacja Wsparcia Reduta - STRZELNICA",
  "a": "Laski",
  "c": "Laski",
  "p": "powiat radomski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 536 776 420",
  "t2": "",
  "w": "https://fundacjawsparciareduta.org/",
  "f": "",
  "e": "fundacjawsparciareduta@gmail.com",
  "h": "",
  "d": "Strzelnica Fundacji Wsparcia Reduta w Laskach koło Pionek: osie 25, 50 i 300 m, także dla grup zorganizowanych.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/1348513506",
  "n": "Strzelnica L.O. w Lipinach",
  "a": "Lipiny",
  "c": "Lipiny",
  "p": "powiat przysuski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, prowadzona przez: L.O. Kadetów R.P. w Lipinach.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1328459779",
  "n": "Strzelnica \"Pod Dębami\"",
  "a": "Luszyn",
  "c": "Luszyn",
  "p": "powiat gostyniński",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Luszyn.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/996146713",
  "n": "Strzelnica Przyczółek",
  "a": "Magnuszew",
  "c": "Magnuszew",
  "p": "powiat kozienicki",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 516 533 907",
  "t2": "",
  "w": "https://strzelnica300.pl",
  "f": "",
  "e": "strzelnica300@gmail.com",
  "h": "",
  "d": "Strzelnica Przyczółek w Magnuszewie - osiem torów 300-metrowych do treningów, zawodów i szkoleń.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/1384415589",
  "n": "Strzelnica",
  "a": "Makówka",
  "c": "Makówka",
  "p": "powiat grodziski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Makówka.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831959315",
  "n": "16",
  "a": "Marynino",
  "c": "Marynino",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Marynino.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831959314",
  "n": "17",
  "a": "Marynino",
  "c": "Marynino",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Marynino.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831951596",
  "n": "18",
  "a": "Marynino",
  "c": "Marynino",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Marynino.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831951595",
  "n": "19",
  "a": "Marynino",
  "c": "Marynino",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Marynino.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831951594",
  "n": "20",
  "a": "Marynino",
  "c": "Marynino",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Marynino.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13831951593",
  "n": "21",
  "a": "Marynino",
  "c": "Marynino",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Marynino.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/12517151313",
  "n": "Kryta Strzelnica Marynino 9",
  "a": "9, 05-140 Marynino",
  "c": "Marynino",
  "p": "powiat legionowski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 531 860 819",
  "t2": "",
  "w": "https://ksm9.pl/",
  "f": "",
  "e": "",
  "h": "pon.-pt. 12-20 ; sob. 10-20 ; niedz. 11-20",
  "d": "Kryta Strzelnica Marynino 9 - wynajem strzelnicy i kursy strzeleckie, czynna przez cały tydzień.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "godz",
   "adres"
  ]
 },
 {
  "id": "node/10147746753",
  "n": "Strzelnica Magnus",
  "a": "Milanówek",
  "c": "Milanówek",
  "p": "powiat grodziski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 606 320 648",
  "t2": "",
  "w": "https://strzelnica-magnus.pl/",
  "f": "",
  "e": "biuro@strzelnica-magnus.pl",
  "h": "pon.-pt. 14-22; sob.-niedz. 11-22",
  "d": "Strzelnica Magnus w Milanówku, czynna codziennie do późnych godzin wieczornych.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1312614813",
  "n": "1 (50m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312644693",
  "n": "10 (25m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312644694",
  "n": "11 (25m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1422284282",
  "n": "12 (100m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614814",
  "n": "2 (50m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614826",
  "n": "3 (40m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614827",
  "n": "4 (40m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614816",
  "n": "5 (15m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614817",
  "n": "6 (15m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614818",
  "n": "7 (15m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614819",
  "n": "8 (15m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614810",
  "n": "9 (15m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614815",
  "n": "? (15m)",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Dwór Mazowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1312614811",
  "n": "Zbrojownia Modlin",
  "a": "Nowy Dwór Mazowiecki",
  "c": "Nowy Dwór Mazowiecki",
  "p": "powiat nowodworski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 788 999 303",
  "t2": "",
  "w": "https://zbrojowniamodlin.pl/",
  "f": "",
  "e": "biuro@zbrojowniamodlin.pl",
  "h": "",
  "d": "Zbrojownia Modlin - strzelnica na terenie Twierdzy Modlin, wstęp płatny.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "node/10289421772",
  "n": "Strzelnica U27",
  "a": "Ołtarzew",
  "c": "Ołtarzew",
  "p": "powiat warszawski zachodni",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 888 491 333",
  "t2": "",
  "w": "https://www.u27.pl/",
  "f": "",
  "e": "rezerwacja@u27.pl",
  "h": "pon. nieczynne; wt.-pt. 14-22; sob.-niedz. 10-20",
  "d": "Nowoczesna strzelnica U27 pod Warszawą (Ołtarzew) - strzelania pod okiem instruktorów, czynna od wtorku do niedzieli.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1351883145",
  "n": "Fort Pacew",
  "a": "Pacew",
  "c": "Pacew",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 512 092 305",
  "t2": "",
  "w": "https://fortpacew.pl/",
  "f": "",
  "e": "biuro@fortpacew.pl",
  "h": "",
  "d": "Fort Pacew - ośrodek szkolenia wojskowego i strzeleckiego z własnymi osiami.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/1431999703",
  "n": "os 5",
  "a": "Pacew",
  "c": "Pacew",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Pacew.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1431999175",
  "n": "oś 1",
  "a": "Pacew",
  "c": "Pacew",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Pacew.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1429036294",
  "n": "oś 2",
  "a": "Pacew",
  "c": "Pacew",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Pacew.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1429037260",
  "n": "oś 3   100m",
  "a": "Pacew",
  "c": "Pacew",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Pacew.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1429036659",
  "n": "oś 4",
  "a": "Pacew",
  "c": "Pacew",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Pacew.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1436276592",
  "n": "sportowa 50m",
  "a": "Piastów",
  "c": "Piastów",
  "p": "powiat radomski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa - Piastów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1437080163",
  "n": "trap",
  "a": "Piastów",
  "c": "Piastów",
  "p": "powiat radomski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Piastów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1165232194",
  "n": "Strzelnica LINIA OGNIA",
  "a": "Górna, 26-803 Promna",
  "c": "Promna",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "biuro@liniaognia.pl",
  "h": "",
  "d": "Strzelnica LINIA OGNIA w Promnej - strzelania rekreacyjne i szkolenia; kontakt przez profil obiektu.",
  "s": 3,
  "k": [
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/806360247",
  "n": "Strzelnica Promna",
  "a": "Górna, 26-803 Promna",
  "c": "Promna",
  "p": "powiat białobrzeski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 691 366 474",
  "t2": "",
  "w": "",
  "f": "",
  "e": "ajwgun@gmail.com",
  "h": "",
  "d": "Strzelnica w Promnej prowadzona przez firmę AJW - otwarte osie strzeleckie.",
  "s": 6,
  "k": [
   "tel",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/221130768",
  "n": "Strzelnica LOK",
  "a": "Płock",
  "c": "Płock",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Płock.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/98037483",
  "n": "Strzelnica \"DRAGON\"",
  "a": "Sokołowska 180A, 08-110 Siedlce",
  "c": "Siedlce",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica DRAGON w Siedlcach - obiekt klubowy z treningami i zawodami.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/1377016055",
  "n": "KSK Grot Radom",
  "a": "Skaryszew",
  "c": "Skaryszew",
  "p": "powiat radomski",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 786 856 416",
  "t2": "",
  "w": "",
  "f": "",
  "e": "kskgrotrdm@gmail.com",
  "h": "",
  "d": "Strzelnica Klubu Strzelecko-Kolekcjonerskiego Grot Radom w Skaryszewie.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "way/1177542724",
  "n": "strzelnica PZŁ Suchodół",
  "a": "Suchodół",
  "c": "Suchodół",
  "p": "powiat piaseczyński",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Suchodół.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1301702306",
  "n": "Strzelnica LOK Szerominek",
  "a": "Szerominek",
  "c": "Szerominek",
  "p": "powiat płoński",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Szerominek.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/993677332",
  "n": "Strzelnica Klubu Strzeleckiego CEL w Ogrodzienicach.",
  "a": "Słomczyn",
  "c": "Słomczyn",
  "p": "powiat grójecki",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa, prowadzona przez: Klub Strzelecki CEL Grójec..",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/217197564",
  "n": "Strzelnica LOK",
  "a": "Nowy Zjazd, Warka",
  "c": "Warka",
  "p": "powiat grójecki",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Ligi Obrony Kraju w Warce - treningi klubowe i strzelania grupowe.",
  "s": 3,
  "k": [
   "adres",
   "klub"
  ]
 },
 {
  "id": "way/742161322",
  "n": "Agvo",
  "a": "Puławska 561, 02-844 Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 224 996 358",
  "t2": "",
  "w": "https://www.agvo.pl/",
  "f": "",
  "e": "biuro@agvo.pl",
  "h": "pon.-pt. 13-22; sob. 11-20; niedz. 10-18",
  "d": "Strzelnica Agvo w Warszawie - strzelania komercyjne, czynna od poniedziałku do niedzieli.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/11108268815",
  "n": "Bema 60",
  "a": "Józefa Bema 60, 01-225 Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 228 567 281",
  "t2": "",
  "w": "https://bema60.pl/",
  "f": "",
  "e": "kontakt@bema60.pl",
  "h": "",
  "d": "Strzelnica Bema 60 w Warszawie - obiekt komercyjny, wstęp płatny.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/9988163676",
  "n": "KS Amator",
  "a": "Jerzego Waldorffa 23, 01-494 Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "https://braterstwo.eu/",
  "f": "",
  "e": "pawel@braterstwo.eu",
  "h": "",
  "d": "Warszawski klub KS Amator z sieci Braterstwo - wsparcie w drodze po patent i pozwolenie na broń.",
  "s": 7,
  "k": [
   "www",
   "adres",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/1525607520",
  "n": "Neo Dzik",
  "a": "Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Warszawa.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13390873846",
  "n": "PM Shooter",
  "a": "Krakowiaków 80A, Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica PM Shooter w Warszawie - strzelania z instruktorem na torach krytych.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/220682273",
  "n": "Strzelnica AWF",
  "a": "Marymoncka 34, 01-813 Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 507 200 066",
  "t2": "",
  "w": "https://strzelnicaawf.pl/",
  "f": "",
  "e": "biuro@strzelnicaawf.pl",
  "h": "",
  "d": "Strzelnica AWF w Warszawie: szeroki arsenał broni krótkiej i długiej, strzelania indywidualne i imprezy.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/11267669011",
  "n": "Strzelnica Chrobry",
  "a": "Stefana Szolc-Rogozińskiego 1, Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubu Chrobry w Warszawie - treningi sportowe i strzelania klubowe.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "node/13069634249",
  "n": "Strzelnica FSO",
  "a": "Jagiellońska 88, 00-992 Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 604 240 195",
  "t2": "",
  "w": "https://strzelnicafso.pl/",
  "f": "",
  "e": "biuro@strzelnicafso.pl",
  "h": "pon.-niedz. 10-22",
  "d": "Strzelnica FSO na warszawskiej Pradze - 13 osi strzeleckich, zawody, strzelania dla dzieci i eventy.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/198683114",
  "n": "Strzelnica Legia",
  "a": "Łazienkowska 3, 00-449 Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 226 252 630",
  "t2": "",
  "w": "https://www.strzelectwo-legia.pl/",
  "f": "",
  "e": "kontakt@strzelectwo-legia.pl",
  "h": "",
  "d": "Kryta strzelnica sekcji strzeleckiej CWKS Legia Warszawa - strzelania indywidualne, grupowe i firmowe, szkolenia i zawody.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "node/11128805998",
  "n": "Strzelnica Warszawianka",
  "a": "Dominika Merliniego 4, 02-511 Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 507 200 055",
  "t2": "",
  "w": "https://strzelnicawarszawianka.pl/",
  "f": "",
  "e": "biuro@strzelnicawarszawianka.pl",
  "h": "pon.-pt. 12-21; sob.-niedz. 12-20; święta nieczynne",
  "d": "Kryta strzelnica Warszawianka (KS Cover) - arsenał broni krótkiej i długiej, imprezy i szkolenia; wstęp płatny.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "way/1083811004",
  "n": "Strzelnica ZKS",
  "a": "Marymoncka 42, 01-977 Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 228 344 108",
  "t2": "",
  "w": "https://zks.waw.pl",
  "f": "",
  "e": "biuro@zks.waw.pl",
  "h": "pon.-niedz. 09-19",
  "d": "Strzelnica Związkowego Klubu Strzeleckiego ZKS Warszawa: sekcje karabinu i pistoletu, OPEN, czarnoprochowa i PRS.",
  "s": 12,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/1453041663",
  "n": "biatlon",
  "a": "Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Warszawa.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1453042390",
  "n": "c.p.",
  "a": "Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Warszawa.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1446716843",
  "n": "dyn. E",
  "a": "Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Warszawa.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1446716842",
  "n": "dyn. F",
  "a": "Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Warszawa.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1498067374",
  "n": "oś. A",
  "a": "Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Warszawa.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13434119782",
  "n": "stara dyn. (strzelbowa)",
  "a": "Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Warszawa.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13910017738",
  "n": "stary \"Dzik\"",
  "a": "Warszawa",
  "c": "Warszawa",
  "p": "",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Warszawa.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11961480213",
  "n": "Strzelnica NTS Shooting",
  "a": "Ząbki",
  "c": "Ząbki",
  "p": "powiat wołomiński",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 605 884 023",
  "t2": "",
  "w": "https://mexshooting.pl/",
  "f": "",
  "e": "kontakt@mexshooting.pl",
  "h": "12-20",
  "d": "Strzelnica NTS Shooting w Ząbkach pod Warszawą, czynna codziennie po południu.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/6198328998",
  "n": "Strzelnica PZŁ BALE",
  "a": "Bale",
  "c": "Świerczyna",
  "p": "powiat siedlecki",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Świerczyna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13514952212",
  "n": "Strzelnica LOK Bielcza",
  "a": "Bielcza",
  "c": "Bielcza",
  "p": "powiat brzeski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Bielcza.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/1482880989",
  "n": "Małopolskie Centrum Strzelectwa",
  "a": "Bochnia",
  "c": "Bochnia",
  "p": "powiat bocheński",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Bochnia.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1084374422",
  "n": "Strzelnica Gunsarea",
  "a": "Brzezinka",
  "c": "Brzezinka",
  "p": "powiat wadowicki",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica w miejscowości Brzezinka.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1221981949",
  "n": "Dawna strzelnica LOK",
  "a": "Brzozówka",
  "c": "Brzozówka",
  "p": "powiat olkuski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica klubowa w miejscowości Brzozówka.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/819553156",
  "n": "Strzelnica K.S. \"Lokus\"",
  "a": "Bukowno",
  "c": "Bukowno",
  "p": "powiat olkuski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 885 368 252",
  "t2": "",
  "w": "http://lokus-olkusz.pl/",
  "f": "",
  "e": "lokus.olkusz@gmail.com",
  "h": "",
  "d": "Strzelnica Klubu Strzeleckiego LOK Lokus w Bukownie - treningi i zawody klubowe.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "node/11439802474",
  "n": "Strzelnica PH Arms",
  "a": "Dąbrówka Gorzycka",
  "c": "Dąbrówka Gorzycka",
  "p": "powiat dąbrowski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 509 736 809",
  "t2": "",
  "w": "https://www.pharms.pl/",
  "f": "",
  "e": "strzelnica@pharms.pl",
  "h": "pon.-śr. 09-21; czw. 10-21:45; pt. 09-21; sob. 09-18; niedz. 09-15",
  "d": "Strzelnica PH Arms w Dąbrówce Gorzyckiej, czynna siedem dni w tygodniu.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/14041831092",
  "n": "Strzelnica Jaworsko",
  "a": "Jaworsko",
  "c": "Jaworsko",
  "p": "powiat brzeski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Jaworsko.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/355742104",
  "n": "Strzelnica Biathlonowa",
  "a": "Kościelisko",
  "c": "Kościelisko",
  "p": "powiat tatrzański",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Kościelisko.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/116609071",
  "n": "Strzelnica Kraków",
  "a": "Fabryczna 17, Kraków",
  "c": "Kraków",
  "p": "",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 794 433 245",
  "t2": "",
  "w": "https://strzelnica.krakow.pl/",
  "f": "",
  "e": "biuro@strzelnica.krakow.pl",
  "h": "pon.,wt. 14-22; śr.,czw. 08-21; pt. 08-22; sob. 09-22",
  "d": "Kryta strzelnica komercyjna w Krakowie z rezerwacją online, klimatyzacją i dostępnością dla osób z niepełnosprawnościami.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/1207111904",
  "n": "Strzelnica Pasternik",
  "a": "Kraków",
  "c": "Kraków",
  "p": "",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 691 462 152",
  "t2": "",
  "w": "http://www.strzelnicapasternik.pl/",
  "f": "",
  "e": "biurotopgun@gmail.com",
  "h": "pon.-sob. 08-17, niedz. 08-15",
  "d": "Strzelnica Pasternik w Krakowie - strzelania sportowe i rekreacyjne, czynna codziennie.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1312667262",
  "n": "Strzelnica LOK Krempachy",
  "a": "Krempachy",
  "c": "Krempachy",
  "p": "powiat nowotarski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Krempachy.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/9996593963",
  "n": "T-CORE",
  "a": "Aleja Jana Pawła II 8, 32-590 Libiąż",
  "c": "Libiąż",
  "p": "powiat chrzanowski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "pon.-czw. 17-22; pt. 16-21; sob.-niedz. 10-21",
  "d": "Strzelnica T-CORE w Libiążu - wieczorne treningi w tygodniu, w weekendy czynna od rana.",
  "s": 4,
  "k": [
   "godz",
   "adres"
  ]
 },
 {
  "id": "node/11049793298",
  "n": "Shooting Zone",
  "a": "Limanowa",
  "c": "Limanowa",
  "p": "powiat limanowski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 509 674 002",
  "t2": "",
  "w": "",
  "f": "",
  "e": "kontakt@shootingzone.pl",
  "h": "",
  "d": "Strzelnica Shooting Zone w Limanowej - strzelania z instruktorem po wcześniejszym umówieniu.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "way/1450931621",
  "n": "Laki Strzał",
  "a": "Maków",
  "c": "Maków",
  "p": "powiat miechowski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 509 437 848",
  "t2": "",
  "w": "https://lakistrzal.com/",
  "f": "",
  "e": "lukaszcnotalakistrzal@gmail.com",
  "h": "",
  "d": "Strzelnica Laki Strzał w Makowie Podhalańskim - strzelania rekreacyjne i pakiety dla grup.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/1059023851",
  "n": "Strzelnica Sportowa",
  "a": "Miechów",
  "c": "Miechów",
  "p": "powiat miechowski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa - Miechów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/308797153",
  "n": "strzelnica sportowa",
  "a": "Zdrojowa 9, 32-400 Myślenice",
  "c": "Myślenice",
  "p": "powiat myślenicki",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "13 - 20",
  "d": "Strzelnica sportowa w Myślenicach - treningi klubowe w godzinach popołudniowych.",
  "s": 4,
  "k": [
   "godz",
   "adres"
  ]
 },
 {
  "id": "way/1003573457",
  "n": "Paint Gang Arena",
  "a": "Nowy Sącz",
  "c": "Nowy Sącz",
  "p": "",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Sącz.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/846961251",
  "n": "Strzelnica Taktyczna VIS MAIOR Nowy Sącz - Biegonice",
  "a": "Nowy Sącz",
  "c": "Nowy Sącz",
  "p": "",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nowy Sącz.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/141213487",
  "n": "strzelnica",
  "a": "Oświęcim",
  "c": "Oświęcim",
  "p": "powiat oświęcimski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Oświęcim.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/2933980213",
  "n": "Strzelnica Bojowa, Krakow Valley Shooting Range",
  "a": "328, 32-065 Paczółtowice",
  "c": "Paczółtowice",
  "p": "powiat krakowski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 660 669 977",
  "t2": "",
  "w": "https://strzelnicabojowa.pl",
  "f": "",
  "e": "rezerwacje@strzelnicabojowa.pl",
  "h": "śr.-pt. 12-20, sob.-niedz. 10-20",
  "d": "Strzelnica bojowa Krakow Valley w Paczółtowicach: strzelania z broni długiej i krótkiej, w tym z karabinów automatycznych.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/3653923706",
  "n": "Strzelnica sportowa HUZAR",
  "a": "Tadeusza Kościuszki 26, 32-090 Słomniki",
  "c": "Słomniki",
  "p": "powiat krakowski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa HUZAR w Słomnikach - treningi i zawody klubowe.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/1015101369",
  "n": "Tarnowski Klub Strzelecki LOK",
  "a": "Krzyska 17, 33-100 Tarnów",
  "c": "Tarnów",
  "p": "Tarnów",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "https://tkslok.pl",
  "f": "",
  "e": "tkslok.tarnow@gmail.com",
  "h": "",
  "d": "Tarnowski Klub Strzelecki LOK - strzelnica klubowa z sekcją sportową i rekreacyjną.",
  "s": 7,
  "k": [
   "www",
   "adres",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/10011626943",
  "n": "Strzelnica pneumatyczna",
  "a": "Rafineryjna 10A, 32-540 Trzebinia",
  "c": "Trzebinia",
  "p": "powiat chrzanowski",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Kryta strzelnica pneumatyczna w Trzebini - strzelania z wiatrówki, dostępna dla wszystkich; wstęp płatny.",
  "s": 4,
  "k": [
   "adres",
   "kryta"
  ]
 },
 {
  "id": "node/7335125667",
  "n": "Strzelnica Opolskiego Klubu Stzeleckiego Husarz",
  "a": "Brzeg",
  "c": "Brzeg",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa, wstęp płatny.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/5898758414",
  "n": "Strzelnica",
  "a": "Kędzierzyn-Koźle",
  "c": "Kędzierzyn-Koźle",
  "p": "powiat kędzierzyńsko-kozielski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa",
  "s": 1,
  "k": [
   "opis"
  ]
 },
 {
  "id": "way/207030999",
  "n": "Strzelnica LOK",
  "a": "Opole",
  "c": "Opole",
  "p": "",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Opole.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/5162891158",
  "n": "Strzelnica sportowa",
  "a": "Opole",
  "c": "Opole",
  "p": "",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Opole.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1509746010",
  "n": "10",
  "a": "Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Pawłów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1509746003",
  "n": "3",
  "a": "Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Pawłów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1509746004",
  "n": "4",
  "a": "Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Pawłów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1509746005",
  "n": "5",
  "a": "Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Pawłów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1509746006",
  "n": "6",
  "a": "Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Pawłów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1509746007",
  "n": "7",
  "a": "Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Pawłów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1509746008",
  "n": "8",
  "a": "Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Pawłów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1509746009",
  "n": "9",
  "a": "Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Pawłów.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11449163090",
  "n": "Strzelnica Pawłów",
  "a": "Poligonowa 41, 49-300 Pawłów",
  "c": "Pawłów",
  "p": "powiat brzeski",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "+48 607 543 503",
  "t2": "",
  "w": "https://strzelnicapawlow.pl/",
  "f": "",
  "e": "info@strzelnicapawlow.pl",
  "h": "pon. nieczynne; wt.-niedz. 09-18",
  "d": "Strzelnica w Pawłowie - nowoczesne stanowiska, kursy strzeleckie i zajęcia z instruktorami, czynna od wtorku do niedzieli.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/439019286",
  "n": "LOK Brzozów Strzelnica",
  "a": "Brzozów",
  "c": "Brzozów",
  "p": "powiat brzozowski",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa - Brzozów.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/11021889437",
  "n": "Pistol Range",
  "a": "Chorzelów",
  "c": "Chorzelów",
  "p": "powiat mielecki",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Chorzelów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1015895525",
  "n": "Strzelnica Rekreacyjna „FRANKÓW”",
  "a": "Dukla",
  "c": "Dukla",
  "p": "powiat krośnieński",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Dukla.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/2341971294",
  "n": "Strzelnica Strzelka",
  "a": "Złota 65, 36-060 Głogów Małopolski",
  "c": "Głogów Małopolski",
  "p": "powiat rzeszowski",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "+48 502 523 887",
  "t2": "",
  "w": "http://www.strzelka.pl",
  "f": "",
  "e": "strzelnica.strzelka@interia.pl",
  "h": "",
  "d": "Strzelnica Strzelka w Głogowie Małopolskim - strzelania rekreacyjne i sportowe.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/1085606096",
  "n": "Strzelnica",
  "a": "Kolbuszowa",
  "c": "Kolbuszowa",
  "p": "powiat kolbuszowski",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Kolbuszowa.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/427035146",
  "n": "Strzelnica Miejska",
  "a": "Mielec",
  "c": "Mielec",
  "p": "powiat mielecki",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Mielec.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1329022759",
  "n": "strzelnica sportowa",
  "a": "Pruchnik",
  "c": "Pruchnik",
  "p": "powiat jarosławski",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica sportowa w miejscowości Pruchnik.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1129888808",
  "n": "Strzelnica sportowa LOK",
  "a": "Juliusza Słowackiego 40, 37-700 Przemyśl",
  "c": "Przemyśl",
  "p": "",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "+48 166 786 845",
  "t2": "",
  "w": "https://www.lok.przemysl.pl/index.php/strzelnica",
  "f": "",
  "e": "strzelnica@lok.przemysl.pl",
  "h": "pon.-pt. 10-18",
  "d": "Strzelnica kulowa dopuszczona jest do strzelań z broni palnej bocznego i centralnego zapłonu (kalibru 5,6 mm i 9 mm). Strzelanie odbywa się na zadaszonych stanowiskach na dwóch osiach. Posiadamy również krytą strzelnicę pneumatyczną, czynną cały rok.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "klub",
   "opis"
  ]
 },
 {
  "id": "way/583043218",
  "n": "Husar",
  "a": "317, 36-054 Rudna Wielka",
  "c": "Rudna Wielka",
  "p": "powiat rzeszowski",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "+48 664 066 654",
  "t2": "",
  "w": "https://www.strzelnicarzeszow.pl",
  "f": "",
  "e": "biuro@strzelnicarzeszow.pl",
  "h": "pon.-pt. 10-20; sob.-niedz. 10-18",
  "d": "Strzelnica Husar pod Rzeszowem: strzelania dla początkujących, wieczory kawalerskie i spotkania integracyjne, czynna codziennie.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/1372536384",
  "n": "Strzelnica Dycha",
  "a": "Rzeszów",
  "c": "Rzeszów",
  "p": "",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "+48 178 700 750",
  "t2": "",
  "w": "https://strzelnica.powiat.rzeszowski.pl/",
  "f": "",
  "e": "strzelnica@powiat.rzeszowski.pl",
  "h": "",
  "d": "Strzelnica Powiatu Rzeszowskiego: broń własna i obiektowa, zajęcia z instruktorem, wynajem osi i strzelnica wirtualna.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/1451093030",
  "n": "Strzelnica Gminna Partyzant",
  "a": "Henryka Sienkiewicza 84, 36-050 Sokołów Małopolski",
  "c": "Sokołów Małopolski",
  "p": "powiat rzeszowski",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "+48 698 032 888",
  "t2": "",
  "w": "https://strzelnica.sokolow-mlp.pl/",
  "f": "",
  "e": "strzelnica@e-sokolow-mlp.pl",
  "h": "",
  "d": "Gminna strzelnica PARTYZANT w Sokołowie Małopolskim, prowadzona przez miejski ośrodek kultury i sportu.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/647341509",
  "n": "Liga Obrony Kraju",
  "a": "Stalowa Wola",
  "c": "Stalowa Wola",
  "p": "powiat stalowowolski",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Stalowa Wola.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11179586877",
  "n": "Strzelnica Wataha",
  "a": "89, 37-205 Łapajówka",
  "c": "Łapajówka",
  "p": "powiat przeworski",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "+48 667 635 786",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Wataha w Łapajówce - otwarty obiekt strzelecki na Podkarpaciu.",
  "s": 5,
  "k": [
   "tel",
   "adres"
  ]
 },
 {
  "id": "way/1352621653",
  "n": "Strzelnica",
  "a": "Łańcut",
  "c": "Łańcut",
  "p": "powiat łańcucki",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa, prowadzona przez: Łańcucki Klub Strzelecki CEL.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/10891380419",
  "n": "Klub Sportowy \"Kaliber\"",
  "a": "Białystok",
  "c": "Białystok",
  "p": "",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "+48 889 889 985",
  "t2": "",
  "w": "https://kaliberbialystok.pl/",
  "f": "",
  "e": "uks.kaliber@wp.pl",
  "h": "",
  "d": "Klub Sportowy Kaliber w Białymstoku - nauka celnego strzału i treningi w gronie osób z podobną pasją.",
  "s": 8,
  "k": [
   "tel",
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/239475501",
  "n": "Strzelnica Hubertus",
  "a": "Produkcyjna 113, 15-680 Białystok",
  "c": "Białystok",
  "p": "",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "+48 856 620 346",
  "t2": "",
  "w": "https://hubertus.com.pl/",
  "f": "",
  "e": "tolczyk@hubertus.com.pl",
  "h": "",
  "d": "Kryta strzelnica przy sklepie Hubertus Tołczyk w Białymstoku - broń, amunicja, optyka i akcesoria strzeleckie.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "way/1327073655",
  "n": "Strzelnica cywilno-sportowa w Borysowszczyźnie",
  "a": "Borysowszczyzna",
  "c": "Borysowszczyzna",
  "p": "powiat siemiatycki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Borysowszczyzna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/12751817984",
  "n": "Strzelnica GROM Group",
  "a": "Czerwony Bór",
  "c": "Czerwony Bór",
  "p": "powiat zambrowski",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Czerwony Bór.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/877829193",
  "n": "Strzelnica Sportowa PZŁ Czerwony Bór",
  "a": "Czerwony Bór",
  "c": "Czerwony Bór",
  "p": "powiat zambrowski",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Czerwony Bór.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1501410522",
  "n": "Strzelnica Jasionówka (Klub 9mm)",
  "a": "Dobrzyniówka",
  "c": "Dobrzyniówka",
  "p": "powiat moniecki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica klubowa w miejscowości Dobrzyniówka.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/194927852",
  "n": "Strzelnica Borek - Sejneńskie Towarzystwo Strzeleckie",
  "a": "Gawiniańce",
  "c": "Gawiniańce",
  "p": "powiat sejneński",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Gawiniańce.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/245260532",
  "n": "strzelnica",
  "a": "Grajewo",
  "c": "Grajewo",
  "p": "powiat grajewski",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Grajewo.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1426659328",
  "n": "Dzik",
  "a": "Karakule",
  "c": "Karakule",
  "p": "powiat białostocki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1426659333",
  "n": "Krąg",
  "a": "Karakule",
  "c": "Karakule",
  "p": "powiat białostocki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1426659331",
  "n": "Oś",
  "a": "Karakule",
  "c": "Karakule",
  "p": "powiat białostocki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1426659330",
  "n": "Przeloty",
  "a": "Karakule",
  "c": "Karakule",
  "p": "powiat białostocki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1426659327",
  "n": "Rogacz",
  "a": "Karakule",
  "c": "Karakule",
  "p": "powiat białostocki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/425972447",
  "n": "Strzelnica myśliwska i sportowa",
  "a": "Karakule",
  "c": "Karakule",
  "p": "powiat białostocki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "+48 603 311 082",
  "t2": "",
  "w": "https://bialystok.pzlow.pl/dla-mysliwych/strzelnica/",
  "f": "",
  "e": "zo.bialystok@pzlow.pl",
  "h": "pon. nieczynne; wt.-pt. 13-19; sob. 09-15; święta nieczynne",
  "d": "Strzelnica myśliwska i sportowa okręgu białostockiego PZŁ w Karakulach; wstęp płatny, czynna od wtorku do soboty.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1426659329",
  "n": "Zając",
  "a": "Karakule",
  "c": "Karakule",
  "p": "powiat białostocki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/5556010262",
  "n": "Suwalska Liga Darta",
  "a": "Suwałki",
  "c": "Suwałki",
  "p": "powiat suwalski",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Suwałki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1473630812",
  "n": "Strzelnica Stowarzyszenie Historyczne im.71. Pułku Piechoty",
  "a": "Tabędz",
  "c": "Tabędz",
  "p": "powiat zambrowski",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Tabędz.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/1489239893",
  "n": "Strzelnica w Główczycach",
  "a": "Cecenowo",
  "c": "Cecenowo",
  "p": "powiat słupski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 783 727 717",
  "t2": "+48 783 727 797",
  "w": "https://trzytwierdze.pl",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Stowarzyszenia Strzelecko-Kolekcjonerskiego Trzy Twierdze w Główczycach.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "klub"
  ]
 },
 {
  "id": "way/616916433",
  "n": "Gdańskie Centrum Strzeleckie",
  "a": "Jaśkowa Dolina 114, 80-286 Gdańsk",
  "c": "Gdańsk",
  "p": "",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 502 545 767",
  "t2": "",
  "w": "http://www.gcs-strzelanie.com",
  "f": "",
  "e": "biuro@gcs-strzelanie.com",
  "h": "pon.-pt. 10-18; sob. 10-14",
  "d": "Gdańskie Centrum Strzeleckie przy Jaśkowej Dolinie - otwarte osie strzeleckie, dostęp dla klientów obiektu.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/6204569342",
  "n": "Salon broni i strzelnica \"Czapla\"",
  "a": "Jana Matejki 6, 80-232 Gdańsk",
  "c": "Gdańsk",
  "p": "",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 583 470 240",
  "t2": "",
  "w": "https://czapla-bron.pl/",
  "f": "",
  "e": "biuro.czapla@wp.pl",
  "h": "pon.-pt. 10-18",
  "d": "Kryta strzelnica przy salonie broni Czapla w Gdańsku - sprzedaż broni i strzelania w dni robocze.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "node/4780401790",
  "n": "Strzelnica DSTeam",
  "a": "Tytusa Chałubińskiego 31, 80-807 Gdańsk",
  "c": "Gdańsk",
  "p": "",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 665 566 997",
  "t2": "",
  "w": "https://dsteam.pl/",
  "f": "",
  "e": "strzelnica@dsteam.pl",
  "h": "pon. 14-22; wt. nieczynne; śr.-pt. 14-22; sob. 12-22; niedz. 12-20",
  "d": "Kryta strzelnica DSTeam na gdańskim Chełmie, czynna sześć dni w tygodniu do późnych godzin.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "way/618090057",
  "n": "Strzelnica Klubu Strzelających Inaczej",
  "a": "Zawodników 1, 80-729 Gdańsk",
  "c": "Gdańsk",
  "p": "",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 576 995 350",
  "t2": "",
  "w": "https://www.strzelamyinaczej.pl/strzelnica-gdansk/",
  "f": "",
  "e": "klubstrzelajacychinaczej@gmail.com",
  "h": "pon.-czw. 17-22; pt.-niedz. 10-22",
  "d": "Strzelnica sportowo-rekreacyjna. Posiada dwie osie strzeleckie, 15 i 25 m. Należy do klubu sportowego, ale obsługuje również osoby spoza klubu.",
  "s": 15,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta",
   "klub",
   "opis"
  ]
 },
 {
  "id": "way/721182227",
  "n": "Centrum Strzeleckie Tarcza Gdynia",
  "a": "Źródło Marii 45A, 81-573 Gdynia",
  "c": "Gdynia",
  "p": "Gdynia",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 534 510 000",
  "t2": "",
  "w": "https://tarcza-gdynia.pl/",
  "f": "",
  "e": "sklep@sklep-strzelecki.pl",
  "h": "pon.-pt. 12-21; sob. 10-22; niedz. 12-21",
  "d": "Kryta strzelnica Centrum Strzeleckiego Tarcza w Gdyni: ogrzewany obiekt 500 m², pakiety startowe i szeroki wybór broni.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "node/10097410492",
  "n": "Strefa Zoltar",
  "a": "Wójta Radtkego 36, 81-355 Gdynia",
  "c": "Gdynia",
  "p": "Gdynia",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 505 787 871",
  "t2": "",
  "w": "https://www.strefazoltar.pl/gdynia",
  "f": "",
  "e": "strefazoltar@gmail.com",
  "h": "pon.-czw. 10-20; pt.-niedz. 10-21",
  "d": "Strefa Zoltar w Gdyni - rozrywkowy obiekt ze strzelnicą; wstęp płatny, czynne codziennie.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/6632311075",
  "n": "Strzelnica MoST",
  "a": "Chwaszczyńska 194, 81-571 Gdynia",
  "c": "Gdynia",
  "p": "Gdynia",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 586 297 960",
  "t2": "+48 539 771 451",
  "w": "",
  "f": "https://www.facebook.com/gdyniastrzelnica",
  "e": "biuro@gdyniastrzelnica.pl",
  "h": "wt.-czw. 16:30-21; pt. 16:30-22; sob. 12:30-20; niedz. 15:30-20",
  "d": "Kryta strzelnica MoST przy ul. Chwaszczyńskiej w Gdyni - treningi i strzelania komercyjne od wtorku do niedzieli.",
  "s": 10,
  "k": [
   "tel",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "way/786288712",
  "n": "Strzelnica Playground",
  "a": "Bernadowska 24, 81-553 Gdynia",
  "c": "Gdynia",
  "p": "Gdynia",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 605 152 425",
  "t2": "",
  "w": "https://strzelnica-playground.pl/",
  "f": "",
  "e": "playground@gardaarms.pl",
  "h": "pon.-niedz. 10-18",
  "d": "Strzelnica Playground w Gdyni - obiekt dla początkujących i doświadczonych strzelców; wstęp płatny.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/280873365",
  "n": "Strzelnica",
  "a": "Hel",
  "c": "Hel",
  "p": "powiat pucki",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/5726352721",
  "n": "Strzelnica bojowa",
  "a": "Hel",
  "c": "Hel",
  "p": "powiat pucki",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 603 650 536",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica bojowa na Helu - strzelania rekreacyjne, kontakt telefoniczny.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "node/4761296797",
  "n": "Klub Strzelecki Dziesiątka",
  "a": "Wzgórze Wolności 1, 83-300 Kartuzy",
  "c": "Kartuzy",
  "p": "powiat kartuski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 608 050 715",
  "t2": "",
  "w": "",
  "f": "",
  "e": "ksdziesiatka@interia.pl",
  "h": "pon.-pt. 16-19; wt.,czw.,sob.,niedz.,święta nieczynne",
  "d": "Klub Strzelecki Dziesiątka w Kartuzach - treningi klubowe w dni powszednie po południu.",
  "s": 9,
  "k": [
   "tel",
   "godz",
   "adres",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/12040463963",
  "n": "Strzelnica Skorpion",
  "a": "Korne",
  "c": "Korne",
  "p": "powiat kościerski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 570 997 007",
  "t2": "",
  "w": "https://strzelnica-skorpion.pl/",
  "f": "",
  "e": "info@strzelnica-skorpion.pl",
  "h": "",
  "d": "Centrum Strzelecko-Szkoleniowe Skorpion w Kornem na Kaszubach - strzelania i szkolenia.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "node/12040164887",
  "n": "Strzelnica Słupsk",
  "a": "Kuleszewo",
  "c": "Kuleszewo",
  "p": "powiat słupski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 501 382 348",
  "t2": "",
  "w": "https://www.strzelnicaslupsk.pl/",
  "f": "",
  "e": "rafal@strzelnicaslupsk.pl",
  "h": "",
  "d": "Strzelnica obsługująca Słupsk, położona w Kuleszewie pod miastem.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/531398474",
  "n": "Strzelnica Sportowa",
  "a": "Strumykowa, 82-500 Kwidzyn",
  "c": "Kwidzyn",
  "p": "powiat kwidzyński",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w Kwidzynie - otwarte osie na trawiastym podłożu, dostęp dla klientów obiektu.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/502480083",
  "n": "Strzelnica Sportowo-Myśliwska \"Czapla\"",
  "a": "Wojska Polskiego 30, 83-050 Lublewo Gdańskie",
  "c": "Lublewo Gdańskie",
  "p": "powiat gdański",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 607 667 606",
  "t2": "",
  "w": "https://strzelnicaczapla.pl/",
  "f": "",
  "e": "strzelnica.lublewo@wp.pl",
  "h": "pon.-sob. 09-18; niedz. nieczynne",
  "d": "Strzelnica sportowo-myśliwska Czapla w Lublewie Gdańskim - strzelania śrutowe i kulowe, czynna od poniedziałku do soboty.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/765155955",
  "n": "Strzelnica KSK Perkun",
  "a": "Gdyńska 86, 80-297 Miszewko",
  "c": "Miszewko",
  "p": "powiat kartuski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 605 644 662",
  "t2": "",
  "w": "https://perkunklub.pl/",
  "f": "",
  "e": "perkun@perkunklub.pl",
  "h": "wt. 11-20; śr. 15-20; pt.-sob. 11-20; niedz. 10-20",
  "d": "Kryta strzelnica klubu strzelecko-kolekcjonerskiego Perkun w Miszewku pod Gdańskiem.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "way/1222806845",
  "n": "Strzelnica klubu strzeleckiego Foka Puck",
  "a": "Mrzezino",
  "c": "Mrzezino",
  "p": "powiat pucki",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 508 622 850",
  "t2": "",
  "w": "",
  "f": "",
  "e": "roman.kreft@ksfoka.pl",
  "h": "",
  "d": "Strzelnica klubu strzeleckiego Foka Puck w Mrzezinie - treningi klubowe.",
  "s": 5,
  "k": [
   "tel",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/366771992",
  "n": "Strzelnica LOK Prabuty",
  "a": "Prabuty",
  "c": "Prabuty",
  "p": "powiat kwidzyński",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Prabuty.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/1114960641",
  "n": "Strzelnica Kurkowego Bractwa Strzeleckigo w Wejherowie",
  "a": "Wejherowo",
  "c": "Wejherowo",
  "p": "powiat wejherowski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Wejherowo.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/9110966101",
  "n": "Strzelnica Trofeum",
  "a": "Strzelecka 1, 82-200 Nowa Wieś Malborska",
  "c": "Wielbark",
  "p": "powiat malborski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 575 079 275",
  "t2": "",
  "w": "https://www.trofeum.net.pl/",
  "f": "",
  "e": "kontakt@trofeum.net.pl",
  "h": "pon.-wt. 09-17; śr. 09-18; czw.-pt. 09-17; sob. 09-14",
  "d": "Strzelnica Trofeum pod Malborkiem - strzelania na eventy i imprezy firmowe, czynna sześć dni w tygodniu.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/6188765918",
  "n": "Strzelnica Klubu Strzelających Inaczej",
  "a": "Zielnowo",
  "c": "Zielnowo",
  "p": "powiat wejherowski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 889 254 486",
  "t2": "",
  "w": "https://www.strzelamyinaczej.pl/strzelnica-zielnowo/",
  "f": "",
  "e": "klubstrzelajacychinaczej@gmail.com",
  "h": "",
  "d": "Otwarta strzelnica klubowa w Zielnowie: dwie osie 15 i 25 m, obsługuje też osoby spoza klubu; wstęp płatny.",
  "s": 8,
  "k": [
   "tel",
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/661040957",
  "n": "Strzelnica Klubu Strzelających Inaczej",
  "a": "Świetlino",
  "c": "Świetlino",
  "p": "powiat wejherowski",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/KSI.Swietlino",
  "e": "",
  "h": "pon.-niedz. 10-18",
  "d": "Strzelnica Klubu Strzelających Inaczej w Świetlinie - otwarte osie, czynne codziennie.",
  "s": 3,
  "k": [
   "godz",
   "klub"
  ]
 },
 {
  "id": "node/12042301695",
  "n": "Strzelnica Virtus",
  "a": "Gągławki",
  "c": "Gągławki",
  "p": "powiat olsztyński",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "+48 603 957 990",
  "t2": "",
  "w": "https://www.ooo-academy.com/strzelnica/",
  "f": "",
  "e": "booking@ooo-academy.com",
  "h": "",
  "d": "Strzelnica Virtus w Gągławkach pod Olsztynem - strzelania rekreacyjne i szkolenia.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "node/10002989221",
  "n": "Wilk Centrum Strzeleckie",
  "a": "Jaśki",
  "c": "Jaśki",
  "p": "powiat olecki",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "+48 875 200 809",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/profile.php?id=100057497047595",
  "e": "strzelnica@wilk.olecko.pl",
  "h": "pon. nieczynne; wt.-pt. 12-20; sob. 10-18 ; niedz. 10-18",
  "d": "Wilk Centrum Strzeleckie w Jaśkach - strzelania od wtorku do niedzieli, także dla grup.",
  "s": 6,
  "k": [
   "tel",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/165526053",
  "n": "Strzelnica myśliwska",
  "a": "Nowa Wieś Ełcka",
  "c": "Mrozy Wielkie",
  "p": "powiat ełcki",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska, prowadzona przez: Polski Związek Łowiecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/444263436",
  "n": "Strzelnica",
  "a": "Olsztyn",
  "c": "Olsztyn",
  "p": "",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Olsztyn.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/165508677",
  "n": "Strzelnica VIP",
  "a": "Marii Grzegorzewskiej 3, 10-048 Olsztyn",
  "c": "Olsztyn",
  "p": "",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "+48 501 923 333",
  "t2": "",
  "w": "https://www.strzelnicavip.pl/",
  "f": "",
  "e": "strzelnicavip@wp.pl",
  "h": "",
  "d": "Kryta strzelnica VIP w Olsztynie - strzelania komercyjne z instruktorem.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "way/1157380104",
  "n": "Tory Taktyczne Srokowo",
  "a": "Srokowo",
  "c": "Srokowo",
  "p": "powiat kętrzyński",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1369589216",
  "n": "Strzelnica Tylice",
  "a": "Tylice",
  "c": "Tylice",
  "p": "powiat nowomiejski",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Tylice.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/4359141732",
  "n": "Strzelnica LOK Iława",
  "a": "Wikielec",
  "c": "Wikielec",
  "p": "powiat iławski",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Wikielec.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/1435126059",
  "n": "strzelnica GRYF Biskupiec",
  "a": "Łabuchy",
  "c": "Łabuchy",
  "p": "powiat olsztyński",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa, prowadzona przez: Strzelecki Klub Sportowy Gryf Biskupiec.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/12887325521",
  "n": "Strzelnica Predator",
  "a": "Aleksandrowo",
  "c": "Aleksandrowo",
  "p": "powiat wągrowiecki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 511 521 769",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/profile.php?id=61559164624171",
  "e": "",
  "h": "",
  "d": "Strzelnica Predator w Aleksandrowie - otwarty obiekt strzelecki w Wielkopolsce.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "node/13416423388",
  "n": "Strzelnica PWR GUNS",
  "a": "Bierzglinek",
  "c": "Bierzglinek",
  "p": "powiat wrzesiński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 781 300 400",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/people/Strzelnica-PWR-GUNS-Wrze%C5%9Bnia/61567260481333/",
  "e": "strzelnica.pwrguns@gmail.com",
  "h": "",
  "d": "Strzelnica PWR GUNS w Bierzglinku pod Wrześnią.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "node/5479948727",
  "n": "Strzelnica sportowa",
  "a": "Buk",
  "c": "Buk",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Buk.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/8655153752",
  "n": "Strzelnica Błocko",
  "a": "Błocko",
  "c": "Błocko",
  "p": "powiat wolsztyński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 697 884 440",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/strzelnicablocko/",
  "e": "strzelnicablocko@gmail.com",
  "h": "",
  "d": "Strzelnica Błocko - otwarty obiekt strzelecki w Wielkopolsce.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "node/11943253671",
  "n": "Strzelnica Cieśle",
  "a": "Cieśle",
  "c": "Cieśle",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "https://strzelnica-ciesle.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Centrum Strzeleckie Perun w Cieślach - nowy obiekt ok. 15 minut samochodem od Poznania.",
  "s": 3,
  "k": [
   "www"
  ]
 },
 {
  "id": "node/10060883178",
  "n": "Strzelnica Czacz",
  "a": "Wielichowska 42, 64-030 Czacz",
  "c": "Czacz",
  "p": "powiat kościański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 570 230 999",
  "t2": "",
  "w": "https://www.strzelnicaczacz.pl/",
  "f": "",
  "e": "kontakt@strzelnicaczacz.pl",
  "h": "09-19",
  "d": "Strzelnica Czacz pod Śmiglem, czynna codziennie od rana do wieczora.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/3717620635",
  "n": "Strzelnica Nad Flintą",
  "a": "Dąbrówka Leśna",
  "c": "Dąbrówka Leśna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 506 050 433",
  "t2": "",
  "w": "https://www.oborniki.pl/turystyka/strzelnica-nad-flinta/",
  "f": "",
  "e": "gajowybonczek@poczta.onet.pl",
  "h": "pon.-pt. 10-17; sob. 09-13; niedz. nieczynne",
  "d": "Strzelnica Nad Flintą w Dąbrówce Leśnej, prowadzona przy udziale gminy Oborniki.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/9983886537",
  "n": "Strzelnica ESA",
  "a": "Gajewo",
  "c": "Gajewo",
  "p": "powiat śremski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 669 955 955",
  "t2": "",
  "w": "https://www.euseca.com/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica European Security Academy w Gajewie - ośrodek szkoleń dla służb i ochrony, działający od 1992 roku.",
  "s": 6,
  "k": [
   "tel",
   "www"
  ]
 },
 {
  "id": "node/10000259145",
  "n": "Strzelnica Myśliwska Orchowo",
  "a": "Gałczynek",
  "c": "Gałczynek",
  "p": "powiat słupecki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Gałczynek.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/9990347162",
  "n": "Klub Strzelectwa Sportowego LOK „VIS”",
  "a": "Gostyń",
  "c": "Gostyń",
  "p": "powiat gostyński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 669 218 251",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Klub Strzelectwa Sportowego LOK VIS w Gostyniu - treningi i zawody klubowe.",
  "s": 4,
  "k": [
   "tel",
   "klub"
  ]
 },
 {
  "id": "node/12735242751",
  "n": "Strzelnica Granowo",
  "a": "Granowo",
  "c": "Granowo",
  "p": "powiat grodziski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 661 976 941",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w Granowie - otwarty obiekt strzelecki w powiecie grodziskim.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "node/13986535274",
  "n": "Strzelnica Trzcinowy Zakątek",
  "a": "Górsko",
  "c": "Górsko",
  "p": "powiat wolsztyński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 730 011 225",
  "t2": "",
  "w": "https://www.trzcinowyzakatek.pl/index.php/strzelnica",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica przy gospodarstwie agroturystycznym Trzcinowy Zakątek - strzelania jako atrakcja dla gości i grup.",
  "s": 6,
  "k": [
   "tel",
   "www"
  ]
 },
 {
  "id": "node/12150449598",
  "n": "Strzelnica Nadleśnictwa Lipka",
  "a": "Górzna",
  "c": "Górzna",
  "p": "powiat złotowski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "https://lipka.pila.lasy.gov.pl/aktualnosci/-/asset_publisher/1M8a/content/strzelnica",
  "f": "",
  "e": "lipka@pila.lasy.gov.pl",
  "h": "",
  "d": "Strzelnica Nadleśnictwa Lipka w Górznej, udostępniana po wcześniejszej rezerwacji.",
  "s": 4,
  "k": [
   "www",
   "mail"
  ]
 },
 {
  "id": "way/778268074",
  "n": "Strzelnica Czempińskiego Związku Strzeleckiego",
  "a": "Głuchowo",
  "c": "Głuchowo",
  "p": "powiat kościański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica, prowadzona przez: Czempiński Związek Strzelecki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11895597640",
  "n": "Strzelnica Jasin",
  "a": "Chabrowa 9, 62-020 Jasin",
  "c": "Jasin",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 452 926 813",
  "t2": "",
  "w": "",
  "f": "",
  "e": "strzelnica.jasin@gmail.pl",
  "h": "pon.-sob. 08-20; niedz. nieczynne",
  "d": "Strzelnica w Jasinie pod Swarzędzem, czynna od poniedziałku do soboty.",
  "s": 8,
  "k": [
   "tel",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/917420065",
  "n": "Strzelnica Defendu",
  "a": "Józefowo",
  "c": "Józefowo",
  "p": "powiat nowotomyski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 693 835 435",
  "t2": "",
  "w": "https://www.defendu.club",
  "f": "",
  "e": "biuro@defendu.club",
  "h": "",
  "d": "Strzelnica Defendu w Józefowie - szkolenia i strzelania praktyczne.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "node/12818030998",
  "n": "Strzelnica Łucjanowo",
  "a": "Józefowo",
  "c": "Józefowo",
  "p": "powiat szamotulski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Józefowo.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10152108155",
  "n": "Strzelnica Sokół",
  "a": "Kazimierz Biskupi",
  "c": "Kazimierz Biskupi",
  "p": "powiat koniński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 795 225 997",
  "t2": "",
  "w": "https://klubsokol.pl/",
  "f": "",
  "e": "sokol.kazimierz@wp.pl",
  "h": "pon.-wt. nieczynne; śr. 16-20; czw.-sob. nieczynne; niedz. 16-20",
  "d": "Strzelnica Stowarzyszenia Strzeleckiego Sokół w Kazimierzu Biskupim - treningi w środy i niedziele.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1273555308",
  "n": "Strzelnica Sportowa LOK",
  "a": "Koło",
  "c": "Koło",
  "p": "powiat kolski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa, prowadzona przez: Liga Obrony Kraju.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/479245071",
  "n": "Strzelnica sportowa Bractwa Kurkowego Krobia",
  "a": "Krobia",
  "c": "Krobia",
  "p": "powiat gostyński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "http://www.bractwo.krobia.pl",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa Bractwa Kurkowego w Krobi - tradycyjne strzelania brackie i treningi sportowe.",
  "s": 3,
  "k": [
   "www"
  ]
 },
 {
  "id": "way/374502680",
  "n": "Strzelnica Bractwa Kurkowego w Krotoszynie",
  "a": "Bractwa Kurkowego 1, 63-700 Krotoszyn",
  "c": "Krotoszyn",
  "p": "powiat krotoszyński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Bractwa Kurkowego w Krotoszynie - obiekt o wieloletniej tradycji strzelectwa kurkowego.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/393202725",
  "n": "Strzelnica Myśliwsko-Sportowa im. T. Nabiałczyka",
  "a": "Krzywiń",
  "c": "Krzywiń",
  "p": "powiat kościański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 500 692 634",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/StrzelnicaKrzywin/",
  "e": "pzlstrzelnicakrzywin@wp.pl",
  "h": "pon. nieczynne; wt.-pt. 12-18; sob.-niedz. 08-18",
  "d": "Strzelnica myśliwsko-sportowa im. T. Nabiałczyka w Krzywiniu, czynna od wtorku do niedzieli.",
  "s": 6,
  "k": [
   "tel",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/4876527824",
  "n": "Strzelnica Sportowa Lesna Leszno",
  "a": "Plac Tadeusza Kościuszki 5, 64-100 Leszno",
  "c": "Leszno",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "https://kslesna.pl/",
  "f": "",
  "e": "klub@kslesna.pl",
  "h": "",
  "d": "Strzelnica sportowa Klubu Strzeleckiego LESNA w Lesznie - treningi i zawody.",
  "s": 6,
  "k": [
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/13037848120",
  "n": "Strzelnica Sompolno",
  "a": "Lubstów",
  "c": "Lubstów",
  "p": "powiat koniński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 792 844 793",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w Lubstowie obsługująca gminę Sompolno.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "way/1273550765",
  "n": "Strzelnica LOK Karczemka",
  "a": "K1, 63-300 Ludwina",
  "c": "Ludwina",
  "p": "powiat pleszewski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 513 184 259",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Ligi Obrony Kraju Karczemka w Ludwinie - treningi klubowe.",
  "s": 6,
  "k": [
   "tel",
   "adres",
   "klub"
  ]
 },
 {
  "id": "node/11627725128",
  "n": "Strzelnica Markowice (w budowie)",
  "a": "Markowice",
  "c": "Markowice",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Markowice.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10143883997",
  "n": "Strzelnica Sportowa Nitro",
  "a": "Mościenica",
  "c": "Mościenica",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 606 682 774",
  "t2": "",
  "w": "",
  "f": "",
  "e": "krzysztof.gawlik88@wp.pl",
  "h": "",
  "d": "Strzelnica sportowa Nitro w Mościenicy - treningi i strzelania grupowe.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "node/2748960043",
  "n": "KBS Murowana Goślina",
  "a": "Bracka 1, 62-095 Murowana Goślina",
  "c": "Murowana Goślina",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "http://kbsmurowanagoslina.pl/",
  "f": "",
  "e": "bractwo@onet.com.pl",
  "h": "",
  "d": "Strzelnica Kurkowego Bractwa Strzeleckiego w Murowanej Goślinie.",
  "s": 6,
  "k": [
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "node/8623617173",
  "n": "Strzelnica Kryta \"Pod Ratuszem\"",
  "a": "Murowana Goślina",
  "c": "Murowana Goślina",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "http://kbsmurowanagoslina.pl/",
  "f": "",
  "e": "bractwo@onet.com.pl",
  "h": "pt. 19-21",
  "d": "Kryta strzelnica Pod Ratuszem w Murowanej Goślinie - strzelania pneumatyczne w piątkowe wieczory.",
  "s": 8,
  "k": [
   "www",
   "godz",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "way/462205215",
  "n": "Klub Strzelecki Tarcza Szamotuły",
  "a": "Mutowo",
  "c": "Mutowo",
  "p": "powiat szamotulski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 606 348 597",
  "t2": "",
  "w": "https://tarcza-szamotuly.pl/",
  "f": "",
  "e": "ks.tarcza.szamotuly@wp.pl",
  "h": "",
  "d": "Strzelnica Klubu Strzeleckiego Tarcza Szamotuły w Mutowie - treningi i zawody sportowe.",
  "s": 8,
  "k": [
   "tel",
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/13626606161",
  "n": "2. (50m)",
  "a": "Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nieczajna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13625493704",
  "n": "3.  (40m)",
  "a": "Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nieczajna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13626609169",
  "n": "4. (16m)",
  "a": "Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nieczajna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13626606162",
  "n": "4. (50m)",
  "a": "Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nieczajna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13626609170",
  "n": "5. (15m)",
  "a": "Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nieczajna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13626609171",
  "n": "6. (13m)",
  "a": "Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nieczajna.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13626609172",
  "n": "7. (12m)",
  "a": "Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Nieczajna.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1486358276",
  "n": "Strzelnica Nieczajna",
  "a": "34, 64-606 Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 452 059 200",
  "t2": "",
  "w": "https://strzelnicanieczajna.pl/",
  "f": "",
  "e": "biuro@strzelnicanieczajna.pl",
  "h": "",
  "d": "Strzelnica Nieczajna - otwarty obiekt strzelecki w Wielkopolsce.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/1486359723",
  "n": "Strzelnica Sportowa Nieczajna 33",
  "a": "Nieczajna 34, 64-606 Nieczajna",
  "c": "Nieczajna",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa Nieczajna 33 - osie strzeleckie do treningów sportowych.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "node/10639563474",
  "n": "Strzelnica Dąbrówka Kościelna",
  "a": "Niedźwiedziny",
  "c": "Niedźwiedziny",
  "p": "powiat wągrowiecki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 602 387 519",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w Niedźwiedzinach koło Dąbrówki Kościelnej - obiekt otwarty.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "node/10965939147",
  "n": "Strzelnica Nowolipsk",
  "a": "59, 62-313 Nowolipsk",
  "c": "Nowolipsk",
  "p": "powiat pleszewski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 730 766 699",
  "t2": "",
  "w": "https://www.nowolipsk.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa Jóźwiak w Nowolipsku - treningi i strzelania komercyjne.",
  "s": 8,
  "k": [
   "tel",
   "www",
   "adres"
  ]
 },
 {
  "id": "node/11191540843",
  "n": "Strzelnica pneumatyczna LOK",
  "a": "Nowy Tomyśl",
  "c": "Nowy Tomyśl",
  "p": "powiat nowotomyski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa, prowadzona przez: LOK Organizacja Rejonowa im. Mieczysława Stefańczyka w Nowym Tomyślu.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/268478835",
  "n": "Strzelnica sportowa",
  "a": "Nowy Tomyśl",
  "c": "Nowy Tomyśl",
  "p": "powiat nowotomyski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa, prowadzona przez: Liga Obrony Kraju.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/625038987",
  "n": "Strzelnica KBS Opalenica",
  "a": "Parkowa 44, 64-330 Opalenica",
  "c": "Opalenica",
  "p": "powiat nowotomyski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 693 541 085",
  "t2": "",
  "w": "https://kbsopalenica.pl/",
  "f": "",
  "e": "kbs.opalenica@gmail.com",
  "h": "",
  "d": "Strzelać każdy może",
  "s": 10,
  "k": [
   "tel",
   "www",
   "adres",
   "mail",
   "opis"
  ]
 },
 {
  "id": "node/3789361838",
  "n": "Centrum Strzelectwa Sportowego TARCZA",
  "a": "Piła",
  "c": "Piła",
  "p": "powiat pilski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 673 533 995",
  "t2": "",
  "w": "",
  "f": "",
  "e": "sekretariat@tarczapila.pl",
  "h": "",
  "d": "Centrum Strzelectwa Sportowego TARCZA w Pile - strzelnica klubowa z sekcją sportową.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "node/11172993674",
  "n": "Kurkowe Bractwo Strzeleckie Pniewy",
  "a": "Pniewy",
  "c": "Pniewy",
  "p": "powiat szamotulski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Pniewy.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/982921516",
  "n": "Strzelnica KBS",
  "a": "Pniewy",
  "c": "Pniewy",
  "p": "powiat szamotulski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Pniewy.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/521099306",
  "n": "Strzelnica Bractwa Kurkowego",
  "a": "6a, 64-510 Szklarnia",
  "c": "Popowo",
  "p": "powiat szamotulski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Bractwa Kurkowego w Popowie - obiekt bracki z tradycyjnymi zawodami.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/1273555082",
  "n": "Strzelnica Konin",
  "a": "Potażniki",
  "c": "Potażniki",
  "p": "powiat koniński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 535 952 139",
  "t2": "",
  "w": "https://www.strzelnicakonin.pl/",
  "f": "",
  "e": "kontakt@strzelnicakonin.pl",
  "h": "",
  "d": "Strzelnica Ligi Obrony Kraju obsługująca Konin, położona w Potażnikach.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "node/8871767656",
  "n": "Dwór Grunwaldzki",
  "a": "Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 601 708 040",
  "t2": "",
  "w": "https://dwor-grunwaldzki.pl/",
  "f": "",
  "e": "info@dwor-grunwaldzki.pl",
  "h": "pon.-pt. 16-20",
  "d": "Strzelecki Klub Sportowy Dwór Grunwaldzki w Poznaniu - szkolenie dzieci i młodzieży oraz treningi w olimpijskich konkurencjach strzeleckich.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "godz",
   "mail",
   "opis"
  ]
 },
 {
  "id": "node/9990442023",
  "n": "Dwór Grunwaldzki",
  "a": "Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 601 708 040",
  "t2": "",
  "w": "https://dwor-grunwaldzki.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelecki Klub Sportowy Dwór Grunwaldzki w Poznaniu - szkolenie dzieci i młodzieży oraz treningi w olimpijskich konkurencjach strzeleckich.",
  "s": 6,
  "k": [
   "tel",
   "www"
  ]
 },
 {
  "id": "way/1191779185",
  "n": "Krąg 2",
  "a": "Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Poznań.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1162980461",
  "n": "Oś: Rogacz, Dzik 1-2, Zając 1-2",
  "a": "Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska, prowadzona przez: PZŁ.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/373895734",
  "n": "Strzelnica \"Magnum\"",
  "a": "Wincentego Witosa 45, 61-691 Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 618 487 896",
  "t2": "",
  "w": "https://www.strzelnica-magnum.pl/",
  "f": "",
  "e": "magnum@strzelnica-magnum.pl",
  "h": "pon. nieczynne; wt.-pt. 12-20; sob. 12-18; niedz. nieczynne",
  "d": "Kryta strzelnica Magnum w Poznaniu, działająca od 1991 roku; broń na miejscu lub własna.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "node/10060748244",
  "n": "Strzelnica WKS Grunwald",
  "a": "Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "https://wksgrunwaldsekcjastrzelecka.pl/strzelnica/",
  "f": "",
  "e": "palickimaciej@gmail.com",
  "h": "",
  "d": "Strzelnica sekcji strzeleckiej WKS Grunwald Poznań - treningi i zawody sportowe.",
  "s": 5,
  "k": [
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/9975718674",
  "n": "Strzelnica kryta KSK Pretor",
  "a": "Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 791 390 444",
  "t2": "",
  "w": "https://www.kskpretor.pl/strzelnice/kryta-strzelnica-w-poznaniu/",
  "f": "",
  "e": "poznan@kskpretor.pl",
  "h": "pon.-sob. 10-21; niedz. 12-18",
  "d": "Kryta strzelnica klubu KSK Pretor w Poznaniu przy ul. Dmowskiego - rezerwacja online, czynna codziennie.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "godz",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/10027035749",
  "n": "Strzelnica myśliwska Lizawka",
  "a": "Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 618 524 218",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/StrzelnicaLizawka",
  "e": "",
  "h": "pon. nieczynne; wt.-sob. 12-18; niedz. nieczynne",
  "d": "Strzelnica myśliwska Lizawka w Poznaniu - przystrzeliwanie broni i treningi myśliwych.",
  "s": 5,
  "k": [
   "tel",
   "godz"
  ]
 },
 {
  "id": "node/11807179221",
  "n": "Strzelnica pneumatyczna LOK",
  "a": "Poznań",
  "c": "Poznań",
  "p": "",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Poznań.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "way/537384662",
  "n": "Strzelnica Sportowo - Myśliwska",
  "a": "Przedlesie",
  "c": "Przedlesie",
  "p": "powiat międzychodzki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Przedlesie.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/12926668031",
  "n": "Strzelnica Robaczyn",
  "a": "Robaczyn",
  "c": "Robaczyn",
  "p": "powiat kościański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Robaczyn.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10109810878",
  "n": "Strzelnica Miejska Rogoźno",
  "a": "Rogoźno",
  "c": "Rogoźno",
  "p": "powiat obornicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 600 415 576",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/GROT-Rogoźno-421428321615095/",
  "e": "grot.rogozno@gmail.com",
  "h": "pon.-pt. nieczynne; sob.-niedz. 11-15",
  "d": "Strzelnica miejska w Rogoźnie, udostępniana w weekendy.",
  "s": 6,
  "k": [
   "tel",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1108306160",
  "n": "Strzelnica Bractwa Kurkowego",
  "a": "Rydzyna",
  "c": "Rydzyna",
  "p": "powiat leszczyński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica, wstęp po wcześniejszym uzgodnieniu.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/9990294550",
  "n": "Strzelnica KBS w Czarnkowie",
  "a": "Sarbka",
  "c": "Sarbka",
  "p": "powiat czarnkowsko-trzcianecki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 608 489 543",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "pon.-pt. 16-22; sob.-niedz. 10-22",
  "d": "Strzelnica Kurkowego Bractwa Strzeleckiego z Czarnkowa, położona w Sarbce; czynna codziennie.",
  "s": 5,
  "k": [
   "tel",
   "godz"
  ]
 },
 {
  "id": "node/9834287730",
  "n": "Strzelnica sportowa",
  "a": "Sierakowo",
  "c": "Sierakowo",
  "p": "powiat rawicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 451 560 008",
  "t2": "+48 605 583 119",
  "w": "https://bockrawicz.pl/",
  "f": "",
  "e": "bockrawicz@gmail.com",
  "h": "",
  "d": "Strzelnica sportowa Klubu Strzeleckiego BOCK w Sierakowie - strzelectwo kulowe i śrutowe.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/1090340920",
  "n": "Strzelnica im. Brata Teofila Dobkowicza",
  "a": "Sieraków",
  "c": "Sieraków",
  "p": "powiat międzychodzki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Sieraków.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1320956613",
  "n": "Strzelnica bractwa kurkowego",
  "a": "Skoki",
  "c": "Skoki",
  "p": "powiat wągrowiecki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Skoki.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10052996703",
  "n": "Strzelnica Shadow Gun",
  "a": "Skrzynki",
  "c": "Skrzynki",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 501 316 001",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/StrzelnicaShadowGun/",
  "e": "kontakt@shadowgun.pl",
  "h": "",
  "d": "Strzelnica Shadow Gun w Skrzynkach pod Poznaniem.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "node/11972236032",
  "n": "Strzelnica Klara",
  "a": "3A, 63-450 Sobótka",
  "c": "Sobótka",
  "p": "powiat ostrowski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 881 399 399",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/people/Strzelnica-sportowo-bojowa-Klara/61550726237901/",
  "e": "motel@motelklara.pl",
  "h": "",
  "d": "Strzelnica Klara w Sobótce - otwarty obiekt strzelecki.",
  "s": 6,
  "k": [
   "tel",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/843826783",
  "n": "Strzelnica Hubertus",
  "a": "Studzieniec",
  "c": "Studzieniec",
  "p": "powiat chodzieski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 672 820 922",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/hubertuschodziez/",
  "e": "biuro@hubertus-chodziez.pl",
  "h": "",
  "d": "Strzelnica Hubertus w Studzieńcu - obiekt myśliwsko-sportowy.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "node/9879524074",
  "n": "Strzelnica Tarnowo Podgórne",
  "a": "Tarnowo Podgórne",
  "c": "Tarnowo Podgórne",
  "p": "powiat poznański",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 604 561 505",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w Tarnowie Podgórnym pod Poznaniem - obiekt gminny.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "node/11663852409",
  "n": "Strzelnica Bryllandia",
  "a": "Witaszyce",
  "c": "Witaszyce",
  "p": "powiat jarociński",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 530 155 232",
  "t2": "",
  "w": "https://bryllandia.pl/strzelnica",
  "f": "",
  "e": "strzelnica@bryllandia.pl",
  "h": "pon. nieczynne; wt.-pt. 16-20; sob. 12-20; niedz. 14-20",
  "d": "Strzelnica w ośrodku rozrywki Bryllandia w Witaszycach - atrakcja dla gości ośrodka, czynna od wtorku do niedzieli.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1236404695",
  "n": "ProShoot strzelnica pneumatyczna",
  "a": "Wronki",
  "c": "Wronki",
  "p": "powiat szamotulski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 880 290 815",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "ProShoot we Wronkach - strzelnica pneumatyczna, strzelania z wiatrówki dla początkujących i dzieci.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "node/9983876870",
  "n": "Centrum Treningowe ESA",
  "a": "Włościejewki",
  "c": "Włościejewki",
  "p": "powiat śremski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 669 955 955",
  "t2": "",
  "w": "https://www.euseca.com/",
  "f": "",
  "e": "reception@euseca.com",
  "h": "",
  "d": "Centrum treningowe European Security Academy we Włościejewkach - szkolenia strzeleckie dla służb i firm.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "node/12188972172",
  "n": "KBS Zbaszyń strzelnica",
  "a": "Zbąszyń",
  "c": "Zbąszyń",
  "p": "powiat nowotomyski",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Zbąszyń.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/12612768097",
  "n": "Strzelnica Pestkownica",
  "a": "gmina Krzyż Wielkopolski",
  "c": "gmina Krzyż Wielkopolski",
  "p": "powiat czarnkowsko-trzcianecki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 502 606 847",
  "t2": "",
  "w": "https://pestkownica.com.pl/",
  "f": "",
  "e": "info@pestkownica.com.pl",
  "h": "",
  "d": "Strzelnica Pestkownica przy ośrodku wypoczynkowym w gminie Krzyż Wielkopolski.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/382275893",
  "n": "Strzelnica",
  "a": "Środa Wielkopolska",
  "c": "Środa Wielkopolska",
  "p": "powiat średzki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 887 200 449",
  "t2": "",
  "w": "http://www.bractwokurkowe.com.pl/",
  "f": "",
  "e": "ryszard.waligora@onet.pl",
  "h": "",
  "d": "Strzelnica Kurkowego Bractwa Strzeleckiego w Środzie Wielkopolskiej - zawody brackie i treningi.",
  "s": 8,
  "k": [
   "tel",
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/12046753869",
  "n": "Strzelnica śrutowa BOCK Rawicz",
  "a": "Żylice",
  "c": "Żylice",
  "p": "powiat rawicki",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Żylice.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/724277197",
  "n": "Strzelnica",
  "a": "Białogard",
  "c": "Białogard",
  "p": "powiat białogardzki",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Białogard.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1239608084",
  "n": "strzelnica",
  "a": "Boleszewo Kolonia",
  "c": "Boleszewo Kolonia",
  "p": "powiat sławieński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Boleszewo Kolonia.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/702391794",
  "n": "strzelnica",
  "a": "Brzeżno",
  "c": "Brzeżno",
  "p": "powiat świdwiński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Brzeżno.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10000111437",
  "n": "Vis Long Shooting",
  "a": "Golce",
  "c": "Golce",
  "p": "powiat wałecki",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 601 878 800",
  "t2": "",
  "w": "https://long-shooting.com/",
  "f": "",
  "e": "info@long-shooting.com",
  "h": "",
  "d": "Vis Long Shooting w Golcach - obiekt sportowo-rekreacyjny ze strzelnicą długodystansową.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/240370074",
  "n": "Strzelnica LOK",
  "a": "Marii Rodziewiczówny, 72-300 Gryfice",
  "c": "Gryfice",
  "p": "powiat gryficki",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Ligi Obrony Kraju w Gryficach - treningi klubowe.",
  "s": 3,
  "k": [
   "adres",
   "klub"
  ]
 },
 {
  "id": "way/627418770",
  "n": "Strzelnica łucznicza",
  "a": "Koszalin",
  "c": "Koszalin",
  "p": "",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Koszalin.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11243010142",
  "n": "Strzelnica Sportowa",
  "a": "Kołobrzeg",
  "c": "Kołobrzeg",
  "p": "powiat kołobrzeski",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 516 066 096",
  "t2": "",
  "w": "https://sport.kolobrzeg.pl/strona-3350-strzelnica_sportowa.html",
  "f": "",
  "e": "recepcja@mosir.kolobrzeg.pl",
  "h": "",
  "d": "Strzelnica sportowa MOSiR w Kołobrzegu - obiekt miejski, ogólnodostępny w wyznaczonych godzinach.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/680970697",
  "n": "Strzelnica myśliwska",
  "a": "Kulice",
  "c": "Kulice",
  "p": "powiat goleniowski",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Kulice.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1422787357",
  "n": "Strzelnica do strzelań z broni palnej",
  "a": "Kędrzyno",
  "c": "Kędrzyno",
  "p": "powiat kołobrzeski",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 516 066 096",
  "t2": "",
  "w": "https://www.kskolobrzeg.pl/",
  "f": "",
  "e": "kskolobrzeg@op.pl",
  "h": "",
  "d": "Strzelnica Klubu Strzeleckiego Kołobrzeg w Kędrzynie - strzelania z broni palnej i treningi klubowe.",
  "s": 8,
  "k": [
   "tel",
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/1467141002",
  "n": "Strzelnica",
  "a": "Lublino",
  "c": "Lublino",
  "p": "powiat stargardzki",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Lublino.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1436749263",
  "n": "Strzelnica",
  "a": "Mielenko Gryfińskie",
  "c": "Mielenko Gryfińskie",
  "p": "powiat gryfiński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Mielenko Gryfińskie.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1318946638",
  "n": "strzelnica",
  "a": "Pełczyce",
  "c": "Pełczyce",
  "p": "powiat choszczeński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Pełczyce.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1521921883",
  "n": "Strzelnica Postomino",
  "a": "Postomino",
  "c": "Postomino",
  "p": "powiat sławieński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Postomino.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/534535042",
  "n": "Strzelnica w Pucicach",
  "a": "Goleniowska, 72-105 Pucice",
  "c": "Pucice",
  "p": "powiat goleniowski",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 914 617 320",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w Pucicach pod Szczecinem - strzelania komercyjne i sportowe.",
  "s": 5,
  "k": [
   "tel",
   "adres"
  ]
 },
 {
  "id": "way/758754554",
  "n": "strzelnica",
  "a": "Stanomino",
  "c": "Stanomino",
  "p": "powiat białogardzki",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Stanomino.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/196485898",
  "n": "Strzelnica",
  "a": "Sułowo",
  "c": "Sułowo",
  "p": "powiat choszczeński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Sułowo.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/5505455175",
  "n": "Strzelnica 17-stka",
  "a": "Szczecin",
  "c": "Szczecin",
  "p": "",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Szczecin.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13888367551",
  "n": "Strzelnica Ramlewo VIS",
  "a": "Wierzbka Dolna",
  "c": "Wierzbka Dolna",
  "p": "powiat kołobrzeski",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica, wstęp po wcześniejszym uzgodnieniu.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/912380956",
  "n": "Strzelnica KMS Dragon Zdrójno",
  "a": "Zdrójno",
  "c": "Zdrójno",
  "p": "powiat choszczeński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Zadaszone stanowiska strzelnicze.",
  "s": 1,
  "k": [
   "opis"
  ]
 },
 {
  "id": "node/11423716323",
  "n": "Strzelnica STS",
  "a": "gmina Stare Czarnowo",
  "c": "gmina Stare Czarnowo",
  "p": "powiat gryfiński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 692 104 267",
  "t2": "",
  "w": "https://sts.org.pl/",
  "f": "",
  "e": "zarzad@sts.org.pl",
  "h": "",
  "d": "Strzelnica Szczecińskiego Towarzystwa Strzeleckiego w gminie Stare Czarnowo.",
  "s": 8,
  "k": [
   "tel",
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/13789088932",
  "n": "Strzelnica - Klub Strzelecki 44 Wyspy",
  "a": "Jachtowa 1, 72-600 Świnoujście",
  "c": "Świnoujście",
  "p": "",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Klubu Strzeleckiego 44 Wyspy w Świnoujściu - treningi klubowe, bez opłaty za wstęp.",
  "s": 3,
  "k": [
   "adres",
   "klub"
  ]
 },
 {
  "id": "way/820291956",
  "n": "Strzelnica Military Area",
  "a": "Żabów",
  "c": "Żabów",
  "p": "powiat pyrzycki",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica, dostępna dla klientów obiektu.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/4643789588",
  "n": "RP Centrum Strzeleckie",
  "a": "Wierzbińska 58, 95-070 Aleksandrów Łódzki",
  "c": "Aleksandrów Łódzki",
  "p": "powiat zgierski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 427 120 596",
  "t2": "",
  "w": "https://strzelnicarp.pl/",
  "f": "",
  "e": "kontakt@strzelnicarp.pl",
  "h": "pon. nieczynne; wt.-sob. 09-21; niedz. 10-20",
  "d": "Kryta strzelnica Centrum Strzeleckiego RP w Aleksandrowie Łódzkim, czynna od wtorku do niedzieli.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "way/1396236979",
  "n": "Strzelnica Wieruszów",
  "a": "Chobanin",
  "c": "Chobanin",
  "p": "powiat wieruszowski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Chobanin.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10009959458",
  "n": "Strzelnica Brygadier",
  "a": "Dobra",
  "c": "Dobra",
  "p": "powiat zgierski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 797 049 095",
  "t2": "",
  "w": "",
  "f": "",
  "e": "sskbrygadier@gmail.com",
  "h": "",
  "d": "Strzelnica Brygadier w Dobrej - otwarty obiekt strzelecki w Łódzkiem.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "relation/13076208",
  "n": "Strzelnica sportowa w Grabicy",
  "a": "Grabica",
  "c": "Grabica",
  "p": "powiat piotrkowski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica sportowa w miejscowości Grabica.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10873826772",
  "n": "Strzelnica Sportowa Panaszew",
  "a": "Józefka",
  "c": "Józefka",
  "p": "powiat poddębicki",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 607 670 170",
  "t2": "",
  "w": "https://www.rcspanaszew.pl/",
  "f": "",
  "e": "biuro@rcspanaszew.pl",
  "h": "pon.-pt. 16-20 ; sob.-niedz. 10-20",
  "d": "Kryta strzelnica RCS Panaszew - szkolenia, pakiety strzeleckie i treningi indywidualne z instruktorem.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "godz",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/10210548988",
  "n": "Stone Range",
  "a": "Kamień",
  "c": "Kamień",
  "p": "powiat brzeziński",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 505 191 997",
  "t2": "",
  "w": "https://stonerange.pl/",
  "f": "",
  "e": "info@stonerange.pl",
  "h": "",
  "d": "Stone Range w Kamieniu - strzelnica z ofertą dla początkujących i zaawansowanych.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/473277009",
  "n": "Go-System Military Club",
  "a": "Karolew",
  "c": "Karolew",
  "p": "powiat zgierski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 502 095 369",
  "t2": "",
  "w": "http://www.go-system.pl/",
  "f": "",
  "e": "go.rybcia@gmail.com",
  "h": "",
  "d": "Go-System Military Club w Karolewie - strzelnica i szkolenia o profilu taktycznym.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "way/1314368698",
  "n": "Klub Strzelectwa Sportowego \"Orzeł\"",
  "a": "Majdany 12, 99-300 Kutno",
  "c": "Kutno",
  "p": "powiat kutnowski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Klub Strzelectwa Sportowego Orzeł w Kutnie - treningi i zawody klubowe.",
  "s": 3,
  "k": [
   "adres",
   "klub"
  ]
 },
 {
  "id": "node/9680018199",
  "n": "Strzelnica LOK",
  "a": "Podlas",
  "c": "Leopoldów",
  "p": "powiat rawski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa - Leopoldów.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/6805872885",
  "n": "Strzelnica Błysk",
  "a": "Opoczno",
  "c": "Opoczno",
  "p": "powiat opoczyński",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 536 219 087",
  "t2": "",
  "w": "",
  "f": "",
  "e": "strzelnica@strzelnicaopoczno.pl",
  "h": "",
  "d": "Strzelnica Błysk w Opocznie - strzelania rekreacyjne i sportowe.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "way/179712228",
  "n": "Strzelnica sportowa",
  "a": "Ozorków",
  "c": "Ozorków",
  "p": "powiat zgierski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa - Ozorków.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11449261814",
  "n": "Strzelnica Shooting Academy",
  "a": "Parzęczew",
  "c": "Parzęczew",
  "p": "powiat zgierski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 602 221 507",
  "t2": "",
  "w": "https://shooting-academy.pl/",
  "f": "",
  "e": "kontakt@shooting-academy.pl",
  "h": "",
  "d": "Strzelnica Shooting Academy w Parzęczewie: osie od 15 do 100 m, zawody pistoletowe, karabinowe i IPSC, sprzedaż broni.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "mail"
  ]
 },
 {
  "id": "node/12324563744",
  "n": "Strzelnica Baszta",
  "a": "Pociecha",
  "c": "Pociecha",
  "p": "powiat łęczycki",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Pociecha.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/699193492",
  "n": "Strzelnica Gminna Jasień",
  "a": "Przyborów",
  "c": "Przyborów",
  "p": "powiat radomszczański",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica - Przyborów.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/1274227791",
  "n": "Strzelnica LOK",
  "a": "Radomsko",
  "c": "Radomsko",
  "p": "powiat radomszczański",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "https://rykoszetlok.pl/",
  "f": "",
  "e": "biuro@rykoszetlok.pl",
  "h": "",
  "d": "Strzelnica klubu Rykoszet LOK w Radomsku - treningi i zawody klubowe.",
  "s": 5,
  "k": [
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/10819931509",
  "n": "Strzelnica sportowa",
  "a": "Sulmierzyce",
  "c": "Sulmierzyce",
  "p": "powiat pajęczański",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 446 852 580",
  "t2": "",
  "w": "https://sulmierzyce.info/strzelnica/",
  "f": "",
  "e": "strzelnica@sulmierzyce.eu",
  "h": "pon. 08-14; wt. 08-20; śr.-pt. 08-20 ; sob. 09-13; niedz. nieczynne",
  "d": "Strzelnica sportowa gminy Sulmierzyce, czynna od poniedziałku do soboty.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/11076330631",
  "n": "Salwa",
  "a": "Szczerców",
  "c": "Szczerców",
  "p": "powiat bełchatowski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica - Szczerców.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/256663796",
  "n": "Strzelnica",
  "a": "Świętego Antoniego 114, 97-200 Tomaszów Mazowiecki",
  "c": "Tomaszów Mazowiecki",
  "p": "powiat tomaszowski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica 18 stanowiskowa w okrytej hali.Os 60 m.",
  "s": 3,
  "k": [
   "adres",
   "opis"
  ]
 },
 {
  "id": "node/9446424868",
  "n": "Strzelnica pneumatyczna",
  "a": "Wójcin",
  "c": "Wójcin",
  "p": "powiat wieruszowski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Wójcin.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/720936421",
  "n": "Strzelnica Góra Chełmo - Omnis Arma",
  "a": "Zagórze",
  "c": "Zagórze",
  "p": "powiat radomszczański",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Zagórze.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/10026967398",
  "n": "Strzelnica Poligon",
  "a": "Zapady",
  "c": "Zapady",
  "p": "powiat skierniewicki",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 603 940 523",
  "t2": "",
  "w": "https://www.strzelnicapoligon.pl/",
  "f": "",
  "e": "przemek@strzelnicapoligon.pl",
  "h": "08-21",
  "d": "Strzelnica Poligon w Zapadach - otwarty obiekt czynny codziennie od rana do wieczora.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/12987968703",
  "n": "Bunkier",
  "a": "Łaska 5, 98-220 Zduńska Wola",
  "c": "Zduńska Wola",
  "p": "powiat zduńskowolski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Bunkier w Zduńskiej Woli - strzelania komercyjne.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/294742543",
  "n": "Szkolny Klub Strzelectwa Sportowego Sokół",
  "a": "Szadkowska 16a, 98-220 Zduńska Wola",
  "c": "Zduńska Wola",
  "p": "powiat zduńskowolski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Szkolny Klub Strzelectwa Sportowego Sokół w Zduńskiej Woli - treningi młodzieży i zawody.",
  "s": 3,
  "k": [
   "adres",
   "klub"
  ]
 },
 {
  "id": "way/1046481506",
  "n": "Shotbom",
  "a": "Wrzosowa 35, 98-100 Łask",
  "c": "Łask",
  "p": "powiat łaski",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Shotbom w Łasku - strzelania rekreacyjne i sportowe.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/738541894",
  "n": "Klub Strzelecki LOK „Dziesiątka”",
  "a": "Łódź",
  "c": "Łódź",
  "p": "",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "https://ksdziesiatka.pl/",
  "f": "",
  "e": "biuro@ksdziesiatka.pl",
  "h": "",
  "d": "Klub Strzelecki LOK Dziesiątka w Łodzi - treningi klubowe i zawody.",
  "s": 5,
  "k": [
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "node/13343054620",
  "n": "Top Shot",
  "a": "Bartnicza 1/7, 92-612 Łódź",
  "c": "Łódź",
  "p": "",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sieci Top Shot w Łodzi - strzelania komercyjne przy sklepie z bronią.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "node/11663811931",
  "n": "Strzelnica Gun Club",
  "a": "Bielsko-Biała",
  "c": "Bielsko-Biała",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 730 001 914",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/strzelnicabielsko/",
  "e": "biuro@strzelnicabielsko.pl",
  "h": "pon.-wt. 16-20; śr. nieczynne; czw.-niedz. 16-20",
  "d": "Strzelnica Gun Club w Bielsku-Białej - strzelania popołudniowe przez sześć dni w tygodniu.",
  "s": 6,
  "k": [
   "tel",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/193557588",
  "n": "Strzelnica Sportowa",
  "a": "Bieruń",
  "c": "Bieruń",
  "p": "powiat bieruńsko-lędziński",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Bieruń.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/3511696835",
  "n": "Strzelnica EMJOT",
  "a": "Aleja Harcerska 3b, 41-500 Chorzów",
  "c": "Chorzów",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica EMJOT w Parku Śląskim w Chorzowie - strzelania rekreacyjne i sportowe.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "node/10669872241",
  "n": "Strzelnica Hajduki",
  "a": "Stalowa 17/Budynek 43, 41-506 Chorzów",
  "c": "Chorzów",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 325 065 061",
  "t2": "",
  "w": "https://strzelnicahajduki.pl",
  "f": "",
  "e": "biuro@strzelnicahajduki.pl",
  "h": "pon.-pt. 16-21; sob.,niedz. 12-20",
  "d": "Kryta strzelnica Hajduki w Chorzowie - dobre miejsce na start w strzelectwie sportowym, czynna codziennie.",
  "s": 13,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail",
   "kryta"
  ]
 },
 {
  "id": "node/12593137451",
  "n": "Strzelnica Myśliwska",
  "a": "Chybie",
  "c": "Chybie",
  "p": "powiat cieszyński",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 601 575 931",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w Chybiu - przystrzeliwanie broni i treningi myśliwych.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "way/863411643",
  "n": "Strzelnica sportowa",
  "a": "Częstochowa",
  "c": "Częstochowa",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Częstochowa.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11509598533",
  "n": "Strzelnica Snajper",
  "a": "Warszawska 35, 44-100 Gliwice",
  "c": "Gliwice",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 663 342 710",
  "t2": "",
  "w": "http://www.strzelnica-snajper.gliwice.pl/",
  "f": "",
  "e": "zssnajper@interia.pl",
  "h": "pon.-pt. 10-21; sob. 10-20; niedz. 10-18",
  "d": "Strzelnica Snajper w Gliwicach - obiekt otwarty dla każdego, czynny siedem dni w tygodniu.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "godz",
   "adres",
   "mail"
  ]
 },
 {
  "id": "way/216657693",
  "n": "Strzelnica Hubertech",
  "a": "Jaworzno",
  "c": "Jaworzno",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 661 355 571",
  "t2": "",
  "w": "https://www.strzelnicahubertech.pl/",
  "f": "",
  "e": "strzelnica@hubertech.pl",
  "h": "pon.-pt. 10-20; sob. 09-19; niedz. nieczynne",
  "d": "Strzelnica Hubertech w Jaworznie: kursy na patent strzelecki, strzelectwo dynamiczne, zawody i imprezy integracyjne.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "way/1042751747",
  "n": "Strzelnica LOK Jaworzno",
  "a": "Jaworzno",
  "c": "Jaworzno",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w miejscowości Jaworzno.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/8089568250",
  "n": "Strzelnica Silesia Shotgun",
  "a": "Katowice",
  "c": "Katowice",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 660 700 408",
  "t2": "",
  "w": "https://strzelnica-katowice.pl/",
  "f": "",
  "e": "kontakt@strzelnica-katowice.pl",
  "h": "12-21",
  "d": "Strzelnica Silesia Shotgun przy ul. Żelaznej w Katowicach - dla początkujących i zawodowców, czynna codziennie.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/11375589135",
  "n": "Strzelnica sportowa Krywałd-Lignoza",
  "a": "Knurów",
  "c": "Knurów",
  "p": "powiat gliwicki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "https://silesiasuperior.org.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa Krywałd-Lignoza w Knurowie - obiekt stowarzyszenia strzeleckiego.",
  "s": 3,
  "k": [
   "www"
  ]
 },
 {
  "id": "way/720042463",
  "n": "Strzelnica Myśliwska",
  "a": "Kochcice",
  "c": "Kochcice",
  "p": "powiat lubliniecki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska w miejscowości Kochcice.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/720042464",
  "n": "Strzelnica Sportowa",
  "a": "Kochcice",
  "c": "Kochcice",
  "p": "powiat lubliniecki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Kochcice.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/720042455",
  "n": "Strzelnica Taktyczna",
  "a": "Kochcice",
  "c": "Kochcice",
  "p": "powiat lubliniecki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Kochcice.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/6370640284",
  "n": "Strzelnica sportowa",
  "a": "Poręba",
  "c": "Poręba",
  "p": "powiat zawierciański",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Poręba.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/802289909",
  "n": "Strzelnica \"TARGET ALFA SILESIA\"",
  "a": "Przyszowice",
  "c": "Przyszowice",
  "p": "powiat gliwicki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Przyszowice.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/861149850",
  "n": "Strzelnica sportowa Dzierżno",
  "a": "Pyskowice",
  "c": "Pyskowice",
  "p": "powiat gliwicki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 693 359 599",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/people/Strzelnica-sportowa-Dzierżno/100040873852760/",
  "e": "s.czarnobil@op.pl",
  "h": "pon.-sob. 09-17; niedz. nieczynne",
  "d": "Strzelnica sportowa Dzierżno w Pyskowicach, czynna od poniedziałku do soboty.",
  "s": 6,
  "k": [
   "tel",
   "godz",
   "mail"
  ]
 },
 {
  "id": "node/6329513860",
  "n": "Strzelnica LOK",
  "a": "Ruda Śląska",
  "c": "Ruda Śląska",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "https://strzelaj.org",
  "f": "",
  "e": "pytania@strzelaj.org",
  "h": "",
  "d": "Klub Strzelecki LOK Legion Silesia w Rudzie Śląskiej - treningi i zawody klubowe.",
  "s": 5,
  "k": [
   "www",
   "mail",
   "klub"
  ]
 },
 {
  "id": "way/301634422",
  "n": "Strzelnica MKS LOK Rybnik",
  "a": "Rybnik",
  "c": "Rybnik",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 690 664 873",
  "t2": "",
  "w": "https://mks-lok.rybnik.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica MKS LOK w Rybniku - treningi sportowe i strzelania klubowe.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "klub"
  ]
 },
 {
  "id": "node/2185585736",
  "n": "Strzelnica PZŁ",
  "a": "Siemianowice Śląskie",
  "c": "Siemianowice Śląskie",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 322 203 835",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/strzelnicasiemianowice/",
  "e": "strzelnicasiemianowice@wp.pl",
  "h": "",
  "d": "Strzelnica Polskiego Związku Łowieckiego w Siemianowicach Śląskich - treningi myśliwskie.",
  "s": 4,
  "k": [
   "tel",
   "mail"
  ]
 },
 {
  "id": "way/719044457",
  "n": "Strzelnica Sportowa",
  "a": "Sieraków Śląski",
  "c": "Sieraków Śląski",
  "p": "powiat lubliniecki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Sieraków Śląski.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/5489324436",
  "n": "Strzelnica",
  "a": "Sosnowiec",
  "c": "Sosnowiec",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "https://strzelnica.net.pl/",
  "f": "",
  "e": "strzelnica@o2.pl",
  "h": "",
  "d": "Strzelnica w Sosnowcu - pakiety obejmujące broń, amunicję, tarcze i opiekę instruktora.",
  "s": 4,
  "k": [
   "www",
   "mail"
  ]
 },
 {
  "id": "node/10225974646",
  "n": "Strzelnica sportowa PHU Matuszek",
  "a": "Syrynia",
  "c": "Syrynia",
  "p": "powiat wodzisławski",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Syrynia.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11755018869",
  "n": "Strzelnica Szczejkowice",
  "a": "Szczejkowice",
  "c": "Szczejkowice",
  "p": "powiat rybnicki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Otwarta strzelnica w miejscowości Szczejkowice.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/11968725474",
  "n": "Strzelnica Sportowa",
  "a": "Sławków",
  "c": "Sławków",
  "p": "powiat będziński",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa - Sławków.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/791377518",
  "n": "Strzelnica sportowa",
  "a": "Wodzisław Śląski",
  "c": "Wodzisław Śląski",
  "p": "powiat wodzisławski",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w miejscowości Wodzisław Śląski.",
  "s": 0,
  "k": []
 },
 {
  "id": "node/13311783679",
  "n": "Strzelnica Woźniki 39",
  "a": "Woźniki",
  "c": "Woźniki",
  "p": "powiat lubliniecki",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 690 524 516",
  "t2": "",
  "w": "",
  "f": "https://www.facebook.com/profile.php?id=61583845559956",
  "e": "",
  "h": "",
  "d": "Strzelnica Woźniki 39 - otwarty obiekt strzelecki na Śląsku.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "way/298012410",
  "n": "Strzelnica kulowa Dębina",
  "a": "Żory",
  "c": "Żory",
  "p": "",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "",
  "t2": "",
  "w": "https://www.kbszory.pl/obiekty-bractwa/strzelnica-kulowa-debina/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Zadaszona strzelnica kulowa Dębina Kurkowego Bractwa Strzeleckiego w Żorach; wstęp płatny, dla klientów obiektu.",
  "s": 6,
  "k": [
   "www",
   "kryta",
   "klub"
  ]
 },
 {
  "id": "node/6716937133",
  "n": "UMKS Snajper",
  "a": "Kielce",
  "c": "Kielce",
  "p": "",
  "r": "swietokrzyskie",
  "rw": "świętokrzyskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Kryta strzelnica w miejscowości Kielce.",
  "s": 2,
  "k": [
   "kryta"
  ]
 },
 {
  "id": "way/334226494",
  "n": "Strzelnica Sportowa",
  "a": "Grodziskowa, 28-400 Pińczów",
  "c": "Pińczów",
  "p": "powiat pińczowski",
  "r": "swietokrzyskie",
  "rw": "świętokrzyskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica sportowa w Pińczowie - treningi i zawody klubowe.",
  "s": 2,
  "k": [
   "adres"
  ]
 },
 {
  "id": "way/941405529",
  "n": "Strzelnica Skotniki Małe",
  "a": "Skotniki Małe",
  "c": "Skotniki Małe",
  "p": "powiat buski",
  "r": "swietokrzyskie",
  "rw": "świętokrzyskie",
  "t": "+48 797 191 851",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w Skotnikach Małych - dostęp dla klientów obiektu.",
  "s": 3,
  "k": [
   "tel"
  ]
 },
 {
  "id": "way/321974105",
  "n": "strzelnica K.S. \"Świt Starachowice\"",
  "a": "Starachowice",
  "c": "Starachowice",
  "p": "powiat starachowicki",
  "r": "swietokrzyskie",
  "rw": "świętokrzyskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa, prowadzona przez: Klub Sportowy Świt Starachowice.",
  "s": 1,
  "k": [
   "klub"
  ]
 },
 {
  "id": "node/13910079934",
  "n": "100m",
  "a": "Wąchock",
  "c": "Wąchock",
  "p": "powiat starachowicki",
  "r": "swietokrzyskie",
  "rw": "świętokrzyskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w miejscowości Wąchock.",
  "s": 0,
  "k": []
 },
 {
  "id": "way/322326048",
  "n": "strzelnica myśliwska PZŁ",
  "a": "Wąchock",
  "c": "Wąchock",
  "p": "powiat starachowicki",
  "r": "swietokrzyskie",
  "rw": "świętokrzyskie",
  "t": "",
  "t2": "",
  "w": "",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska, prowadzona przez: Polski Związek Łowiectwa.",
  "s": 0,
  "k": []
 },
 {
  "id": "web/strzelnica-c4-guns-lodz",
  "n": "Strzelnica C4 Guns",
  "a": "Łódź",
  "c": "Łódź",
  "p": "Łódź",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 507 058 414",
  "t2": "",
  "w": "https://c4guns.pl/strzelnica",
  "f": "",
  "e": "",
  "h": "",
  "d": "Kryta strzelnica komercyjna z rezerwacją terminu online, pakietami strzeleckimi i wynajmem broni dla osób bez pozwolenia.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-lodzka-centrum-szkolenia-strzeleckiego-lodz",
  "n": "Strzelnica Łódzka - Centrum Szkolenia Strzeleckiego",
  "a": "ul. Brzezińska 1/3, 92-119 Łódź",
  "c": "Łódź",
  "p": "Łódź",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 426 742 754",
  "t2": "",
  "w": "https://strzelnicalodzka.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Kryta strzelnica bojowa i centrum szkolenia strzeleckiego; strzelania indywidualne, grupowe i szkolenia, także dla firm.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/top-shot-sklep-i-strzelnica-lodz",
  "n": "TOP SHOT - sklep i strzelnica",
  "a": "ul. Bartnicza 1/7, 91-850 Łódź",
  "c": "Łódź",
  "p": "Łódź",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 534 988 881",
  "t2": "",
  "w": "https://top-shot.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica połączona ze sklepem z bronią; druga lokalizacja przy ul. Okopowej. Strzelania komercyjne i dla posiadaczy własnej broni.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/kolimator-strzelnica-lodz-lodz",
  "n": "Kolimator - strzelnica Łódź",
  "a": "ul. Rzgowska 17a, 93-008 Łódź",
  "c": "Łódź",
  "p": "Łódź",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 694 363 603",
  "t2": "",
  "w": "https://kolimator.com.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Klub i strzelnica prowadząca szkolenia dla ubiegających się o pozwolenie na broń oraz strzelania rekreacyjne.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/black-raven-shooting-club-lodz",
  "n": "Black Raven Shooting Club",
  "a": "ul. Podchorążych 116, 94-234 Łódź",
  "c": "Łódź",
  "p": "Łódź",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 739 016 667",
  "t2": "",
  "w": "https://strzelnicabrsc.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Klub strzelecki ze strzelnicą krytą, pakietami dla początkujących i treningami dla posiadaczy własnej broni.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/snajper-szkolenia-strzeleckie-lodz",
  "n": "SNAJPER Szkolenia Strzeleckie",
  "a": "ul. Dowborczyków 17, 90-019 Łódź",
  "c": "Łódź",
  "p": "Łódź",
  "r": "lodzkie",
  "rw": "łódzkie",
  "t": "+48 511 585 116",
  "t2": "",
  "w": "https://snajperlodz.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Ośrodek szkoleń strzeleckich: kursy na pozwolenie na broń, pakiety strzeleckie i imprezy firmowe.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/lubelskie-centrum-strzeleckie-lcs-lublin",
  "n": "Lubelskie Centrum Strzeleckie (LCS)",
  "a": "ul. Metalurgiczna 3, 20-234 Lublin",
  "c": "Lublin",
  "p": "Lublin",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 720 811 820",
  "t2": "",
  "w": "https://lcs.lublin.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Kryta strzelnica z rezerwacją online, pakietami dla osób bez pozwolenia i wynajmem stanowisk dla posiadaczy własnej broni.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-schron-lublin",
  "n": "Strzelnica SCHRON",
  "a": "ul. Mariana Smoluchowskiego 1, 20-474 Lublin",
  "c": "Lublin",
  "p": "Lublin",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 530 065 066",
  "t2": "",
  "w": "https://schron-lublin.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica komercyjna z pakietami zależnymi od rodzaju broni i liczby strzałów; w cenie opieka instruktora i ochronniki.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-km-lublin",
  "n": "Strzelnica „KM”",
  "a": "Lublin",
  "c": "Lublin",
  "p": "Lublin",
  "r": "lubelskie",
  "rw": "lubelskie",
  "t": "+48 889 731 458",
  "t2": "",
  "w": "https://www.strzelnica.lublin.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica z pakietem wprowadzającym dla początkujących: godzina na stanowisku z bronią i instruktorem.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-kielce-centrum-strzeleckie-kielce",
  "n": "Strzelnica Kielce - Centrum Strzeleckie",
  "a": "ul. Kusocińskiego 61A, 25-045 Kielce",
  "c": "Kielce",
  "p": "Kielce",
  "r": "swietokrzyskie",
  "rw": "świętokrzyskie",
  "t": "+48 412 020 555",
  "t2": "",
  "w": "https://www.strzelnica-cskielce.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica z bronią palną sportową i bojową, szkoleniami oraz strzelaniami dla osób bez pozwolenia.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-sls-kielce-kielce",
  "n": "Strzelnica SLS Kielce",
  "a": "ul. Nowaka-Jeziorańskiego 53, 25-432 Kielce",
  "c": "Kielce",
  "p": "Kielce",
  "r": "swietokrzyskie",
  "rw": "świętokrzyskie",
  "t": "",
  "t2": "",
  "w": "https://slskielce.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Kryta strzelnica prowadzona w ramach Szkolnej Ligi Strzeleckiej - zawody i treningi młodzieży, także strzelania otwarte.",
  "s": 8,
  "k": [
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/akademia-strzelecka-ragun-radom",
  "n": "Akademia Strzelecka Ragun",
  "a": "Radom",
  "c": "Radom",
  "p": "Radom",
  "r": "mazowieckie",
  "rw": "mazowieckie",
  "t": "+48 733 749 011",
  "t2": "",
  "w": "https://ragun.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Szkolenia strzeleckie i nauka strzelania w Radomiu i Kielcach; zajęcia odbywają się na strzelnicach partnerskich.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-czestochowa-css-czestochowa",
  "n": "Strzelnica Częstochowa - CSS",
  "a": "ul. św. Andrzeja 8/10, 42-200 Częstochowa",
  "c": "Częstochowa",
  "p": "Częstochowa",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 605 129 909",
  "t2": "",
  "w": "https://strzelnicaczestochowa.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Częstochowskiego Stowarzyszenia Strzeleckiego; klub z licencją PZSS, treningi i strzelania komercyjne.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-emjot-chorzow",
  "n": "Strzelnica EMJOT",
  "a": "aleja Harcerska 3b, 41-500 Chorzów",
  "c": "Chorzów",
  "p": "Chorzów",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 322 412 945",
  "t2": "",
  "w": "https://strzelnica.com.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica w Parku Śląskim, prowadzona od lat przez firmę EMJOT - strzelania rekreacyjne i sportowe.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-sportowa-strzelam-bo-lubie-czechowice-dziedzice",
  "n": "Strzelnica Sportowa STRZELAM BO LUBIĘ",
  "a": "ul. Norberta Barlickiego 30A, 43-502 Czechowice-Dziedzice",
  "c": "Czechowice-Dziedzice",
  "p": "powiat bielski",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 452 380 319",
  "t2": "",
  "w": "https://strzelambolubie.eu/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Oś 25 m z sześcioma stanowiskami i automatycznymi transporterami tarcz; obsługuje strzelców z Bielska-Białej, Katowic i Rybnika.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/klub-strzelecki-lok-ermador-bielsko-biala",
  "n": "Klub Strzelecki LOK Ermador",
  "a": "ul. Filarowa 52, 43-300 Bielsko-Biała",
  "c": "Bielsko-Biała",
  "p": "Bielsko-Biała",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 791 940 515",
  "t2": "",
  "w": "https://strzelnica-bielsko.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Klub strzelecki LOK ze strzelnicą, treningami, zawodami i wynajmem stanowisk.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "adres",
   "klub",
   "opis"
  ]
 },
 {
  "id": "web/klub-strzelecki-skaut-bielsko-biala",
  "n": "Klub Strzelecki SKAUT",
  "a": "ul. Piastowska 22, 43-300 Bielsko-Biała",
  "c": "Bielsko-Biała",
  "p": "Bielsko-Biała",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 792 792 721",
  "t2": "",
  "w": "https://ksskaut.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Klub strzelecki zrzeszający zawodników i kandydatów na patent strzelecki; treningi pod okiem instruktorów.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "adres",
   "klub",
   "opis"
  ]
 },
 {
  "id": "web/gun-club-polska-bielsko-biala",
  "n": "Gun Club Polska",
  "a": "ul. 1 Maja 19, 43-300 Bielsko-Biała",
  "c": "Bielsko-Biała",
  "p": "Bielsko-Biała",
  "r": "slaskie",
  "rw": "śląskie",
  "t": "+48 574 974 435",
  "t2": "",
  "w": "https://www.gunclubpolska.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica komercyjna dostępna bez pozwolenia na broń, strzelania z instruktorem; klub prowadzi też obiekt w Rzeszowie.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/malawa-fun-park-strzelnica-rzeszow",
  "n": "Malawa Fun Park - strzelnica",
  "a": "ul. Frezji 1, 35-604 Rzeszów",
  "c": "Rzeszów",
  "p": "Rzeszów",
  "r": "podkarpackie",
  "rw": "podkarpackie",
  "t": "+48 791 486 431",
  "t2": "",
  "w": "https://malawafunpark.pl/strzelnica",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelanie z wiatrówki i z łuku oraz paintball statyczny - oferta rekreacyjna, także dla dzieci. Nie jest to strzelnica broni palnej.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/klub-strzelecki-krokus-lok-nowy-sacz",
  "n": "Klub Strzelecki KROKUS LOK",
  "a": "ul. Tarnowska 32, 33-300 Nowy Sącz",
  "c": "Nowy Sącz",
  "p": "Nowy Sącz",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "",
  "t2": "",
  "w": "https://ks-krokus.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Klub strzelecki LOK z własną strzelnicą, instruktorami i szerokim wyborem broni do strzelań.",
  "s": 7,
  "k": [
   "www",
   "adres",
   "klub",
   "opis"
  ]
 },
 {
  "id": "web/shooting-cracow-krakow",
  "n": "Shooting Cracow",
  "a": "Kraków",
  "c": "Kraków",
  "p": "Kraków",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 721 000 505",
  "t2": "",
  "w": "https://www.shootingcracow.com/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica komercyjna z pakietami strzeleckimi, obsługą w języku angielskim i szkoleniem bezpieczeństwa przed strzelaniem.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/kocham-bron-strzelnica-krakow",
  "n": "Kocham Broń - strzelnica",
  "a": "ul. Golikówka 12N, 30-723 Kraków",
  "c": "Kraków",
  "p": "Kraków",
  "r": "malopolskie",
  "rw": "małopolskie",
  "t": "+48 790 738 900",
  "t2": "",
  "w": "https://kochambron.pl/strzelnica/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica przy sklepie z bronią; strzelania komercyjne, szkolenia i pomoc w drodze po pozwolenie na broń.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-falkona-lutomia-gorna",
  "n": "Strzelnica Falkona",
  "a": "Lutomia Górna",
  "c": "Lutomia Górna",
  "p": "powiat świdnicki",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 662 617 519",
  "t2": "",
  "w": "https://strzelnicafalkona.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica pod Świdnicą (Lutomia Górna), obsługująca też Wrocław, Dzierżoniów i Wałbrzych; dojazd drogą gruntową od Bojanic.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-burza-brzeg-dolny",
  "n": "Strzelnica Burza",
  "a": "Brzeg Dolny",
  "c": "Brzeg Dolny",
  "p": "powiat wołowski",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 886 174 224",
  "t2": "",
  "w": "https://strzelnicaburza.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica pod Wrocławiem z pakietami strzeleckimi i voucherami prezentowymi.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-reload-wroclaw",
  "n": "Strzelnica RELOAD",
  "a": "Wrocław",
  "c": "Wrocław",
  "p": "Wrocław",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 792 011 696",
  "t2": "",
  "w": "https://strzelnicareload.pl/wroclaw/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Wrocławski oddział strzelnicy RELOAD - pakiety strzeleckie z bronią i instruktorem, rezerwacja telefoniczna lub mailowa.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-subiekt-gdanska-strzelnica-gdansk",
  "n": "Strzelnica Subiekt - Gdańska Strzelnica",
  "a": "Gdańsk",
  "c": "Gdańsk",
  "p": "Gdańsk",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "+48 585 730 630",
  "t2": "",
  "w": "https://www.strzelnicagdansk.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica przy akademii szkoleniowej Subiekt - strzelania komercyjne, kursy i szkolenia z bronią palną.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/lok-gdansk-strzelnica-gdansk",
  "n": "LOK Gdańsk - strzelnica",
  "a": "Gdańsk",
  "c": "Gdańsk",
  "p": "Gdańsk",
  "r": "pomorskie",
  "rw": "pomorskie",
  "t": "",
  "t2": "",
  "w": "https://lokgdansk.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica Ligi Obrony Kraju: kursy strzeleckie, zawody i strzelania dla grup zorganizowanych.",
  "s": 5,
  "k": [
   "www",
   "klub",
   "opis"
  ]
 },
 {
  "id": "web/klub-strzelectwa-sportowego-legion-wschodni-turosn-koscielna",
  "n": "Klub Strzelectwa Sportowego Legion Wschodni",
  "a": "ul. Białostocka 7, 18-106 Turośń Kościelna",
  "c": "Turośń Kościelna",
  "p": "powiat białostocki",
  "r": "podlaskie",
  "rw": "podlaskie",
  "t": "+48 575 531 347",
  "t2": "",
  "w": "https://legionwschodni.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Duży obiekt pod Białymstokiem: dziewięć osi strzeleckich na dystansach 200, 100, 50 i 6×30 m. Rezerwacja przez formularz.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "adres",
   "klub",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-kryta-unia-koszalin-koszalin",
  "n": "Strzelnica kryta Unia Koszalin",
  "a": "ul. Szczecińska 27D, Koszalin",
  "c": "Koszalin",
  "p": "Koszalin",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 607 456 481",
  "t2": "",
  "w": "https://www.unia.koszalin.pl/index.php/strzelnica",
  "f": "",
  "e": "",
  "h": "",
  "d": "Dwie czterostanowiskowe osie do strzelań z broni krótkiej i gładkolufowej oraz oś pneumatyczna; comiesięczne zawody otwarte.",
  "s": 11,
  "k": [
   "tel",
   "www",
   "adres",
   "kryta",
   "opis"
  ]
 },
 {
  "id": "web/sfcobra-strzelnica-i-szkolenia-koszalin",
  "n": "SFCobra - strzelnica i szkolenia",
  "a": "Koszalin",
  "c": "Koszalin",
  "p": "Koszalin",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 503 575 272",
  "t2": "",
  "w": "https://sfcobra.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Nauka strzelania i przygotowanie do pozwolenia na broń w rejonie Koszalina.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/osrodek-szkolenia-gt-delve-szczecin",
  "n": "Ośrodek Szkolenia GT Delve",
  "a": "Szczecin",
  "c": "Szczecin",
  "p": "Szczecin",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 601 727 212",
  "t2": "",
  "w": "https://strzelnicaszczecin.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Ośrodek szkolenia strzeleckiego w Szczecinie: strzelania komercyjne i kursy dla ubiegających się o pozwolenie.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-falcon-group-poznan",
  "n": "Strzelnica Falcon Group",
  "a": "Poznań",
  "c": "Poznań",
  "p": "Poznań",
  "r": "wielkopolskie",
  "rw": "wielkopolskie",
  "t": "+48 798 305 590",
  "t2": "",
  "w": "https://strzelnica-poznan.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Szkolenia strzeleckie i kursy na pozwolenie na broń w Poznaniu, z zajęciami praktycznymi na strzelnicy.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/bydgoskie-towarzystwo-strzeleckie-kaliber-bydgoszcz",
  "n": "Bydgoskie Towarzystwo Strzeleckie Kaliber",
  "a": "ul. Śniadeckich 32, Bydgoszcz",
  "c": "Bydgoszcz",
  "p": "Bydgoszcz",
  "r": "kujawsko-pomorskie",
  "rw": "kujawsko-pomorskie",
  "t": "+48 523 456 611",
  "t2": "",
  "w": "https://www.nfs.pl/strzelnica/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica klubowa w centrum Bydgoszczy; koszt strzelania zależy od modelu broni i amunicji, stanowiska po rezerwacji telefonicznej.",
  "s": 10,
  "k": [
   "tel",
   "www",
   "adres",
   "klub",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-zielona-gora-zielona-gora",
  "n": "Strzelnica Zielona Góra",
  "a": "Zielona Góra",
  "c": "Zielona Góra",
  "p": "Zielona Góra",
  "r": "lubuskie",
  "rw": "lubuskie",
  "t": "+48 533 636 596",
  "t2": "",
  "w": "https://strzelanie.zgora.pl/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica z szeroką ofertą broni sportowej, bojowej i gładkolufowej; szkolenia, vouchery i strzelania na próbę.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-szarak-opole",
  "n": "Strzelnica Szarak",
  "a": "Opole",
  "c": "Opole",
  "p": "Opole",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "+48 785 925 795",
  "t2": "",
  "w": "http://szarak.net.pl/strzelnica/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica prowadzona przez opolskie koło łowieckie Szarak - strzelania śrutowe i kulowe, treningi myśliwskie.",
  "s": 7,
  "k": [
   "tel",
   "www",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-mysliwska-zo-pzl-olsztyn-olsztyn",
  "n": "Strzelnica myśliwska ZO PZŁ Olsztyn",
  "a": "ul. Cietrzewia 53A, 11-041 Olsztyn",
  "c": "Olsztyn",
  "p": "powiat olsztyński",
  "r": "warminsko-mazurskie",
  "rw": "warmińsko-mazurskie",
  "t": "+48 604 468 646",
  "t2": "",
  "w": "https://olsztyn.pzlow.pl/dla-mysliwych/strzelnica/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska Polskiego Związku Łowieckiego, czynna sezonowo: od marca do września w dni powszednie i w weekendy.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-mysliwska-zo-pzl-opole-opole",
  "n": "Strzelnica myśliwska ZO PZŁ Opole",
  "a": "ul. Strzelecka 80D, 45-525 Opole",
  "c": "Opole",
  "p": "Opole",
  "r": "opolskie",
  "rw": "opolskie",
  "t": "+48 785 925 795",
  "t2": "",
  "w": "https://opole.pzlow.pl/dla-mysliwych/strzelnica/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska okręgu opolskiego PZŁ - treningi i przystrzeliwanie broni myśliwskiej.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/strzelnica-mysliwska-zo-pzl-koszalin-manowo",
  "n": "Strzelnica myśliwska ZO PZŁ Koszalin",
  "a": "ul. Myśliwska 10, 76-015 Manowo",
  "c": "Manowo",
  "p": "powiat koszaliński",
  "r": "zachodniopomorskie",
  "rw": "zachodniopomorskie",
  "t": "+48 943 454 552",
  "t2": "",
  "w": "https://koszalin.pzlow.pl/dla-mysliwych/strzelnica/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Strzelnica myśliwska okręgu koszalińskiego PZŁ pod Koszalinem; strzelania śrutowe i kulowe dla myśliwych.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "adres",
   "opis"
  ]
 },
 {
  "id": "web/regionalne-centrum-sportowe-strzelnica-lubin",
  "n": "Regionalne Centrum Sportowe - strzelnica",
  "a": "Lubin",
  "c": "Lubin",
  "p": "powiat lubiński",
  "r": "dolnoslaskie",
  "rw": "dolnośląskie",
  "t": "+48 768 460 828",
  "t2": "",
  "w": "https://www.rcslubin.pl/strzelnica/",
  "f": "",
  "e": "",
  "h": "",
  "d": "Miejska strzelnica przy Regionalnym Centrum Sportowym w Lubinie; udostępniana klubom i osobom indywidualnym.",
  "s": 9,
  "k": [
   "tel",
   "www",
   "kryta",
   "opis"
  ]
 }
];

export const REGIONY = [
 {
  "slug": "dolnoslaskie",
  "name": "dolnośląskie",
  "loc": "dolnośląskim",
  "cities": [
   {
    "name": "Boguszów-Gorce",
    "slug": "boguszow-gorce",
    "idx": [
     1
    ]
   },
   {
    "name": "Brzeg Dolny",
    "slug": "brzeg-dolny",
    "idx": [
     476
    ]
   },
   {
    "name": "Domaniów",
    "slug": "domaniow",
    "idx": [
     7
    ]
   },
   {
    "name": "Duszniki-Zdrój",
    "slug": "duszniki-zdroj",
    "idx": [
     8
    ]
   },
   {
    "name": "Dłużyna Dolna",
    "slug": "dluzyna-dolna",
    "idx": [
     10
    ]
   },
   {
    "name": "Jawor",
    "slug": "jawor",
    "idx": [
     11,
     12
    ]
   },
   {
    "name": "Jelenia Góra",
    "slug": "jelenia-gora",
    "idx": [
     13
    ]
   },
   {
    "name": "Kwietno",
    "slug": "kwietno",
    "idx": [
     14
    ]
   },
   {
    "name": "Lubin",
    "slug": "lubin",
    "idx": [
     491
    ]
   },
   {
    "name": "Lutomia Górna",
    "slug": "lutomia-gorna",
    "idx": [
     475
    ]
   },
   {
    "name": "Lwówek Śląski",
    "slug": "lwowek-slaski",
    "idx": [
     18
    ]
   },
   {
    "name": "Milicz",
    "slug": "milicz",
    "idx": [
     19
    ]
   },
   {
    "name": "Miłków",
    "slug": "milkow",
    "idx": [
     20
    ]
   },
   {
    "name": "Moszyce",
    "slug": "moszyce",
    "idx": [
     21
    ]
   },
   {
    "name": "Oława",
    "slug": "olawa",
    "idx": [
     22
    ]
   },
   {
    "name": "Serby",
    "slug": "serby",
    "idx": [
     27
    ]
   },
   {
    "name": "Siechnice",
    "slug": "siechnice",
    "idx": [
     28
    ]
   },
   {
    "name": "Srebrna Góra",
    "slug": "srebrna-gora",
    "idx": [
     29
    ]
   },
   {
    "name": "Stare Bogaczowice",
    "slug": "stare-bogaczowice",
    "idx": [
     30
    ]
   },
   {
    "name": "Trzebnice",
    "slug": "trzebnice",
    "idx": [
     31
    ]
   },
   {
    "name": "Wrocław",
    "slug": "wroclaw",
    "idx": [
     34,
     477,
     35
    ]
   },
   {
    "name": "Łowęcice",
    "slug": "lowecice",
    "idx": [
     36
    ]
   },
   {
    "name": "Świdnica",
    "slug": "swidnica",
    "idx": [
     37
    ]
   }
  ],
  "other": [
   "Bractwo Kurkowe \"Husarz\" (Wrocław)",
   "Strzelnica (Dzikowiec)",
   "Strzelnica (Lubin)",
   "Strzelnica 200 m (Bolesławiec)",
   "Strzelnica Berdysz (Ożary)",
   "Strzelnica Izerska (Rębiszów)",
   "Strzelnica KSOS (Świdnica)",
   "Strzelnica Krzelków (Lipa)",
   "Strzelnica LOK (Oława)",
   "Strzelnica Myśliwska Biernacice (Biernacice)",
   "Strzelnica Pistoletowa (Bolesławiec)",
   "Strzelnica SSK Trzy Twierdze Twierdza Kłodzko (Kłodzko)",
   "Strzelnica Sportowa (Brzeg Głogowski)",
   "Strzelnica Sportowa (Dobrzejów)",
   "Strzelnica myśliwska (Pietrzyków)",
   "Strzelnica sportowa w Wołowie (Wołów)",
   "strzelnica (Brzeg Głogowski)"
  ],
  "count": 43,
  "listed": 26,
  "top": [
   34,
   35,
   37,
   10,
   491,
   7,
   20,
   28,
   11,
   476
  ]
 },
 {
  "slug": "kujawsko-pomorskie",
  "name": "kujawsko-pomorskie",
  "loc": "kujawsko-pomorskim",
  "cities": [
   {
    "name": "Bydgoszcz",
    "slug": "bydgoszcz",
    "idx": [
     485
    ]
   },
   {
    "name": "Golub-Dobrzyń",
    "slug": "golub-dobrzyn",
    "idx": [
     42
    ]
   },
   {
    "name": "Rybieniec",
    "slug": "rybieniec",
    "idx": [
     46
    ]
   },
   {
    "name": "Smolniki",
    "slug": "smolniki",
    "idx": [
     47
    ]
   },
   {
    "name": "Toruń",
    "slug": "torun",
    "idx": [
     49
    ]
   },
   {
    "name": "Wielka Nieszawka",
    "slug": "wielka-nieszawka",
    "idx": [
     51
    ]
   }
  ],
  "other": [
   "ACS II (Bydgoszcz)",
   "Centrum Szkolenia Strzeleckiego Lasów Państwowych im. Jana Wendy w Plaskoszu k/Tucholi (Tuchola)",
   "Lipnowski Klub Strzelecki \"Vis\" (Złotopole)",
   "Shotgun team akwanuta (Toruń)",
   "Strzelnica Godawy (Łysinin)",
   "Strzelnica Kowalewko - Mundurowy Klub Strzelecki - Jednostka Ratownictwa Specialnego w Kowalewku (Kowalewko)",
   "Strzelnica Nakielskiego Bractwa Kurkowego (Paterek)",
   "Strzelnica Piechcin (Aleksandrowo)",
   "Strzelnica myśliwska (Cierpice)",
   "Strzelnica myśliwska PZŁ Włocławek - Ostrowy (Włocławek)",
   "Strzelnica, Kurkowego Bractwa Strzeleckiego w Solcu Kujawskim (Przyłubie)"
  ],
  "count": 17,
  "listed": 6,
  "top": [
   485,
   47,
   51,
   49,
   46,
   42
  ]
 },
 {
  "slug": "lubelskie",
  "name": "lubelskie",
  "loc": "lubelskim",
  "cities": [
   {
    "name": "Cicibór Mały",
    "slug": "cicibor-maly",
    "idx": [
     57
    ]
   },
   {
    "name": "Dęblin",
    "slug": "deblin",
    "idx": [
     58
    ]
   },
   {
    "name": "Hubale",
    "slug": "hubale",
    "idx": [
     59
    ]
   },
   {
    "name": "Janowiec",
    "slug": "janowiec",
    "idx": [
     60
    ]
   },
   {
    "name": "Lublin",
    "slug": "lublin",
    "idx": [
     61,
     459,
     460,
     62,
     461
    ]
   },
   {
    "name": "Ostrów Lubelski",
    "slug": "ostrow-lubelski",
    "idx": [
     66
    ]
   },
   {
    "name": "Osówka",
    "slug": "osowka",
    "idx": [
     68
    ]
   },
   {
    "name": "Parchatka",
    "slug": "parchatka",
    "idx": [
     69
    ]
   },
   {
    "name": "Uniszowice",
    "slug": "uniszowice",
    "idx": [
     76
    ]
   },
   {
    "name": "Wilkołaz Drugi",
    "slug": "wilkolaz-drugi",
    "idx": [
     77
    ]
   },
   {
    "name": "Woskrzenice Duże",
    "slug": "woskrzenice-duze",
    "idx": [
     78
    ]
   },
   {
    "name": "Wąwolnica",
    "slug": "wawolnica",
    "idx": [
     79
    ]
   },
   {
    "name": "Świdnik",
    "slug": "swidnik",
    "idx": [
     84
    ]
   }
  ],
  "other": [
   "KS KALIBER (Małaszewicze Małe)",
   "Lewart (Olempin)",
   "SJS (Siedliska)",
   "Strzelnica (Rudka)",
   "Strzelnica (Sobieszyn)",
   "Strzelnica (Zamość)",
   "Strzelnica Fort IV Borowa (Borowa)",
   "Strzelnica Grodzisko Zawalów (Zawalów)",
   "Strzelnica PZŁ (Puławy)",
   "Strzelnica Pneumatyczna (Zamość)",
   "Strzelnica Sportowo- Myśliwska w Zarajcu (Michałówka)",
   "Strzelnica szkolna (Ostrów Lubelski)",
   "Strzelnica Łaziska (Łaziska)",
   "strzelnica Borek (Piaski)",
   "strzelnica Jonnik (Stara Wróblina)",
   "w dyszkę (Brzeziny)"
  ],
  "count": 33,
  "listed": 17,
  "top": [
   459,
   84,
   460,
   76,
   79,
   61,
   77,
   78,
   68,
   461
  ]
 },
 {
  "slug": "lubuskie",
  "name": "lubuskie",
  "loc": "lubuskim",
  "cities": [
   {
    "name": "Lubiszyn",
    "slug": "lubiszyn",
    "idx": [
     86
    ]
   },
   {
    "name": "Lubrza",
    "slug": "lubrza",
    "idx": [
     87
    ]
   },
   {
    "name": "Nietoperek",
    "slug": "nietoperek",
    "idx": [
     88
    ]
   },
   {
    "name": "Racław",
    "slug": "raclaw",
    "idx": [
     89
    ]
   },
   {
    "name": "Słubice",
    "slug": "slubice",
    "idx": [
     91
    ]
   },
   {
    "name": "Wiechlice",
    "slug": "wiechlice",
    "idx": [
     92
    ]
   },
   {
    "name": "Zielona Góra",
    "slug": "zielona-gora",
    "idx": [
     486
    ]
   }
  ],
  "other": [
   "LOK (Szprotawa)",
   "STRZELNICA (Dobiegniew)",
   "Strzelnica Miejska LOK Żary (Żary)",
   "Strzelnica PZŁ w Zielonej Górze (Zielona Góra)",
   "Strzelnica Zielona Góra (Zielona Góra)"
  ],
  "count": 12,
  "listed": 7,
  "top": [
   91,
   92,
   88,
   486,
   86,
   89,
   87
  ]
 },
 {
  "slug": "lodzkie",
  "name": "łódzkie",
  "loc": "łódzkim",
  "cities": [
   {
    "name": "Aleksandrów Łódzki",
    "slug": "aleksandrow-lodzki",
    "idx": [
     393
    ]
   },
   {
    "name": "Dobra",
    "slug": "dobra",
    "idx": [
     395
    ]
   },
   {
    "name": "Józefka",
    "slug": "jozefka",
    "idx": [
     397
    ]
   },
   {
    "name": "Kamień",
    "slug": "kamien",
    "idx": [
     398
    ]
   },
   {
    "name": "Karolew",
    "slug": "karolew",
    "idx": [
     399
    ]
   },
   {
    "name": "Kutno",
    "slug": "kutno",
    "idx": [
     400
    ]
   },
   {
    "name": "Opoczno",
    "slug": "opoczno",
    "idx": [
     402
    ]
   },
   {
    "name": "Parzęczew",
    "slug": "parzeczew",
    "idx": [
     404
    ]
   },
   {
    "name": "Radomsko",
    "slug": "radomsko",
    "idx": [
     407
    ]
   },
   {
    "name": "Sulmierzyce",
    "slug": "sulmierzyce",
    "idx": [
     408
    ]
   },
   {
    "name": "Tomaszów Mazowiecki",
    "slug": "tomaszow-mazowiecki",
    "idx": [
     410
    ]
   },
   {
    "name": "Zapady",
    "slug": "zapady",
    "idx": [
     413
    ]
   },
   {
    "name": "Zduńska Wola",
    "slug": "zdunska-wola",
    "idx": [
     414,
     415
    ]
   },
   {
    "name": "Łask",
    "slug": "lask",
    "idx": [
     416
    ]
   },
   {
    "name": "Łódź",
    "slug": "lodz",
    "idx": [
     457,
     417,
     456,
     458,
     453,
     454,
     455,
     418
    ]
   }
  ],
  "other": [
   "Salwa (Szczerców)",
   "Strzelnica Baszta (Pociecha)",
   "Strzelnica Gminna Jasień (Przyborów)",
   "Strzelnica Góra Chełmo - Omnis Arma (Zagórze)",
   "Strzelnica LOK (Leopoldów)",
   "Strzelnica Wieruszów (Chobanin)",
   "Strzelnica pneumatyczna (Wójcin)",
   "Strzelnica sportowa (Ozorków)",
   "Strzelnica sportowa w Grabicy (Grabica)"
  ],
  "count": 32,
  "listed": 23,
  "top": [
   393,
   457,
   456,
   454,
   455,
   397,
   458,
   453,
   413,
   408
  ]
 },
 {
  "slug": "malopolskie",
  "name": "małopolskie",
  "loc": "małopolskim",
  "cities": [
   {
    "name": "Bukowno",
    "slug": "bukowno",
    "idx": [
     199
    ]
   },
   {
    "name": "Dąbrówka Gorzycka",
    "slug": "dabrowka-gorzycka",
    "idx": [
     200
    ]
   },
   {
    "name": "Kraków",
    "slug": "krakow",
    "idx": [
     474,
     473,
     203,
     204
    ]
   },
   {
    "name": "Libiąż",
    "slug": "libiaz",
    "idx": [
     206
    ]
   },
   {
    "name": "Limanowa",
    "slug": "limanowa",
    "idx": [
     207
    ]
   },
   {
    "name": "Maków",
    "slug": "makow",
    "idx": [
     208
    ]
   },
   {
    "name": "Myślenice",
    "slug": "myslenice",
    "idx": [
     210
    ]
   },
   {
    "name": "Nowy Sącz",
    "slug": "nowy-sacz",
    "idx": [
     472
    ]
   },
   {
    "name": "Paczółtowice",
    "slug": "paczoltowice",
    "idx": [
     214
    ]
   },
   {
    "name": "Słomniki",
    "slug": "slomniki",
    "idx": [
     215
    ]
   },
   {
    "name": "Tarnów",
    "slug": "tarnow",
    "idx": [
     216
    ]
   },
   {
    "name": "Trzebinia",
    "slug": "trzebinia",
    "idx": [
     217
    ]
   }
  ],
  "other": [
   "Dawna strzelnica LOK (Brzozówka)",
   "Małopolskie Centrum Strzelectwa (Bochnia)",
   "Paint Gang Arena (Nowy Sącz)",
   "Strzelnica Biathlonowa (Kościelisko)",
   "Strzelnica Gunsarea (Brzezinka)",
   "Strzelnica Jaworsko (Jaworsko)",
   "Strzelnica LOK Bielcza (Bielcza)",
   "Strzelnica LOK Krempachy (Krempachy)",
   "Strzelnica Sportowa (Miechów)",
   "Strzelnica Taktyczna VIS MAIOR Nowy Sącz - Biegonice (Nowy Sącz)",
   "strzelnica (Oświęcim)"
  ],
  "count": 26,
  "listed": 15,
  "top": [
   214,
   203,
   474,
   473,
   200,
   204,
   472,
   208,
   199,
   216
  ]
 },
 {
  "slug": "mazowieckie",
  "name": "mazowieckie",
  "loc": "mazowieckim",
  "cities": [
   {
    "name": "Błonie",
    "slug": "blonie",
    "idx": [
     104
    ]
   },
   {
    "name": "Chłopków",
    "slug": "chlopkow",
    "idx": [
     105,
     106
    ]
   },
   {
    "name": "Dawidy Bankowe",
    "slug": "dawidy-bankowe",
    "idx": [
     107
    ]
   },
   {
    "name": "Dębinki",
    "slug": "debinki",
    "idx": [
     120
    ]
   },
   {
    "name": "Góry",
    "slug": "gory",
    "idx": [
     122
    ]
   },
   {
    "name": "Gąsawy Rządowe",
    "slug": "gasawy-rzadowe",
    "idx": [
     123
    ]
   },
   {
    "name": "Józefów",
    "slug": "jozefow",
    "idx": [
     125
    ]
   },
   {
    "name": "Kobyłka",
    "slug": "kobylka",
    "idx": [
     127
    ]
   },
   {
    "name": "Kochów",
    "slug": "kochow",
    "idx": [
     128
    ]
   },
   {
    "name": "Kurowo",
    "slug": "kurowo",
    "idx": [
     129
    ]
   },
   {
    "name": "Laski",
    "slug": "laski",
    "idx": [
     130
    ]
   },
   {
    "name": "Magnuszew",
    "slug": "magnuszew",
    "idx": [
     133
    ]
   },
   {
    "name": "Marynino",
    "slug": "marynino",
    "idx": [
     141
    ]
   },
   {
    "name": "Milanówek",
    "slug": "milanowek",
    "idx": [
     142
    ]
   },
   {
    "name": "Nowy Dwór Mazowiecki",
    "slug": "nowy-dwor-mazowiecki",
    "idx": [
     156
    ]
   },
   {
    "name": "Ołtarzew",
    "slug": "oltarzew",
    "idx": [
     157
    ]
   },
   {
    "name": "Pacew",
    "slug": "pacew",
    "idx": [
     158
    ]
   },
   {
    "name": "Promna",
    "slug": "promna",
    "idx": [
     166,
     167
    ]
   },
   {
    "name": "Radom",
    "slug": "radom",
    "idx": [
     464
    ]
   },
   {
    "name": "Siedlce",
    "slug": "siedlce",
    "idx": [
     169
    ]
   },
   {
    "name": "Skaryszew",
    "slug": "skaryszew",
    "idx": [
     170
    ]
   },
   {
    "name": "Warka",
    "slug": "warka",
    "idx": [
     174
    ]
   },
   {
    "name": "Warszawa",
    "slug": "warszawa",
    "idx": [
     175,
     176,
     177,
     179,
     180,
     181,
     182,
     183,
     184,
     185
    ]
   },
   {
    "name": "Ząbki",
    "slug": "zabki",
    "idx": [
     193
    ]
   }
  ],
  "other": [
   "1 (50m) (Nowy Dwór Mazowiecki)",
   "10 (25m) (Nowy Dwór Mazowiecki)",
   "11 (25m) (Nowy Dwór Mazowiecki)",
   "12 (100m) (Nowy Dwór Mazowiecki)",
   "16 (Marynino)",
   "17 (Marynino)",
   "18 (Marynino)",
   "19 (Marynino)",
   "2 (50m) (Nowy Dwór Mazowiecki)",
   "20 (Marynino)",
   "21 (Marynino)",
   "22 (Dębinki)",
   "23 (Dębinki)",
   "24 (Dębinki)",
   "25 (Dębinki)",
   "26 (Dębinki)",
   "27 (Dębinki)",
   "28 (Dębinki)",
   "29 (Dębinki)",
   "3 (40m) (Nowy Dwór Mazowiecki)",
   "30 (Dębinki)",
   "31 (Dębinki)",
   "32 (Dębinki)",
   "33 (Dębinki)",
   "4 (40m) (Nowy Dwór Mazowiecki)",
   "5 (15m) (Nowy Dwór Mazowiecki)",
   "50m (Baraki Chotumskie)",
   "6 (15m) (Nowy Dwór Mazowiecki)",
   "7 (15m) (Nowy Dwór Mazowiecki)",
   "8 (15m) (Nowy Dwór Mazowiecki)",
   "9 (15m) (Nowy Dwór Mazowiecki)",
   "? (15m) (Nowy Dwór Mazowiecki)",
   "MOP (Baraki Chotumskie)",
   "Neo Dzik (Warszawa)",
   "Stowarzyszenie strzeleckie Shooter (Dębsk)",
   "Strzelnica \"Pod Dębami\" (Luszyn)",
   "Strzelnica (Kieszek)",
   "Strzelnica (Makówka)",
   "Strzelnica Klubu Strzeleckiego CEL w Ogrodzienicach. (Słomczyn)",
   "Strzelnica L.O. w Lipinach (Lipiny)",
   "Strzelnica LOK (Płock)",
   "Strzelnica LOK Szerominek (Szerominek)",
   "Strzelnica PZŁ BALE (Świerczyna)",
   "Strzelnica UFO Team (Jasionna)",
   "biatlon (Warszawa)",
   "c.p. (Warszawa)",
   "dyn. E (Warszawa)",
   "dyn. F (Warszawa)",
   "dzik (Baraki Chotumskie)",
   "os 5 (Pacew)",
   "oś 1 (Pacew)",
   "oś 2 (Pacew)",
   "oś 3   100m (Pacew)",
   "oś 4 (Pacew)",
   "oś. A (Warszawa)",
   "rogacz (Baraki Chotumskie)",
   "skeet (Baraki Chotumskie)",
   "sportowa 50m (Piastów)",
   "stara dyn. (strzelbowa) (Warszawa)",
   "stary \"Dzik\" (Warszawa)",
   "strzelnica PZŁ Suchodół (Suchodół)",
   "strzelnica myśliwska (Baraki Chotumskie)",
   "trap (Baraki Chotumskie)",
   "trap (Piastów)",
   "zając (Baraki Chotumskie)"
  ],
  "count": 100,
  "listed": 35,
  "top": [
   184,
   185,
   175,
   107,
   105,
   106,
   127,
   182,
   183,
   141
  ]
 },
 {
  "slug": "opolskie",
  "name": "opolskie",
  "loc": "opolskim",
  "cities": [
   {
    "name": "Opole",
    "slug": "opole",
    "idx": [
     487,
     489
    ]
   },
   {
    "name": "Pawłów",
    "slug": "pawlow",
    "idx": [
     230
    ]
   }
  ],
  "other": [
   "10 (Pawłów)",
   "3 (Pawłów)",
   "4 (Pawłów)",
   "5 (Pawłów)",
   "6 (Pawłów)",
   "7 (Pawłów)",
   "8 (Pawłów)",
   "9 (Pawłów)",
   "Strzelnica (Kędzierzyn-Koźle)",
   "Strzelnica LOK (Opole)",
   "Strzelnica Opolskiego Klubu Stzeleckiego Husarz (Brzeg)",
   "Strzelnica sportowa (Opole)"
  ],
  "count": 15,
  "listed": 3,
  "top": [
   230,
   489,
   487
  ]
 },
 {
  "slug": "podkarpackie",
  "name": "podkarpackie",
  "loc": "podkarpackim",
  "cities": [
   {
    "name": "Głogów Małopolski",
    "slug": "glogow-malopolski",
    "idx": [
     234
    ]
   },
   {
    "name": "Przemyśl",
    "slug": "przemysl",
    "idx": [
     238
    ]
   },
   {
    "name": "Rudna Wielka",
    "slug": "rudna-wielka",
    "idx": [
     239
    ]
   },
   {
    "name": "Rzeszów",
    "slug": "rzeszow",
    "idx": [
     471,
     240
    ]
   },
   {
    "name": "Sokołów Małopolski",
    "slug": "sokolow-malopolski",
    "idx": [
     241
    ]
   },
   {
    "name": "Łapajówka",
    "slug": "lapajowka",
    "idx": [
     243
    ]
   }
  ],
  "other": [
   "LOK Brzozów Strzelnica (Brzozów)",
   "Liga Obrony Kraju (Stalowa Wola)",
   "Pistol Range (Chorzelów)",
   "Strzelnica (Kolbuszowa)",
   "Strzelnica (Łańcut)",
   "Strzelnica Miejska (Mielec)",
   "Strzelnica Rekreacyjna „FRANKÓW” (Dukla)",
   "strzelnica sportowa (Pruchnik)"
  ],
  "count": 15,
  "listed": 7,
  "top": [
   238,
   239,
   471,
   241,
   234,
   240,
   243
  ]
 },
 {
  "slug": "podlaskie",
  "name": "podlaskie",
  "loc": "podlaskim",
  "cities": [
   {
    "name": "Białystok",
    "slug": "bialystok",
    "idx": [
     245,
     246
    ]
   },
   {
    "name": "Karakule",
    "slug": "karakule",
    "idx": [
     258
    ]
   },
   {
    "name": "Turośń Kościelna",
    "slug": "turosn-koscielna",
    "idx": [
     480
    ]
   }
  ],
  "other": [
   "Dzik (Karakule)",
   "Krąg (Karakule)",
   "Oś (Karakule)",
   "Przeloty (Karakule)",
   "Rogacz (Karakule)",
   "Strzelnica Borek - Sejneńskie Towarzystwo Strzeleckie (Gawiniańce)",
   "Strzelnica GROM Group (Czerwony Bór)",
   "Strzelnica Jasionówka (Klub 9mm) (Dobrzyniówka)",
   "Strzelnica Sportowa PZŁ Czerwony Bór (Czerwony Bór)",
   "Strzelnica Stowarzyszenie Historyczne im.71. Pułku Piechoty (Tabędz)",
   "Strzelnica cywilno-sportowa w Borysowszczyźnie (Borysowszczyzna)",
   "Suwalska Liga Darta (Suwałki)",
   "Zając (Karakule)",
   "strzelnica (Grajewo)"
  ],
  "count": 18,
  "listed": 4,
  "top": [
   246,
   480,
   258,
   245
  ]
 },
 {
  "slug": "pomorskie",
  "name": "pomorskie",
  "loc": "pomorskim",
  "cities": [
   {
    "name": "Cecenowo",
    "slug": "cecenowo",
    "idx": [
     262
    ]
   },
   {
    "name": "Gdańsk",
    "slug": "gdansk",
    "idx": [
     263,
     479,
     264,
     265,
     266,
     478
    ]
   },
   {
    "name": "Gdynia",
    "slug": "gdynia",
    "idx": [
     267,
     268,
     269,
     270
    ]
   },
   {
    "name": "Hel",
    "slug": "hel",
    "idx": [
     272
    ]
   },
   {
    "name": "Kartuzy",
    "slug": "kartuzy",
    "idx": [
     273
    ]
   },
   {
    "name": "Korne",
    "slug": "korne",
    "idx": [
     274
    ]
   },
   {
    "name": "Kuleszewo",
    "slug": "kuleszewo",
    "idx": [
     275
    ]
   },
   {
    "name": "Kwidzyn",
    "slug": "kwidzyn",
    "idx": [
     276
    ]
   },
   {
    "name": "Lublewo Gdańskie",
    "slug": "lublewo-gdanskie",
    "idx": [
     277
    ]
   },
   {
    "name": "Miszewko",
    "slug": "miszewko",
    "idx": [
     278
    ]
   },
   {
    "name": "Mrzezino",
    "slug": "mrzezino",
    "idx": [
     279
    ]
   },
   {
    "name": "Wielbark",
    "slug": "wielbark",
    "idx": [
     282
    ]
   },
   {
    "name": "Zielnowo",
    "slug": "zielnowo",
    "idx": [
     283
    ]
   },
   {
    "name": "Świetlino",
    "slug": "swietlino",
    "idx": [
     284
    ]
   }
  ],
  "other": [
   "Strzelnica (Hel)",
   "Strzelnica Kurkowego Bractwa Strzeleckigo w Wejherowie (Wejherowo)",
   "Strzelnica LOK Prabuty (Prabuty)"
  ],
  "count": 25,
  "listed": 22,
  "top": [
   266,
   267,
   264,
   265,
   278,
   263,
   268,
   270,
   277,
   282
  ]
 },
 {
  "slug": "slaskie",
  "name": "śląskie",
  "loc": "śląskim",
  "cities": [
   {
    "name": "Bielsko-Biała",
    "slug": "bielsko-biala",
    "idx": [
     470,
     468,
     469,
     419
    ]
   },
   {
    "name": "Chorzów",
    "slug": "chorzow",
    "idx": [
     421,
     466,
     422
    ]
   },
   {
    "name": "Chybie",
    "slug": "chybie",
    "idx": [
     423
    ]
   },
   {
    "name": "Czechowice-Dziedzice",
    "slug": "czechowice-dziedzice",
    "idx": [
     467
    ]
   },
   {
    "name": "Częstochowa",
    "slug": "czestochowa",
    "idx": [
     465
    ]
   },
   {
    "name": "Gliwice",
    "slug": "gliwice",
    "idx": [
     425
    ]
   },
   {
    "name": "Jaworzno",
    "slug": "jaworzno",
    "idx": [
     426
    ]
   },
   {
    "name": "Katowice",
    "slug": "katowice",
    "idx": [
     428
    ]
   },
   {
    "name": "Knurów",
    "slug": "knurow",
    "idx": [
     429
    ]
   },
   {
    "name": "Pyskowice",
    "slug": "pyskowice",
    "idx": [
     435
    ]
   },
   {
    "name": "Ruda Śląska",
    "slug": "ruda-slaska",
    "idx": [
     436
    ]
   },
   {
    "name": "Rybnik",
    "slug": "rybnik",
    "idx": [
     437
    ]
   },
   {
    "name": "Siemianowice Śląskie",
    "slug": "siemianowice-slaskie",
    "idx": [
     438
    ]
   },
   {
    "name": "Sosnowiec",
    "slug": "sosnowiec",
    "idx": [
     440
    ]
   },
   {
    "name": "Woźniki",
    "slug": "wozniki",
    "idx": [
     445
    ]
   },
   {
    "name": "Żory",
    "slug": "zory",
    "idx": [
     446
    ]
   }
  ],
  "other": [
   "Strzelnica \"TARGET ALFA SILESIA\" (Przyszowice)",
   "Strzelnica LOK Jaworzno (Jaworzno)",
   "Strzelnica Myśliwska (Kochcice)",
   "Strzelnica Sportowa (Bieruń)",
   "Strzelnica Sportowa (Kochcice)",
   "Strzelnica Sportowa (Sieraków Śląski)",
   "Strzelnica Sportowa (Sławków)",
   "Strzelnica Szczejkowice (Szczejkowice)",
   "Strzelnica Taktyczna (Kochcice)",
   "Strzelnica sportowa (Częstochowa)",
   "Strzelnica sportowa (Poręba)",
   "Strzelnica sportowa (Wodzisław Śląski)",
   "Strzelnica sportowa PHU Matuszek (Syrynia)"
  ],
  "count": 34,
  "listed": 21,
  "top": [
   422,
   470,
   425,
   468,
   469,
   465,
   466,
   426,
   428,
   467
  ]
 },
 {
  "slug": "swietokrzyskie",
  "name": "świętokrzyskie",
  "loc": "świętokrzyskim",
  "cities": [
   {
    "name": "Kielce",
    "slug": "kielce",
    "idx": [
     462,
     463
    ]
   },
   {
    "name": "Pińczów",
    "slug": "pinczow",
    "idx": [
     448
    ]
   },
   {
    "name": "Skotniki Małe",
    "slug": "skotniki-male",
    "idx": [
     449
    ]
   }
  ],
  "other": [
   "100m (Wąchock)",
   "UMKS Snajper (Kielce)",
   "strzelnica K.S. \"Świt Starachowice\" (Starachowice)",
   "strzelnica myśliwska PZŁ (Wąchock)"
  ],
  "count": 8,
  "listed": 4,
  "top": [
   462,
   463,
   449,
   448
  ]
 },
 {
  "slug": "warminsko-mazurskie",
  "name": "warmińsko-mazurskie",
  "loc": "warmińsko-mazurskim",
  "cities": [
   {
    "name": "Gągławki",
    "slug": "gaglawki",
    "idx": [
     285
    ]
   },
   {
    "name": "Jaśki",
    "slug": "jaski",
    "idx": [
     286
    ]
   },
   {
    "name": "Olsztyn",
    "slug": "olsztyn",
    "idx": [
     289,
     488
    ]
   }
  ],
  "other": [
   "Strzelnica (Olsztyn)",
   "Strzelnica LOK Iława (Wikielec)",
   "Strzelnica Tylice (Tylice)",
   "Strzelnica myśliwska (Mrozy Wielkie)",
   "Tory Taktyczne Srokowo (Srokowo)",
   "strzelnica GRYF Biskupiec (Łabuchy)"
  ],
  "count": 10,
  "listed": 4,
  "top": [
   289,
   488,
   285,
   286
  ]
 },
 {
  "slug": "wielkopolskie",
  "name": "wielkopolskie",
  "loc": "wielkopolskim",
  "cities": [
   {
    "name": "Aleksandrowo",
    "slug": "aleksandrowo",
    "idx": [
     294
    ]
   },
   {
    "name": "Bierzglinek",
    "slug": "bierzglinek",
    "idx": [
     295
    ]
   },
   {
    "name": "Błocko",
    "slug": "blocko",
    "idx": [
     297
    ]
   },
   {
    "name": "Cieśle",
    "slug": "ciesle",
    "idx": [
     298
    ]
   },
   {
    "name": "Czacz",
    "slug": "czacz",
    "idx": [
     299
    ]
   },
   {
    "name": "Dąbrówka Leśna",
    "slug": "dabrowka-lesna",
    "idx": [
     300
    ]
   },
   {
    "name": "Gajewo",
    "slug": "gajewo",
    "idx": [
     301
    ]
   },
   {
    "name": "Gostyń",
    "slug": "gostyn",
    "idx": [
     303
    ]
   },
   {
    "name": "Granowo",
    "slug": "granowo",
    "idx": [
     304
    ]
   },
   {
    "name": "Górsko",
    "slug": "gorsko",
    "idx": [
     305
    ]
   },
   {
    "name": "Górzna",
    "slug": "gorzna",
    "idx": [
     306
    ]
   },
   {
    "name": "Jasin",
    "slug": "jasin",
    "idx": [
     308
    ]
   },
   {
    "name": "Józefowo",
    "slug": "jozefowo",
    "idx": [
     309
    ]
   },
   {
    "name": "Kazimierz Biskupi",
    "slug": "kazimierz-biskupi",
    "idx": [
     311
    ]
   },
   {
    "name": "Krobia",
    "slug": "krobia",
    "idx": [
     313
    ]
   },
   {
    "name": "Krotoszyn",
    "slug": "krotoszyn",
    "idx": [
     314
    ]
   },
   {
    "name": "Krzywiń",
    "slug": "krzywin",
    "idx": [
     315
    ]
   },
   {
    "name": "Leszno",
    "slug": "leszno",
    "idx": [
     316
    ]
   },
   {
    "name": "Lubstów",
    "slug": "lubstow",
    "idx": [
     317
    ]
   },
   {
    "name": "Ludwina",
    "slug": "ludwina",
    "idx": [
     318
    ]
   },
   {
    "name": "Mościenica",
    "slug": "moscienica",
    "idx": [
     320
    ]
   },
   {
    "name": "Murowana Goślina",
    "slug": "murowana-goslina",
    "idx": [
     321,
     322
    ]
   },
   {
    "name": "Mutowo",
    "slug": "mutowo",
    "idx": [
     323
    ]
   },
   {
    "name": "Nieczajna",
    "slug": "nieczajna",
    "idx": [
     331,
     332
    ]
   },
   {
    "name": "Niedźwiedziny",
    "slug": "niedzwiedziny",
    "idx": [
     333
    ]
   },
   {
    "name": "Nowolipsk",
    "slug": "nowolipsk",
    "idx": [
     334
    ]
   },
   {
    "name": "Opalenica",
    "slug": "opalenica",
    "idx": [
     337
    ]
   },
   {
    "name": "Piła",
    "slug": "pila",
    "idx": [
     338
    ]
   },
   {
    "name": "Popowo",
    "slug": "popowo",
    "idx": [
     341
    ]
   },
   {
    "name": "Potażniki",
    "slug": "potazniki",
    "idx": [
     342
    ]
   },
   {
    "name": "Poznań",
    "slug": "poznan",
    "idx": [
     343,
     344,
     347,
     484,
     348,
     349,
     350
    ]
   },
   {
    "name": "Rogoźno",
    "slug": "rogozno",
    "idx": [
     354
    ]
   },
   {
    "name": "Sarbka",
    "slug": "sarbka",
    "idx": [
     356
    ]
   },
   {
    "name": "Sierakowo",
    "slug": "sierakowo",
    "idx": [
     357
    ]
   },
   {
    "name": "Skrzynki",
    "slug": "skrzynki",
    "idx": [
     360
    ]
   },
   {
    "name": "Sobótka",
    "slug": "sobotka",
    "idx": [
     361
    ]
   },
   {
    "name": "Studzieniec",
    "slug": "studzieniec",
    "idx": [
     362
    ]
   },
   {
    "name": "Tarnowo Podgórne",
    "slug": "tarnowo-podgorne",
    "idx": [
     363
    ]
   },
   {
    "name": "Witaszyce",
    "slug": "witaszyce",
    "idx": [
     364
    ]
   },
   {
    "name": "Wronki",
    "slug": "wronki",
    "idx": [
     365
    ]
   },
   {
    "name": "Włościejewki",
    "slug": "wlosciejewki",
    "idx": [
     366
    ]
   },
   {
    "name": "gmina Krzyż Wielkopolski",
    "slug": "gmina-krzyz-wielkopolski",
    "idx": [
     368
    ]
   },
   {
    "name": "Środa Wielkopolska",
    "slug": "sroda-wielkopolska",
    "idx": [
     369
    ]
   }
  ],
  "other": [
   "2. (50m) (Nieczajna)",
   "3.  (40m) (Nieczajna)",
   "4. (16m) (Nieczajna)",
   "4. (50m) (Nieczajna)",
   "5. (15m) (Nieczajna)",
   "6. (13m) (Nieczajna)",
   "7. (12m) (Nieczajna)",
   "KBS Zbaszyń strzelnica (Zbąszyń)",
   "Krąg 2 (Poznań)",
   "Kurkowe Bractwo Strzeleckie Pniewy (Pniewy)",
   "Oś: Rogacz, Dzik 1-2, Zając 1-2 (Poznań)",
   "Strzelnica Bractwa Kurkowego (Rydzyna)",
   "Strzelnica Czempińskiego Związku Strzeleckiego (Głuchowo)",
   "Strzelnica KBS (Pniewy)",
   "Strzelnica Markowice (w budowie) (Markowice)",
   "Strzelnica Myśliwska Orchowo (Gałczynek)",
   "Strzelnica Robaczyn (Robaczyn)",
   "Strzelnica Sportowa LOK (Koło)",
   "Strzelnica Sportowo - Myśliwska (Przedlesie)",
   "Strzelnica bractwa kurkowego (Skoki)",
   "Strzelnica im. Brata Teofila Dobkowicza (Sieraków)",
   "Strzelnica pneumatyczna LOK (Nowy Tomyśl)",
   "Strzelnica pneumatyczna LOK (Poznań)",
   "Strzelnica sportowa (Buk)",
   "Strzelnica sportowa (Nowy Tomyśl)",
   "Strzelnica Łucjanowo (Józefowo)",
   "Strzelnica śrutowa BOCK Rawicz (Żylice)"
  ],
  "count": 78,
  "listed": 51,
  "top": [
   347,
   299,
   343,
   337,
   349,
   364,
   300,
   331,
   311,
   323
  ]
 },
 {
  "slug": "zachodniopomorskie",
  "name": "zachodniopomorskie",
  "loc": "zachodniopomorskim",
  "cities": [
   {
    "name": "Golce",
    "slug": "golce",
    "idx": [
     374
    ]
   },
   {
    "name": "Gryfice",
    "slug": "gryfice",
    "idx": [
     375
    ]
   },
   {
    "name": "Koszalin",
    "slug": "koszalin",
    "idx": [
     482,
     481
    ]
   },
   {
    "name": "Kołobrzeg",
    "slug": "kolobrzeg",
    "idx": [
     377
    ]
   },
   {
    "name": "Kędrzyno",
    "slug": "kedrzyno",
    "idx": [
     379
    ]
   },
   {
    "name": "Manowo",
    "slug": "manowo",
    "idx": [
     490
    ]
   },
   {
    "name": "Pucice",
    "slug": "pucice",
    "idx": [
     384
    ]
   },
   {
    "name": "Szczecin",
    "slug": "szczecin",
    "idx": [
     483
    ]
   },
   {
    "name": "gmina Stare Czarnowo",
    "slug": "gmina-stare-czarnowo",
    "idx": [
     390
    ]
   },
   {
    "name": "Świnoujście",
    "slug": "swinoujscie",
    "idx": [
     391
    ]
   }
  ],
  "other": [
   "Strzelnica (Białogard)",
   "Strzelnica (Lublino)",
   "Strzelnica (Mielenko Gryfińskie)",
   "Strzelnica (Sułowo)",
   "Strzelnica 17-stka (Szczecin)",
   "Strzelnica KMS Dragon Zdrójno (Zdrójno)",
   "Strzelnica Military Area (Żabów)",
   "Strzelnica Postomino (Postomino)",
   "Strzelnica Ramlewo VIS (Wierzbka Dolna)",
   "Strzelnica myśliwska (Kulice)",
   "Strzelnica łucznicza (Koszalin)",
   "strzelnica (Boleszewo Kolonia)",
   "strzelnica (Brzeżno)",
   "strzelnica (Pełczyce)",
   "strzelnica (Stanomino)"
  ],
  "count": 26,
  "listed": 11,
  "top": [
   481,
   490,
   390,
   379,
   483,
   482,
   377,
   374,
   384,
   391
  ]
 }
];

export const MIASTA = [
 {
  "name": "Warszawa",
  "slug": "warszawa",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 10,
  "idx": [
   184,
   185,
   175,
   182,
   183,
   176,
   180,
   177,
   179,
   181
  ]
 },
 {
  "name": "Łódź",
  "slug": "lodz",
  "woj": "łódzkie",
  "wojSlug": "lodzkie",
  "wojLoc": "łódzkim",
  "count": 8,
  "idx": [
   457,
   456,
   454,
   455,
   458,
   453,
   417,
   418
  ]
 },
 {
  "name": "Poznań",
  "slug": "poznan",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 7,
  "idx": [
   347,
   343,
   349,
   484,
   344,
   348,
   350
  ]
 },
 {
  "name": "Gdańsk",
  "slug": "gdansk",
  "woj": "pomorskie",
  "wojSlug": "pomorskie",
  "wojLoc": "pomorskim",
  "count": 6,
  "idx": [
   266,
   264,
   265,
   263,
   478,
   479
  ]
 },
 {
  "name": "Lublin",
  "slug": "lublin",
  "woj": "lubelskie",
  "wojSlug": "lubelskie",
  "wojLoc": "lubelskim",
  "count": 5,
  "idx": [
   459,
   460,
   61,
   461,
   62
  ]
 },
 {
  "name": "Kraków",
  "slug": "krakow",
  "woj": "małopolskie",
  "wojSlug": "malopolskie",
  "wojLoc": "małopolskim",
  "count": 4,
  "idx": [
   203,
   474,
   473,
   204
  ]
 },
 {
  "name": "Gdynia",
  "slug": "gdynia",
  "woj": "pomorskie",
  "wojSlug": "pomorskie",
  "wojLoc": "pomorskim",
  "count": 4,
  "idx": [
   267,
   268,
   270,
   269
  ]
 },
 {
  "name": "Bielsko-Biała",
  "slug": "bielsko-biala",
  "woj": "śląskie",
  "wojSlug": "slaskie",
  "wojLoc": "śląskim",
  "count": 4,
  "idx": [
   470,
   468,
   469,
   419
  ]
 },
 {
  "name": "Wrocław",
  "slug": "wroclaw",
  "woj": "dolnośląskie",
  "wojSlug": "dolnoslaskie",
  "wojLoc": "dolnośląskim",
  "count": 3,
  "idx": [
   34,
   35,
   477
  ]
 },
 {
  "name": "Chorzów",
  "slug": "chorzow",
  "woj": "śląskie",
  "wojSlug": "slaskie",
  "wojLoc": "śląskim",
  "count": 3,
  "idx": [
   422,
   466,
   421
  ]
 },
 {
  "name": "Jawor",
  "slug": "jawor",
  "woj": "dolnośląskie",
  "wojSlug": "dolnoslaskie",
  "wojLoc": "dolnośląskim",
  "count": 2,
  "idx": [
   11,
   12
  ]
 },
 {
  "name": "Chłopków",
  "slug": "chlopkow",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 2,
  "idx": [
   105,
   106
  ]
 },
 {
  "name": "Promna",
  "slug": "promna",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 2,
  "idx": [
   167,
   166
  ]
 },
 {
  "name": "Opole",
  "slug": "opole",
  "woj": "opolskie",
  "wojSlug": "opolskie",
  "wojLoc": "opolskim",
  "count": 2,
  "idx": [
   489,
   487
  ]
 },
 {
  "name": "Rzeszów",
  "slug": "rzeszow",
  "woj": "podkarpackie",
  "wojSlug": "podkarpackie",
  "wojLoc": "podkarpackim",
  "count": 2,
  "idx": [
   471,
   240
  ]
 },
 {
  "name": "Białystok",
  "slug": "bialystok",
  "woj": "podlaskie",
  "wojSlug": "podlaskie",
  "wojLoc": "podlaskim",
  "count": 2,
  "idx": [
   246,
   245
  ]
 },
 {
  "name": "Olsztyn",
  "slug": "olsztyn",
  "woj": "warmińsko-mazurskie",
  "wojSlug": "warminsko-mazurskie",
  "wojLoc": "warmińsko-mazurskim",
  "count": 2,
  "idx": [
   289,
   488
  ]
 },
 {
  "name": "Murowana Goślina",
  "slug": "murowana-goslina",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   322,
   321
  ]
 },
 {
  "name": "Nieczajna",
  "slug": "nieczajna",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   331,
   332
  ]
 },
 {
  "name": "Koszalin",
  "slug": "koszalin",
  "woj": "zachodniopomorskie",
  "wojSlug": "zachodniopomorskie",
  "wojLoc": "zachodniopomorskim",
  "count": 2,
  "idx": [
   481,
   482
  ]
 },
 {
  "name": "Zduńska Wola",
  "slug": "zdunska-wola",
  "woj": "łódzkie",
  "wojSlug": "lodzkie",
  "wojLoc": "łódzkim",
  "count": 2,
  "idx": [
   415,
   414
  ]
 },
 {
  "name": "Kielce",
  "slug": "kielce",
  "woj": "świętokrzyskie",
  "wojSlug": "swietokrzyskie",
  "wojLoc": "świętokrzyskim",
  "count": 2,
  "idx": [
   462,
   463
  ]
 }
];

export const POWIATY = [
 {
  "name": "powiat poznański",
  "slug": "powiat-poznanski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 7,
  "idx": [
   308,
   322,
   321,
   360,
   320,
   298,
   363
  ]
 },
 {
  "name": "powiat obornicki",
  "slug": "powiat-obornicki",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 4,
  "idx": [
   300,
   331,
   354,
   332
  ]
 },
 {
  "name": "powiat zgierski",
  "slug": "powiat-zgierski",
  "woj": "łódzkie",
  "wojSlug": "lodzkie",
  "wojLoc": "łódzkim",
  "count": 4,
  "idx": [
   393,
   399,
   404,
   395
  ]
 },
 {
  "name": "powiat puławski",
  "slug": "powiat-pulawski",
  "woj": "lubelskie",
  "wojSlug": "lubelskie",
  "wojLoc": "lubelskim",
  "count": 3,
  "idx": [
   79,
   60,
   69
  ]
 },
 {
  "name": "powiat białobrzeski",
  "slug": "powiat-bialobrzeski",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 3,
  "idx": [
   158,
   167,
   166
  ]
 },
 {
  "name": "powiat rzeszowski",
  "slug": "powiat-rzeszowski",
  "woj": "podkarpackie",
  "wojSlug": "podkarpackie",
  "wojLoc": "podkarpackim",
  "count": 3,
  "idx": [
   239,
   241,
   234
  ]
 },
 {
  "name": "powiat koniński",
  "slug": "powiat-koninski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 3,
  "idx": [
   311,
   342,
   317
  ]
 },
 {
  "name": "powiat szamotulski",
  "slug": "powiat-szamotulski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 3,
  "idx": [
   323,
   365,
   341
  ]
 },
 {
  "name": "powiat jaworski",
  "slug": "powiat-jaworski",
  "woj": "dolnośląskie",
  "wojSlug": "dolnoslaskie",
  "wojLoc": "dolnośląskim",
  "count": 2,
  "idx": [
   11,
   12
  ]
 },
 {
  "name": "powiat oławski",
  "slug": "powiat-olawski",
  "woj": "dolnośląskie",
  "wojSlug": "dolnoslaskie",
  "wojLoc": "dolnośląskim",
  "count": 2,
  "idx": [
   7,
   22
  ]
 },
 {
  "name": "powiat wałbrzyski",
  "slug": "powiat-walbrzyski",
  "woj": "dolnośląskie",
  "wojSlug": "dolnoslaskie",
  "wojLoc": "dolnośląskim",
  "count": 2,
  "idx": [
   30,
   1
  ]
 },
 {
  "name": "powiat średzki",
  "slug": "powiat-sredzki-dolnoslaskie",
  "woj": "dolnośląskie",
  "wojSlug": "dolnoslaskie",
  "wojLoc": "dolnośląskim",
  "count": 2,
  "idx": [
   36,
   14
  ]
 },
 {
  "name": "powiat świdnicki",
  "slug": "powiat-swidnicki-dolnoslaskie",
  "woj": "dolnośląskie",
  "wojSlug": "dolnoslaskie",
  "wojLoc": "dolnośląskim",
  "count": 2,
  "idx": [
   37,
   475
  ]
 },
 {
  "name": "powiat bialski",
  "slug": "powiat-bialski",
  "woj": "lubelskie",
  "wojSlug": "lubelskie",
  "wojLoc": "lubelskim",
  "count": 2,
  "idx": [
   78,
   57
  ]
 },
 {
  "name": "powiat lubelski",
  "slug": "powiat-lubelski",
  "woj": "lubelskie",
  "wojSlug": "lubelskie",
  "wojLoc": "lubelskim",
  "count": 2,
  "idx": [
   76,
   68
  ]
 },
 {
  "name": "powiat gorzowski",
  "slug": "powiat-gorzowski",
  "woj": "lubuskie",
  "wojSlug": "lubuskie",
  "wojLoc": "lubuskim",
  "count": 2,
  "idx": [
   86,
   89
  ]
 },
 {
  "name": "powiat legionowski",
  "slug": "powiat-legionowski",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 2,
  "idx": [
   141,
   120
  ]
 },
 {
  "name": "powiat radomski",
  "slug": "powiat-radomski",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 2,
  "idx": [
   130,
   170
  ]
 },
 {
  "name": "powiat warszawski zachodni",
  "slug": "powiat-warszawski-zachodni",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 2,
  "idx": [
   104,
   157
  ]
 },
 {
  "name": "powiat wołomiński",
  "slug": "powiat-wolominski",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 2,
  "idx": [
   127,
   193
  ]
 },
 {
  "name": "powiat łosicki",
  "slug": "powiat-losicki",
  "woj": "mazowieckie",
  "wojSlug": "mazowieckie",
  "wojLoc": "mazowieckim",
  "count": 2,
  "idx": [
   105,
   106
  ]
 },
 {
  "name": "powiat chrzanowski",
  "slug": "powiat-chrzanowski",
  "woj": "małopolskie",
  "wojSlug": "malopolskie",
  "wojLoc": "małopolskim",
  "count": 2,
  "idx": [
   217,
   206
  ]
 },
 {
  "name": "powiat krakowski",
  "slug": "powiat-krakowski",
  "woj": "małopolskie",
  "wojSlug": "malopolskie",
  "wojLoc": "małopolskim",
  "count": 2,
  "idx": [
   214,
   215
  ]
 },
 {
  "name": "powiat białostocki",
  "slug": "powiat-bialostocki",
  "woj": "podlaskie",
  "wojSlug": "podlaskie",
  "wojLoc": "podlaskim",
  "count": 2,
  "idx": [
   480,
   258
  ]
 },
 {
  "name": "powiat kartuski",
  "slug": "powiat-kartuski",
  "woj": "pomorskie",
  "wojSlug": "pomorskie",
  "wojLoc": "pomorskim",
  "count": 2,
  "idx": [
   278,
   273
  ]
 },
 {
  "name": "powiat pucki",
  "slug": "powiat-pucki",
  "woj": "pomorskie",
  "wojSlug": "pomorskie",
  "wojLoc": "pomorskim",
  "count": 2,
  "idx": [
   279,
   272
  ]
 },
 {
  "name": "powiat słupski",
  "slug": "powiat-slupski",
  "woj": "pomorskie",
  "wojSlug": "pomorskie",
  "wojLoc": "pomorskim",
  "count": 2,
  "idx": [
   275,
   262
  ]
 },
 {
  "name": "powiat wejherowski",
  "slug": "powiat-wejherowski",
  "woj": "pomorskie",
  "wojSlug": "pomorskie",
  "wojLoc": "pomorskim",
  "count": 2,
  "idx": [
   283,
   284
  ]
 },
 {
  "name": "powiat olsztyński",
  "slug": "powiat-olsztynski",
  "woj": "warmińsko-mazurskie",
  "wojSlug": "warminsko-mazurskie",
  "wojLoc": "warmińsko-mazurskim",
  "count": 2,
  "idx": [
   488,
   285
  ]
 },
 {
  "name": "powiat czarnkowsko-trzcianecki",
  "slug": "powiat-czarnkowsko-trzcianecki",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   368,
   356
  ]
 },
 {
  "name": "powiat gostyński",
  "slug": "powiat-gostynski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   303,
   313
  ]
 },
 {
  "name": "powiat kościański",
  "slug": "powiat-koscianski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   299,
   315
  ]
 },
 {
  "name": "powiat nowotomyski",
  "slug": "powiat-nowotomyski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   337,
   309
  ]
 },
 {
  "name": "powiat pleszewski",
  "slug": "powiat-pleszewski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   334,
   318
  ]
 },
 {
  "name": "powiat wolsztyński",
  "slug": "powiat-wolsztynski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   305,
   297
  ]
 },
 {
  "name": "powiat wągrowiecki",
  "slug": "powiat-wagrowiecki",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   333,
   294
  ]
 },
 {
  "name": "powiat śremski",
  "slug": "powiat-sremski",
  "woj": "wielkopolskie",
  "wojSlug": "wielkopolskie",
  "wojLoc": "wielkopolskim",
  "count": 2,
  "idx": [
   366,
   301
  ]
 },
 {
  "name": "powiat kołobrzeski",
  "slug": "powiat-kolobrzeski",
  "woj": "zachodniopomorskie",
  "wojSlug": "zachodniopomorskie",
  "wojLoc": "zachodniopomorskim",
  "count": 2,
  "idx": [
   379,
   377
  ]
 },
 {
  "name": "powiat zduńskowolski",
  "slug": "powiat-zdunskowolski",
  "woj": "łódzkie",
  "wojSlug": "lodzkie",
  "wojLoc": "łódzkim",
  "count": 2,
  "idx": [
   415,
   414
  ]
 },
 {
  "name": "powiat gliwicki",
  "slug": "powiat-gliwicki",
  "woj": "śląskie",
  "wojSlug": "slaskie",
  "wojLoc": "śląskim",
  "count": 2,
  "idx": [
   435,
   429
  ]
 }
];

export const RANKING_PL = [266, 267, 393, 264, 347, 265, 422, 278, 184, 238, 185, 175, 457, 263, 470, 239, 107, 456, 459, 84, 105, 106, 268, 214, 34, 299, 127, 182, 91, 246, 203, 183, 230, 270, 460, 425, 277, 282, 289, 481];

export default REGIONY;
